import { messagesFixture } from "../../../../tests/fixtures/messages.fixture";

export const globalApiMock = {
  layers: [
    {
      layerId: 1,
      layerName: "א'",
    },
    {
      layerId: 2,
      layerName: "ב'",
    },
    {
      layerId: 3,
      layerName: "ג'",
    },
    {
      layerId: 4,
      layerName: "ד'",
    },
    {
      layerId: 5,
      layerName: "ה'",
    },
    {
      layerId: 6,
      layerName: "ו'",
    },
    {
      layerId: 7,
      layerName: "ז'",
    },
    {
      layerId: 8,
      layerName: "ח'",
    },
    {
      layerId: 9,
      layerName: "ט'",
    },
    {
      layerId: 10,
      layerName: "י'",
    },
    {
      layerId: 11,
      layerName: 'י"א',
    },
    {
      layerId: 12,
      layerName: 'י"ב',
    },
    {
      layerId: 13,
      layerName: 'י"ג',
    },
    {
      layerId: 14,
      layerName: 'י"ד',
    },
    {
      layerId: 15,
      layerName: "מבוגרים",
    },
  ],
  countries: [
    {
      id: 88,
      name: "ישראל",
      sortOrder: 1,
    },
    {
      id: 1,
      name: "אוגנדה",
      sortOrder: 2,
    },
    {
      id: 2,
      name: "אוזבקיסטן",
      sortOrder: 3,
    },
    {
      id: 3,
      name: "אוסטריה",
      sortOrder: 4,
    },
    {
      id: 4,
      name: "אוסטרליה",
      sortOrder: 5,
    },
    {
      id: 5,
      name: "אוקראינה",
      sortOrder: 6,
    },
    {
      id: 6,
      name: "אורוגוואי",
      sortOrder: 7,
    },
    {
      id: 7,
      name: "אזרבייג'ן",
      sortOrder: 8,
    },
    {
      id: 8,
      name: "איטליה",
      sortOrder: 9,
    },
    {
      id: 9,
      name: "איי מרשל",
      sortOrder: 10,
    },
    {
      id: 10,
      name: "איי סיישל",
      sortOrder: 11,
    },
    {
      id: 11,
      name: "איי שלמה",
      sortOrder: 12,
    },
    {
      id: 12,
      name: "אינדונזיה",
      sortOrder: 13,
    },
    {
      id: 13,
      name: "איסלנד",
      sortOrder: 14,
    },
    {
      id: 14,
      name: "איראן",
      sortOrder: 15,
    },
    {
      id: 15,
      name: "אירלנד",
      sortOrder: 16,
    },
    {
      id: 16,
      name: "אל סלוודור",
      sortOrder: 17,
    },
    {
      id: 17,
      name: "אלבניה",
      sortOrder: 18,
    },
    {
      id: 18,
      name: "אלג'יריה",
      sortOrder: 19,
    },
    {
      id: 19,
      name: "אנגולה",
      sortOrder: 20,
    },
    {
      id: 20,
      name: "אנדורה",
      sortOrder: 21,
    },
    {
      id: 21,
      name: "אנטיגואה וברבודה",
      sortOrder: 22,
    },
    {
      id: 22,
      name: "אסטוניה",
      sortOrder: 23,
    },
    {
      id: 23,
      name: "אפגניסטן",
      sortOrder: 24,
    },
    {
      id: 24,
      name: "אקוודור",
      sortOrder: 25,
    },
    {
      id: 25,
      name: "ארגנטינה",
      sortOrder: 26,
    },
    {
      id: 26,
      name: "אריתריאה",
      sortOrder: 27,
    },
    {
      id: 27,
      name: "ארמניה",
      sortOrder: 28,
    },
    {
      id: 28,
      name: "ארצות הברית",
      sortOrder: 29,
    },
    {
      id: 29,
      name: "אתיופיה",
      sortOrder: 30,
    },
    {
      id: 30,
      name: "איי בהאמה",
      sortOrder: 31,
    },
    {
      id: 31,
      name: "בהוטן",
      sortOrder: 32,
    },
    {
      id: 32,
      name: "בוטסואנה",
      sortOrder: 33,
    },
    {
      id: 33,
      name: "בולגריה",
      sortOrder: 34,
    },
    {
      id: 34,
      name: "בוליביה",
      sortOrder: 35,
    },
    {
      id: 35,
      name: "בוסניה והרצגובינה",
      sortOrder: 36,
    },
    {
      id: 36,
      name: "בורונדי",
      sortOrder: 37,
    },
    {
      id: 37,
      name: "בורקינה פאסו",
      sortOrder: 38,
    },
    {
      id: 38,
      name: "בחריין",
      sortOrder: 39,
    },
    {
      id: 39,
      name: "בלגיה",
      sortOrder: 40,
    },
    {
      id: 40,
      name: "בליז",
      sortOrder: 41,
    },
    {
      id: 41,
      name: "בלארוס",
      sortOrder: 42,
    },
    {
      id: 42,
      name: "בנגלדש",
      sortOrder: 43,
    },
    {
      id: 43,
      name: "בנין",
      sortOrder: 44,
    },
    {
      id: 44,
      name: "ברבדוס",
      sortOrder: 45,
    },
    {
      id: 45,
      name: "ברוניי",
      sortOrder: 46,
    },
    {
      id: 46,
      name: "ברזיל",
      sortOrder: 47,
    },
    {
      id: 47,
      name: "גאורגיה",
      sortOrder: 48,
    },
    {
      id: 48,
      name: "גאנה",
      sortOrder: 49,
    },
    {
      id: 49,
      name: "גבון",
      sortOrder: 50,
    },
    {
      id: 50,
      name: "גואטמלה",
      sortOrder: 51,
    },
    {
      id: 51,
      name: "גיאנה",
      sortOrder: 52,
    },
    {
      id: 52,
      name: "ג'יבוטי",
      sortOrder: 53,
    },
    {
      id: 53,
      name: "גינאה",
      sortOrder: 54,
    },
    {
      id: 54,
      name: "גינאה ביסאו",
      sortOrder: 55,
    },
    {
      id: 55,
      name: "גינאה המשוונית",
      sortOrder: 56,
    },
    {
      id: 56,
      name: "גמביה",
      sortOrder: 57,
    },
    {
      id: 57,
      name: "ג'מייקה",
      sortOrder: 58,
    },
    {
      id: 58,
      name: "גרמניה",
      sortOrder: 59,
    },
    {
      id: 59,
      name: "גרנדה",
      sortOrder: 60,
    },
    {
      id: 60,
      name: "דומיניקה",
      sortOrder: 61,
    },
    {
      id: 61,
      name: "דנמרק",
      sortOrder: 62,
    },
    {
      id: 62,
      name: "דרום אפריקה",
      sortOrder: 63,
    },
    {
      id: 63,
      name: "דרום סודאן",
      sortOrder: 64,
    },
    {
      id: 64,
      name: "האיטי",
      sortOrder: 65,
    },
    {
      id: 65,
      name: "איחוד האמירויות הערביות",
      sortOrder: 66,
    },
    {
      id: 66,
      name: "הודו",
      sortOrder: 67,
    },
    {
      id: 67,
      name: "הולנד",
      sortOrder: 68,
    },
    {
      id: 68,
      name: "הונגריה",
      sortOrder: 69,
    },
    {
      id: 69,
      name: "הונדורס",
      sortOrder: 70,
    },
    {
      id: 70,
      name: "הממלכה המאוחדת",
      sortOrder: 71,
    },
    {
      id: 71,
      name: "וייטנאם",
      sortOrder: 72,
    },
    {
      id: 72,
      name: "ונואטו",
      sortOrder: 73,
    },
    {
      id: 73,
      name: "ונצואלה",
      sortOrder: 74,
    },
    {
      id: 74,
      name: "זימבבואה",
      sortOrder: 75,
    },
    {
      id: 75,
      name: "זמביה",
      sortOrder: 76,
    },
    {
      id: 76,
      name: "חוף השנהב",
      sortOrder: 77,
    },
    {
      id: 77,
      name: "טג'יקיסטן",
      sortOrder: 78,
    },
    {
      id: 78,
      name: "טובאלו",
      sortOrder: 79,
    },
    {
      id: 79,
      name: "טוגו",
      sortOrder: 80,
    },
    {
      id: 80,
      name: "טונגה",
      sortOrder: 81,
    },
    {
      id: 81,
      name: "טורקיה",
      sortOrder: 82,
    },
    {
      id: 82,
      name: "טורקמניסטן",
      sortOrder: 83,
    },
    {
      id: 83,
      name: "טנזניה",
      sortOrder: 84,
    },
    {
      id: 84,
      name: "טרינידד וטובגו",
      sortOrder: 85,
    },
    {
      id: 85,
      name: "יוון",
      sortOrder: 86,
    },
    {
      id: 86,
      name: "יפן",
      sortOrder: 87,
    },
    {
      id: 87,
      name: "ירדן",
      sortOrder: 88,
    },
    {
      id: 89,
      name: "כווית",
      sortOrder: 90,
    },
    {
      id: 90,
      name: "כף ורדה",
      sortOrder: 91,
    },
    {
      id: 91,
      name: "לאוס",
      sortOrder: 92,
    },
    {
      id: 92,
      name: "לבנון",
      sortOrder: 93,
    },
    {
      id: 93,
      name: "לוב",
      sortOrder: 94,
    },
    {
      id: 94,
      name: "לוקסמבורג",
      sortOrder: 95,
    },
    {
      id: 95,
      name: "לטביה",
      sortOrder: 96,
    },
    {
      id: 96,
      name: "ליבריה",
      sortOrder: 97,
    },
    {
      id: 97,
      name: "ליטא",
      sortOrder: 98,
    },
    {
      id: 98,
      name: "ליכטנשטיין",
      sortOrder: 99,
    },
    {
      id: 99,
      name: "לסוטו",
      sortOrder: 100,
    },
    {
      id: 100,
      name: "מאוריטניה",
      sortOrder: 101,
    },
    {
      id: 101,
      name: "מאוריציוס",
      sortOrder: 102,
    },
    {
      id: 102,
      name: "מאלי",
      sortOrder: 103,
    },
    {
      id: 103,
      name: "מדגסקר",
      sortOrder: 104,
    },
    {
      id: 104,
      name: "מוזמביק",
      sortOrder: 105,
    },
    {
      id: 105,
      name: "מולדובה",
      sortOrder: 106,
    },
    {
      id: 106,
      name: "מונגוליה",
      sortOrder: 107,
    },
    {
      id: 107,
      name: "מונטנגרו",
      sortOrder: 108,
    },
    {
      id: 108,
      name: "מונקו",
      sortOrder: 109,
    },
    {
      id: 109,
      name: "מזרח טימור",
      sortOrder: 110,
    },
    {
      id: 110,
      name: "מיאנמר",
      sortOrder: 111,
    },
    {
      id: 111,
      name: "מיקרונזיה",
      sortOrder: 112,
    },
    {
      id: 112,
      name: "מלאווי",
      sortOrder: 113,
    },
    {
      id: 113,
      name: "האיים המלדיביים",
      sortOrder: 114,
    },
    {
      id: 114,
      name: "מלזיה",
      sortOrder: 115,
    },
    {
      id: 115,
      name: "מלטה",
      sortOrder: 116,
    },
    {
      id: 116,
      name: "מצרים",
      sortOrder: 117,
    },
    {
      id: 117,
      name: "מקדוניה",
      sortOrder: 118,
    },
    {
      id: 118,
      name: "מקסיקו",
      sortOrder: 119,
    },
    {
      id: 119,
      name: "מרוקו",
      sortOrder: 120,
    },
    {
      id: 120,
      name: "נאורו",
      sortOrder: 121,
    },
    {
      id: 121,
      name: "נורווגיה",
      sortOrder: 122,
    },
    {
      id: 122,
      name: "ניגריה",
      sortOrder: 123,
    },
    {
      id: 123,
      name: "ניו זילנד",
      sortOrder: 124,
    },
    {
      id: 124,
      name: "ניז'ר",
      sortOrder: 125,
    },
    {
      id: 125,
      name: "ניקרגואה",
      sortOrder: 126,
    },
    {
      id: 126,
      name: "נמיביה",
      sortOrder: 127,
    },
    {
      id: 127,
      name: "נפאל",
      sortOrder: 128,
    },
    {
      id: 128,
      name: "סאו טומה ופרינסיפה",
      sortOrder: 129,
    },
    {
      id: 129,
      name: "סודאן",
      sortOrder: 130,
    },
    {
      id: 130,
      name: "סווזילנד",
      sortOrder: 131,
    },
    {
      id: 131,
      name: "סומליה",
      sortOrder: 132,
    },
    {
      id: 132,
      name: "סוריה",
      sortOrder: 133,
    },
    {
      id: 133,
      name: "סורינאם",
      sortOrder: 134,
    },
    {
      id: 134,
      name: "סיירה לאון",
      sortOrder: 135,
    },
    {
      id: 135,
      name: "סין",
      sortOrder: 136,
    },
    {
      id: 136,
      name: "סינגפור",
      sortOrder: 137,
    },
    {
      id: 137,
      name: "סלובניה",
      sortOrder: 138,
    },
    {
      id: 138,
      name: "סלובקיה",
      sortOrder: 139,
    },
    {
      id: 139,
      name: "סמואה",
      sortOrder: 140,
    },
    {
      id: 140,
      name: "סן מרינו",
      sortOrder: 141,
    },
    {
      id: 141,
      name: "סנגל",
      sortOrder: 142,
    },
    {
      id: 142,
      name: "סנט וינסנט והגרנדינים",
      sortOrder: 143,
    },
    {
      id: 143,
      name: "סנט לוסיה",
      sortOrder: 144,
    },
    {
      id: 144,
      name: "סנט קיטס ונוויס",
      sortOrder: 145,
    },
    {
      id: 145,
      name: "ספרד",
      sortOrder: 146,
    },
    {
      id: 146,
      name: "סרביה",
      sortOrder: 147,
    },
    {
      id: 147,
      name: "סרי לנקה",
      sortOrder: 148,
    },
    {
      id: 148,
      name: "עומאן",
      sortOrder: 149,
    },
    {
      id: 149,
      name: "עיראק",
      sortOrder: 150,
    },
    {
      id: 150,
      name: "ערב הסעודית",
      sortOrder: 151,
    },
    {
      id: 151,
      name: "פולין",
      sortOrder: 152,
    },
    {
      id: 152,
      name: "פורטוגל",
      sortOrder: 153,
    },
    {
      id: 153,
      name: "איי פיג'י",
      sortOrder: 154,
    },
    {
      id: 154,
      name: "הפיליפינים",
      sortOrder: 155,
    },
    {
      id: 155,
      name: "פינלנד",
      sortOrder: 156,
    },
    {
      id: 156,
      name: "פלאו",
      sortOrder: 157,
    },
    {
      id: 157,
      name: "פנמה",
      sortOrder: 158,
    },
    {
      id: 158,
      name: "פפואה גינאה החדשה",
      sortOrder: 159,
    },
    {
      id: 159,
      name: "פקיסטן",
      sortOrder: 160,
    },
    {
      id: 160,
      name: "פרגוואי",
      sortOrder: 161,
    },
    {
      id: 161,
      name: "פרו",
      sortOrder: 162,
    },
    {
      id: 162,
      name: "צ'אד",
      sortOrder: 163,
    },
    {
      id: 163,
      name: "צ'ילה",
      sortOrder: 164,
    },
    {
      id: 164,
      name: "צ'כיה",
      sortOrder: 165,
    },
    {
      id: 165,
      name: "צרפת",
      sortOrder: 166,
    },
    {
      id: 166,
      name: "קובה",
      sortOrder: 167,
    },
    {
      id: 167,
      name: "קולומביה",
      sortOrder: 168,
    },
    {
      id: 168,
      name: "איי קומורו",
      sortOrder: 169,
    },
    {
      id: 169,
      name: "הרפובליקה הדמוקרטית של קונגו (זאיר)",
      sortOrder: 170,
    },
    {
      id: 170,
      name: "רפובליקת קונגו",
      sortOrder: 171,
    },
    {
      id: 171,
      name: "קוסטה ריקה",
      sortOrder: 172,
    },
    {
      id: 172,
      name: "קוריאה הדרומית",
      sortOrder: 173,
    },
    {
      id: 173,
      name: "קוריאה הצפונית",
      sortOrder: 174,
    },
    {
      id: 174,
      name: "קזחסטן",
      sortOrder: 175,
    },
    {
      id: 175,
      name: "קטר",
      sortOrder: 176,
    },
    {
      id: 176,
      name: "קירגיזסטן",
      sortOrder: 177,
    },
    {
      id: 177,
      name: "קיריבטי",
      sortOrder: 178,
    },
    {
      id: 178,
      name: "קמבודיה",
      sortOrder: 179,
    },
    {
      id: 179,
      name: "קמרון",
      sortOrder: 180,
    },
    {
      id: 180,
      name: "קנדה",
      sortOrder: 181,
    },
    {
      id: 181,
      name: "קניה",
      sortOrder: 182,
    },
    {
      id: 182,
      name: "קפריסין",
      sortOrder: 183,
    },
    {
      id: 183,
      name: "קרואטיה",
      sortOrder: 184,
    },
    {
      id: 184,
      name: "קריית הוותיקן",
      sortOrder: 185,
    },
    {
      id: 185,
      name: "רואנדה",
      sortOrder: 186,
    },
    {
      id: 186,
      name: "רומניה",
      sortOrder: 187,
    },
    {
      id: 187,
      name: "רוסיה",
      sortOrder: 188,
    },
    {
      id: 188,
      name: "הרפובליקה הדומיניקנית",
      sortOrder: 189,
    },
    {
      id: 189,
      name: "הרפובליקה המרכז אפריקאית",
      sortOrder: 190,
    },
    {
      id: 190,
      name: "שוודיה",
      sortOrder: 191,
    },
    {
      id: 191,
      name: "שווייץ",
      sortOrder: 192,
    },
    {
      id: 192,
      name: "תאילנד",
      sortOrder: 193,
    },
    {
      id: 193,
      name: "תוניסיה",
      sortOrder: 194,
    },
    {
      id: 194,
      name: "תימן",
      sortOrder: 195,
    },
    {
      id: 195,
      name: "אחר",
      sortOrder: 196,
    },
  ],
  circles: [
    {
      circleId: 1600,
      name: "הקהילה היהודית",
      code: "1",
    },
    {
      circleId: 1601,
      name: "הקנים הערביים",
      code: "2",
    },
    {
      circleId: 1602,
      name: "בני המושבים",
      code: "3",
    },
  ],
  counties: [
    {
      countyId: 0,
      name: "ALL",
      code: "0",
      parent: 0,
    },
    {
      countyId: 1200,
      name: "מחוז עמקים",
      code: "1",
      parent: 1600,
    },
    {
      countyId: 1201,
      name: "מחוז חיפה",
      code: "2",
      parent: 1600,
    },
    {
      countyId: 1202,
      name: "מחוז חוף",
      code: "3",
      parent: 1600,
    },
    {
      countyId: 1203,
      name: "מחוז שרון",
      code: "4",
      parent: 1600,
    },
    {
      countyId: 1204,
      name: "מחוז דרום",
      code: "5",
      parent: 1600,
    },
    {
      countyId: 1205,
      name: "מחוז ירושלים",
      code: "6",
      parent: 1600,
    },
    {
      countyId: 1206,
      name: "מחוז נגב",
      code: "7",
      parent: 1600,
    },
    {
      countyId: 1450,
      name: "מעגל הקנים הדרוזים",
      code: "1",
      parent: 1800,
    },
    {
      countyId: 1500,
      name: "מחוז גליל",
      code: "9",
      parent: 1600,
    },
    {
      countyId: 1607,
      name: "קיום משותף גליל",
      code: "1",
      parent: 1851,
    },
    {
      countyId: 1608,
      name: "קיום משותף ערים מעורבות",
      code: "2",
      parent: 1851,
    },
    {
      countyId: 1609,
      name: "קיום משותף נגב",
      code: "3",
      parent: 1851,
    },
    {
      countyId: 1650,
      name: "שכבות יא-יב",
      code: "8",
      parent: 1600,
    },
    {
      countyId: 1651,
      name: "קנים ערבים צפון",
      code: "1",
      parent: 1900,
    },
    {
      countyId: 1652,
      name: "קנים ערבים מרכז",
      code: "2",
      parent: 1900,
    },
    {
      countyId: 1653,
      name: "קנים ערבים דרום",
      code: "3",
      parent: 1900,
    },
    {
      countyId: 1700,
      name: "מחוז איילון",
      code: "A",
      parent: 1600,
    },
    {
      countyId: 1701,
      name: "מחוז חולות",
      code: "B",
      parent: 1600,
    },
    {
      countyId: 1702,
      name: "מחוז ירקון",
      code: "C",
      parent: 1600,
    },
    {
      countyId: 2001,
      name: "בני המושבים מחוז מרכז ב",
      code: "w",
      parent: 2001,
    },
    {
      countyId: 2002,
      name: "בני המושבים ארצי",
      code: "Z",
      parent: 2001,
    },
    {
      countyId: 2050,
      name: "האיגוד המקצועי",
      code: "9",
      parent: 1650,
    },
    {
      countyId: 2100,
      name: "כלל תנועתי",
      code: "9",
      parent: 2050,
    },
    {
      countyId: 2101,
      name: "נוער תלם",
      code: "4",
      parent: 2051,
    },
    {
      countyId: 2102,
      name: "מ.א. עמק הירדן",
      code: "K",
      parent: 1600,
    },
    {
      countyId: 2103,
      name: "מ.א. משגב",
      code: "L",
      parent: 1600,
    },
    {
      countyId: 2104,
      name: "בני המושבים - מא מטה אשר",
      code: "2",
      parent: 2001,
    },
    {
      countyId: 2105,
      name: "מ.א. גליל עליון",
      code: "N",
      parent: 1600,
    },
    {
      countyId: 2106,
      name: "מ.א. מרום גליל",
      code: "O",
      parent: 1600,
    },
    {
      countyId: 2107,
      name: "מ.א. גזר",
      code: "P",
      parent: 1600,
    },
    {
      countyId: 2108,
      name: "מ.א. מטה יהודה",
      code: "Q",
      parent: 1600,
    },
    {
      countyId: 2109,
      name: "מ.א. מגילות",
      code: "R",
      parent: 1600,
    },
    {
      countyId: 2110,
      name: "מ.א. שער הנגב",
      code: "S",
      parent: 1600,
    },
    {
      countyId: 2111,
      name: "מ.א. אשכול",
      code: "T",
      parent: 1600,
    },
    {
      countyId: 2200,
      name: "מעגלי החיים הבוגרים",
      code: "7",
      parent: 2050,
    },
    {
      countyId: 2300,
      name: "קנים ערבים מחוז חיפה",
      code: "4",
      parent: 1900,
    },
    {
      countyId: 2301,
      name: "בני המושבים - מא גולן",
      code: "1",
      parent: 2001,
    },
    {
      countyId: 2303,
      name: "בני המושבים - מא גליל תחתון",
      code: "3",
      parent: 2001,
    },
    {
      countyId: 2304,
      name: "בני המושבים - מא עמק המעיינות",
      code: "4",
      parent: 2001,
    },
    {
      countyId: 2305,
      name: "בני המושבים - מועצות מקומיות צפון",
      code: "5",
      parent: 2001,
    },
    {
      countyId: 2306,
      name: "בני המושבים - מא הגלבוע",
      code: "6",
      parent: 2001,
    },
    {
      countyId: 2307,
      name: "בני המושבים - מא חוף הכרמל",
      code: "7",
      parent: 2001,
    },
    {
      countyId: 2308,
      name: "בני המושבים - מא מבואות החרמון",
      code: "8",
      parent: 2001,
    },
    {
      countyId: 2309,
      name: "בני המושבים - מא מנשה",
      code: "9",
      parent: 2001,
    },
    {
      countyId: 2310,
      name: "בני המושבים - מא עמק יזרעאל",
      code: "A",
      parent: 2001,
    },
    {
      countyId: 2311,
      name: "בני המושבים - מא מעלה יוסף",
      code: "B",
      parent: 2001,
    },
    {
      countyId: 2312,
      name: "בני המושבים - מא עמק חפר",
      code: "C",
      parent: 2001,
    },
    {
      countyId: 2313,
      name: "בני המושבים - מא לב השרון",
      code: "D",
      parent: 2001,
    },
    {
      countyId: 2314,
      name: "בני המושבים - מא אלונה",
      code: "E",
      parent: 2001,
    },
    {
      countyId: 2315,
      name: "בני המושבים - מא מטה יהודה",
      code: "F",
      parent: 2001,
    },
    {
      countyId: 2316,
      name: "בני המושבים - מועצות מקומיות מרכז",
      code: "G",
      parent: 2001,
    },
    {
      countyId: 2317,
      name: "בני המושבים - מא ערבות הירדן",
      code: "H",
      parent: 2001,
    },
    {
      countyId: 2318,
      name: "בני המושבים - מא רמת הנגב",
      code: "I",
      parent: 2001,
    },
    {
      countyId: 2319,
      name: "בני המושבים - מא דרום השרון",
      code: "J",
      parent: 2001,
    },
    {
      countyId: 2320,
      name: "בני המושבים - מא שדות דן",
      code: "K",
      parent: 2001,
    },
    {
      countyId: 2321,
      name: "בני המושבים - מא חבל מודיעין",
      code: "L",
      parent: 2001,
    },
    {
      countyId: 2322,
      name: "בני המושבים - מא באר טוביה",
      code: "M",
      parent: 2001,
    },
    {
      countyId: 2323,
      name: "בני המושבים - מא ברנר",
      code: "N",
      parent: 2001,
    },
    {
      countyId: 2324,
      name: "בני המושבים - מא גזר",
      code: "O",
      parent: 2001,
    },
    {
      countyId: 2325,
      name: "בני המושבים - מא בני שמעון",
      code: "P",
      parent: 2001,
    },
    {
      countyId: 2326,
      name: "בני המושבים - מא חוף אשקלון",
      code: "Q",
      parent: 2001,
    },
    {
      countyId: 2327,
      name: "בני המושבים - מא הערבה התיכונה",
      code: "R",
      parent: 2001,
    },
    {
      countyId: 2328,
      name: "בני המושבים - מא לכיש",
      code: "S",
      parent: 2001,
    },
    {
      countyId: 2329,
      name: "בני המושבים - מא אשכול",
      code: "T",
      parent: 2001,
    },
  ],
  nests: [
    {
      nestId: 0,
      name: "ALL",
      code: "0",
      parent: 0,
    },
    {
      nestId: 650,
      name: "קרית טבעון",
      code: "14",
      parent: 1200,
    },
    {
      nestId: 651,
      name: "רמתיים",
      code: "17",
      parent: 1203,
    },
    {
      nestId: 652,
      name: "מעלה אדומים",
      code: "07",
      parent: 1205,
    },
    {
      nestId: 653,
      name: "הגבעה הצרפתית",
      code: "10",
      parent: 1205,
    },
    {
      nestId: 654,
      name: "קרית יובל",
      code: "20",
      parent: 1205,
    },
    {
      nestId: 656,
      name: "מודיעין הנחלים",
      code: "04",
      parent: 1205,
    },
    {
      nestId: 657,
      name: "שהם",
      code: "04",
      parent: 1702,
    },
    {
      nestId: 658,
      name: "בית שמש",
      code: "06",
      parent: 1205,
    },
    {
      nestId: 659,
      name: "פסגת זאב",
      code: "08",
      parent: 1205,
    },
    {
      nestId: 660,
      name: "הר חומה",
      code: "21",
      parent: 1205,
    },
    {
      nestId: 661,
      name: "פרדסיה",
      code: "15",
      parent: 1203,
    },
    {
      nestId: 663,
      name: 'כפ"ס ישן',
      code: "11",
      parent: 1203,
    },
    {
      nestId: 664,
      name: 'כפ"ס חדש',
      code: "10",
      parent: 1203,
    },
    {
      nestId: 665,
      name: "הנשיאים",
      code: "42",
      parent: 1203,
    },
    {
      nestId: 666,
      name: "הדר גנים",
      code: "01",
      parent: 1702,
    },
    {
      nestId: 667,
      name: "ראש העין",
      code: "03",
      parent: 1702,
    },
    {
      nestId: 669,
      name: "קרית אונו צפון",
      code: "03",
      parent: 1700,
    },
    {
      nestId: 670,
      name: "כרמל צרפתי",
      code: "10",
      parent: 1201,
    },
    {
      nestId: 671,
      name: "נווה שאנן",
      code: "12",
      parent: 1201,
    },
    {
      nestId: 672,
      name: "הדר",
      code: "94",
      parent: 1201,
    },
    {
      nestId: 673,
      name: "קרית חיים",
      code: "13",
      parent: 1201,
    },
    {
      nestId: 674,
      name: "קרית ים",
      code: "14",
      parent: 1201,
    },
    {
      nestId: 675,
      name: "עכו",
      code: "49",
      parent: 1500,
    },
    {
      nestId: 676,
      name: "נהריה צפון",
      code: "15",
      parent: 1500,
    },
    {
      nestId: 677,
      name: "כרמיאל - רבין",
      code: "03",
      parent: 1500,
    },
    {
      nestId: 679,
      name: "זכרון יעקב",
      code: "04",
      parent: 1202,
    },
    {
      nestId: 681,
      name: "בנימינה",
      code: "05",
      parent: 1202,
    },
    {
      nestId: 682,
      name: "פרדס חנה-כרכור",
      code: "25",
      parent: 1202,
    },
    {
      nestId: 683,
      name: "חדרה - בית אליעזר",
      code: "21",
      parent: 1202,
    },
    {
      nestId: 684,
      name: "נתניה מזרח",
      code: "09",
      parent: 1202,
    },
    {
      nestId: 685,
      name: "קרית נורדאו",
      code: "34",
      parent: 1202,
    },
    {
      nestId: 686,
      name: "הרצליה",
      code: "51",
      parent: 1203,
    },
    {
      nestId: 687,
      name: "לב העיר",
      code: "06",
      parent: 1700,
    },
    {
      nestId: 688,
      name: "כפר שלם",
      code: "02",
      parent: 1700,
    },
    {
      nestId: 689,
      name: "בורוכוב",
      code: "01",
      parent: 1700,
    },
    {
      nestId: 691,
      name: "מיתר",
      code: "17",
      parent: 1206,
    },
    {
      nestId: 700,
      name: "חולון",
      code: "02",
      parent: 1701,
    },
    {
      nestId: 701,
      name: "יבנה",
      code: "13",
      parent: 1204,
    },
    {
      nestId: 703,
      name: "רמז - ראשון לציון",
      code: "07",
      parent: 1701,
    },
    {
      nestId: 705,
      name: "גן יבנה",
      code: "20",
      parent: 1204,
    },
    {
      nestId: 706,
      name: "נס ציונה",
      code: "04",
      parent: 1701,
    },
    {
      nestId: 707,
      name: "רמלה אפקה",
      code: "05",
      parent: 1702,
    },
    {
      nestId: 708,
      name: "לוד גני אביב",
      code: "06",
      parent: 1702,
    },
    {
      nestId: 709,
      name: "קרית גנים - המרחב - ראשון לציון",
      code: "05",
      parent: 1701,
    },
    {
      nestId: 710,
      name: "חבצלת והחדשה",
      code: "31",
      parent: 1204,
    },
    {
      nestId: 711,
      name: "מזכרת בתיה",
      code: "32",
      parent: 1204,
    },
    {
      nestId: 712,
      name: "רחובות ההולנדית",
      code: "34",
      parent: 1204,
    },
    {
      nestId: 713,
      name: "תל גיבורים",
      code: "10",
      parent: 1701,
    },
    {
      nestId: 714,
      name: "ראשון מזרח",
      code: "06",
      parent: 1701,
    },
    {
      nestId: 715,
      name: "קרית עקרון",
      code: "42",
      parent: 1204,
    },
    {
      nestId: 719,
      name: "מצפה רמון",
      code: "01",
      parent: 1206,
    },
    {
      nestId: 721,
      name: "ערד",
      code: "11",
      parent: 1206,
    },
    {
      nestId: 722,
      name: "נווה נוי",
      code: "12",
      parent: 1206,
    },
    {
      nestId: 723,
      name: "נווה זאב",
      code: "13",
      parent: 1206,
    },
    {
      nestId: 725,
      name: "שדרות",
      code: "20",
      parent: 1206,
    },
    {
      nestId: 726,
      name: "אופקים",
      code: "33",
      parent: 1206,
    },
    {
      nestId: 727,
      name: "אשדוד דרום",
      code: "51",
      parent: 1204,
    },
    {
      nestId: 729,
      name: "קן ט'",
      code: "46",
      parent: 1206,
    },
    {
      nestId: 734,
      name: "מרכז ט'",
      code: "47",
      parent: 1206,
    },
    {
      nestId: 750,
      name: "ראש פינה",
      code: "04",
      parent: 1500,
    },
    {
      nestId: 801,
      name: "נווה יעקב",
      code: "70",
      parent: 1205,
    },
    {
      nestId: 802,
      name: "כפר תבור",
      code: "51",
      parent: 1200,
    },
    {
      nestId: 803,
      name: 'מ"א עמק הירדן',
      code: "99",
      parent: 2102,
    },
    {
      nestId: 804,
      name: "רמת ישי",
      code: "12",
      parent: 1200,
    },
    {
      nestId: 805,
      name: "מגדל העמק",
      code: "22",
      parent: 1200,
    },
    {
      nestId: 806,
      name: "נוף הגליל",
      code: "23",
      parent: 1200,
    },
    {
      nestId: 807,
      name: "קן עפולה",
      code: "24",
      parent: 1200,
    },
    {
      nestId: 808,
      name: "סניף קרית שמונה",
      code: "14",
      parent: 1500,
    },
    {
      nestId: 809,
      name: "טבריה",
      code: "32",
      parent: 1200,
    },
    {
      nestId: 810,
      name: "פרוד",
      code: "05",
      parent: 2106,
    },
    {
      nestId: 955,
      name: "קרית ביאליק הבונים",
      code: "01",
      parent: 1201,
    },
    {
      nestId: 1050,
      name: "ג'וליס",
      code: "10",
      parent: 1450,
    },
    {
      nestId: 1100,
      name: "בית ג'אן",
      code: "20",
      parent: 1450,
    },
    {
      nestId: 1101,
      name: "כסרא",
      code: "03",
      parent: 1450,
    },
    {
      nestId: 1102,
      name: "כפר סמיע",
      code: "12",
      parent: 1450,
    },
    {
      nestId: 1103,
      name: "מע'אר",
      code: "21",
      parent: 1450,
    },
    {
      nestId: 1104,
      name: "ינוח",
      code: "23",
      parent: 1450,
    },
    {
      nestId: 1105,
      name: "ג'ת",
      code: "15",
      parent: 1450,
    },
    {
      nestId: 1106,
      name: "חורפיש",
      code: "17",
      parent: 1450,
    },
    {
      nestId: 1107,
      name: "ירכא",
      code: "09",
      parent: 1450,
    },
    {
      nestId: 1108,
      name: "עוספיה",
      code: "14",
      parent: 1450,
    },
    {
      nestId: 1150,
      name: "קרית אתא",
      code: "50",
      parent: 1201,
    },
    {
      nestId: 1200,
      name: "קן יא באר שבע",
      code: "48",
      parent: 1206,
    },
    {
      nestId: 1201,
      name: "קן אשדוד ים",
      code: "53",
      parent: 1204,
    },
    {
      nestId: 1251,
      name: 'מ"א מרום גליל',
      code: "99",
      parent: 2106,
    },
    {
      nestId: 1257,
      name: "נס עמים",
      code: "50",
      parent: 2104,
    },
    {
      nestId: 1259,
      name: 'מ"א גזר',
      code: "99",
      parent: 2107,
    },
    {
      nestId: 1260,
      name: "נען",
      code: "02",
      parent: 2107,
    },
    {
      nestId: 1261,
      name: "נצר סרני",
      code: "01",
      parent: 2107,
    },
    {
      nestId: 1266,
      name: "ברור חיל",
      code: "01",
      parent: 2110,
    },
    {
      nestId: 1269,
      name: "רביבים",
      code: "12",
      parent: 2318,
    },
    {
      nestId: 1270,
      name: "יסוד המעלה",
      code: "01",
      parent: 1500,
    },
    {
      nestId: 1271,
      name: "פתח תקווה החורשה",
      code: "02",
      parent: 1702,
    },
    {
      nestId: 1301,
      name: "כמון",
      code: "11",
      parent: 2103,
    },
    {
      nestId: 1302,
      name: "הר חלוץ",
      code: "10",
      parent: 2103,
    },
    {
      nestId: 1303,
      name: "טל-אל",
      code: "08",
      parent: 2103,
    },
    {
      nestId: 1304,
      name: "שכורנית",
      code: "09",
      parent: 2103,
    },
    {
      nestId: 1305,
      name: "יובלים",
      code: "12",
      parent: 2103,
    },
    {
      nestId: 1307,
      name: "עצמון",
      code: "14",
      parent: 2103,
    },
    {
      nestId: 1308,
      name: "מצפה אביב",
      code: "13",
      parent: 2103,
    },
    {
      nestId: 1350,
      name: "גשר הזיו",
      code: "31",
      parent: 2104,
    },
    {
      nestId: 1351,
      name: "רגבה",
      code: "49",
      parent: 2104,
    },
    {
      nestId: 1352,
      name: "לוחמי הגטאות",
      code: "48",
      parent: 2104,
    },
    {
      nestId: 1353,
      name: "ראש הנקרה",
      code: "47",
      parent: 2104,
    },
    {
      nestId: 1354,
      name: 'מ"א מגילות',
      code: "99",
      parent: 2109,
    },
    {
      nestId: 1355,
      name: "שפיים",
      code: "78",
      parent: 1203,
    },
    {
      nestId: 1358,
      name: "צרעה",
      code: "03",
      parent: 2108,
    },
    {
      nestId: 1359,
      name: "שואבה",
      code: "04",
      parent: 2108,
    },
    {
      nestId: 1360,
      name: "מעלה החמישה",
      code: "05",
      parent: 2108,
    },
    {
      nestId: 1361,
      name: "קרית ענבים",
      code: "01",
      parent: 2108,
    },
    {
      nestId: 1362,
      name: "רמת רחל",
      code: "02",
      parent: 2108,
    },
    {
      nestId: 1363,
      name: "משמר הנגב",
      code: "02",
      parent: 2325,
    },
    {
      nestId: 1365,
      name: "רקפת",
      code: "07",
      parent: 2103,
    },
    {
      nestId: 1366,
      name: "אורים",
      code: "02",
      parent: 2111,
    },
    {
      nestId: 1367,
      name: "רעים",
      code: "01",
      parent: 2111,
    },
    {
      nestId: 1368,
      name: "כיסופים",
      code: "03",
      parent: 2111,
    },
    {
      nestId: 1369,
      name: "עין השלושה",
      code: "04",
      parent: 2111,
    },
    {
      nestId: 1370,
      name: "אור הנר",
      code: "03",
      parent: 2110,
    },
    {
      nestId: 1371,
      name: "מפלסים",
      code: "05",
      parent: 2110,
    },
    {
      nestId: 1372,
      name: "ניר עם",
      code: "09",
      parent: 2110,
    },
    {
      nestId: 1374,
      name: "גבים",
      code: "07",
      parent: 2110,
    },
    {
      nestId: 1375,
      name: "רוחמה",
      code: "02",
      parent: 2110,
    },
    {
      nestId: 1376,
      name: "ארז",
      code: "06",
      parent: 2110,
    },
    {
      nestId: 1377,
      name: "יכיני",
      code: "04",
      parent: 2110,
    },
    {
      nestId: 1378,
      name: "דורות",
      code: "08",
      parent: 2110,
    },
    {
      nestId: 1379,
      name: "נחל עוז",
      code: "10",
      parent: 2110,
    },
    {
      nestId: 1400,
      name: "מצפה שלם",
      code: "02",
      parent: 2109,
    },
    {
      nestId: 1401,
      name: "קליה",
      code: "05",
      parent: 2109,
    },
    {
      nestId: 1402,
      name: "אלמוג",
      code: "04",
      parent: 2109,
    },
    {
      nestId: 1403,
      name: "ורד יריחו",
      code: "03",
      parent: 2109,
    },
    {
      nestId: 1404,
      name: "בית הערבה",
      code: "01",
      parent: 2109,
    },
    {
      nestId: 1450,
      name: "קיסריה",
      code: "03",
      parent: 1202,
    },
    {
      nestId: 1501,
      name: "תובל",
      code: "05",
      parent: 2103,
    },
    {
      nestId: 1502,
      name: "אבטליון",
      code: "03",
      parent: 2103,
    },
    {
      nestId: 1503,
      name: "הררית יחד",
      code: "06",
      parent: 2103,
    },
    {
      nestId: 1550,
      name: 'רמב"ם - הביתלה - ראשון לציון',
      code: "15",
      parent: 1701,
    },
    {
      nestId: 1552,
      name: "מועדון ספיר",
      code: "07",
      parent: 1202,
    },
    {
      nestId: 1553,
      name: "אשדוד מרכז",
      code: "52",
      parent: 1204,
    },
    {
      nestId: 1554,
      name: "עמיעד",
      code: "02",
      parent: 2105,
    },
    {
      nestId: 1555,
      name: 'מ"א אשכול',
      code: "99",
      parent: 2111,
    },
    {
      nestId: 1556,
      name: "איילת השחר",
      code: "07",
      parent: 2105,
    },
    {
      nestId: 1557,
      name: "מחניים",
      code: "06",
      parent: 2105,
    },
    {
      nestId: 1558,
      name: "יפתח",
      code: "05",
      parent: 2105,
    },
    {
      nestId: 1559,
      name: "כפר גלעדי",
      code: "03",
      parent: 2105,
    },
    {
      nestId: 1560,
      name: "מעין ברוך",
      code: "08",
      parent: 2105,
    },
    {
      nestId: 1561,
      name: "הגושרים",
      code: "01",
      parent: 2105,
    },
    {
      nestId: 1562,
      name: "גדות",
      code: "04",
      parent: 2105,
    },
    {
      nestId: 1563,
      name: 'מ"א שער הנגב',
      code: "99",
      parent: 2110,
    },
    {
      nestId: 1564,
      name: "דגניה א",
      code: "08",
      parent: 2102,
    },
    {
      nestId: 1565,
      name: "דגניה ב",
      code: "09",
      parent: 2102,
    },
    {
      nestId: 1566,
      name: "אפיקים",
      code: "03",
      parent: 2102,
    },
    {
      nestId: 1567,
      name: "שער הגולן/מסדה",
      code: "18",
      parent: 2102,
    },
    {
      nestId: 1568,
      name: "בית זרע",
      code: "05",
      parent: 2102,
    },
    {
      nestId: 1569,
      name: "מעגן",
      code: "13",
      parent: 2102,
    },
    {
      nestId: 1570,
      name: "אלומות",
      code: "01",
      parent: 2102,
    },
    {
      nestId: 1571,
      name: "אשדות יעקב",
      code: "04",
      parent: 2102,
    },
    {
      nestId: 1572,
      name: "נווה עובד",
      code: "14",
      parent: 2102,
    },
    {
      nestId: 1573,
      name: "חוקוק",
      code: "10",
      parent: 2102,
    },
    {
      nestId: 1574,
      name: "גינוסר",
      code: "06",
      parent: 2102,
    },
    {
      nestId: 1575,
      name: "אלמגור",
      code: "02",
      parent: 2102,
    },
    {
      nestId: 1576,
      name: "לבנים",
      code: "06",
      parent: 2106,
    },
    {
      nestId: 1577,
      name: "מגדל",
      code: "20",
      parent: 2102,
    },
    {
      nestId: 1578,
      name: "עין גב",
      code: "15",
      parent: 2102,
    },
    {
      nestId: 1579,
      name: "פוריה עילית",
      code: "16",
      parent: 2102,
    },
    {
      nestId: 1580,
      name: "גשר",
      code: "01",
      parent: 2304,
    },
    {
      nestId: 1581,
      name: "קיבוץ כנרת",
      code: "17",
      parent: 2102,
    },
    {
      nestId: 1582,
      name: "קרית מוצקין",
      code: "28",
      parent: 1201,
    },
    {
      nestId: 1601,
      name: "חרשים",
      code: "02",
      parent: 2103,
    },
    {
      nestId: 1609,
      name: "אאא",
      code: "98",
      parent: 1202,
    },
    {
      nestId: 1612,
      name: "ברנע אשקלון",
      code: "09",
      parent: 1206,
    },
    {
      nestId: 1613,
      name: 'מ"א גליל עליון',
      code: "99",
      parent: 2105,
    },
    {
      nestId: 1651,
      name: "חיפה הטכני",
      code: "08",
      parent: 1201,
    },
    {
      nestId: 1654,
      name: "סניף גילה",
      code: "11",
      parent: 1205,
    },
    {
      nestId: 1655,
      name: "לוד",
      code: "11",
      parent: 1702,
    },
    {
      nestId: 1658,
      name: "פתח תקווה עין גנים",
      code: "12",
      parent: 1702,
    },
    {
      nestId: 1660,
      name: "רמת אליהו - ראשון לציון",
      code: "22",
      parent: 1701,
    },
    {
      nestId: 1661,
      name: "סניף רמלה",
      code: "13",
      parent: 1702,
    },
    {
      nestId: 1662,
      name: "סניף אשקלון",
      code: "04",
      parent: 1206,
    },
    {
      nestId: 1800,
      name: "אשקלון דרום",
      code: "06",
      parent: 1206,
    },
    {
      nestId: 1850,
      name: "בית שאן",
      code: "30",
      parent: 1200,
    },
    {
      nestId: 1851,
      name: "בני המושבים ארצי",
      code: "01",
      parent: 2002,
    },
    {
      nestId: 1852,
      name: "נווה עופר",
      code: "20",
      parent: 1700,
    },
    {
      nestId: 1900,
      name: "אשדוד אורט ימי",
      code: "90",
      parent: 1204,
    },
    {
      nestId: 1901,
      name: "עפולה עילית",
      code: "27",
      parent: 1200,
    },
    {
      nestId: 1902,
      name: "מבשרת ציון",
      code: "03",
      parent: 1205,
    },
    {
      nestId: 1903,
      name: "נהריה הירוקה",
      code: "07",
      parent: 1500,
    },
    {
      nestId: 1904,
      name: "עמל רמת דוד",
      code: "62",
      parent: 1200,
    },
    {
      nestId: 1905,
      name: "חיפה קטרפילר",
      code: "44",
      parent: 1201,
    },
    {
      nestId: 1906,
      name: "סניף בת גלים",
      code: "07",
      parent: 1201,
    },
    {
      nestId: 1907,
      name: "עמל טק אין",
      code: "52",
      parent: 1702,
    },
    {
      nestId: 1908,
      name: "אורט תעשייה אווירית",
      code: "53",
      parent: 1702,
    },
    {
      nestId: 1909,
      name: "אורט בית הערבה",
      code: "54",
      parent: 1205,
    },
    {
      nestId: 1910,
      name: "עתיד פלמחים",
      code: "55",
      parent: 1204,
    },
    {
      nestId: 1912,
      name: "בת ים",
      code: "01",
      parent: 1701,
    },
    {
      nestId: 1913,
      name: "ראשון מרכז - עבודה + - ראשון לציון",
      code: "19",
      parent: 1701,
    },
    {
      nestId: 1915,
      name: "אורט צריפין",
      code: "58",
      parent: 1701,
    },
    {
      nestId: 1916,
      name: "אורט תל נוף",
      code: "59",
      parent: 1204,
    },
    {
      nestId: 1917,
      name: "כפר מנדא",
      code: "51",
      parent: 2300,
    },
    {
      nestId: 1918,
      name: "אעבלין",
      code: "52",
      parent: 2300,
    },
    {
      nestId: 1919,
      name: "קיום משותף סח'נין",
      code: "53",
      parent: 1607,
    },
    {
      nestId: 1920,
      name: "מנשייה זבדה",
      code: "54",
      parent: 1607,
    },
    {
      nestId: 1921,
      name: "כמאנה",
      code: "16",
      parent: 1651,
    },
    {
      nestId: 1924,
      name: "יפו",
      code: "17",
      parent: 1700,
    },
    {
      nestId: 1925,
      name: "קיום משותף רהט",
      code: "51",
      parent: 1609,
    },
    {
      nestId: 1926,
      name: "שגב שלום",
      code: "09",
      parent: 1653,
    },
    {
      nestId: 1950,
      name: "שלומי",
      code: "05",
      parent: 1500,
    },
    {
      nestId: 1951,
      name: "מודיעין כרמים",
      code: "12",
      parent: 1205,
    },
    {
      nestId: 2000,
      name: "קרית בורוכוב",
      code: "07",
      parent: 1700,
    },
    {
      nestId: 2050,
      name: "שכבת יב",
      code: "01",
      parent: 1650,
    },
    {
      nestId: 2051,
      name: "דיר אל אסד",
      code: "20",
      parent: 1651,
    },
    {
      nestId: 2052,
      name: "עין מאהל",
      code: "01",
      parent: 2300,
    },
    {
      nestId: 2100,
      name: "רמת גן הראשונים",
      code: "04",
      parent: 1700,
    },
    {
      nestId: 2201,
      name: "קורנית",
      code: "01",
      parent: 2103,
    },
    {
      nestId: 2300,
      name: "חיפה התיכון החברתי",
      code: "93",
      parent: 1201,
    },
    {
      nestId: 2301,
      name: "יפו ד'",
      code: "09",
      parent: 1700,
    },
    {
      nestId: 2350,
      name: "רכס הכרמל",
      code: "54",
      parent: 1201,
    },
    {
      nestId: 2400,
      name: "יהוד",
      code: "7",
      parent: 1702,
    },
    {
      nestId: 2401,
      name: "רחובות היובל (לא פעיל)",
      code: "54",
      parent: 1204,
    },
    {
      nestId: 2406,
      name: "דלית אל כרמל",
      code: "13",
      parent: 1450,
    },
    {
      nestId: 2450,
      name: "פקיעין",
      code: "19",
      parent: 1450,
    },
    {
      nestId: 2451,
      name: "מסעדה",
      code: "04",
      parent: 1450,
    },
    {
      nestId: 2452,
      name: "מגדל שמס",
      code: "01",
      parent: 1450,
    },
    {
      nestId: 2453,
      name: "בוקעאת'א",
      code: "16",
      parent: 1450,
    },
    {
      nestId: 2500,
      name: "אמירים",
      code: "09",
      parent: 2106,
    },
    {
      nestId: 2501,
      name: "בארי",
      code: "05",
      parent: 2111,
    },
    {
      nestId: 2502,
      name: 'מ"א משגב',
      code: "99",
      parent: 2103,
    },
    {
      nestId: 2503,
      name: 'מ"א מטה אשר',
      code: "99",
      parent: 2104,
    },
    {
      nestId: 2504,
      name: "אביבים",
      code: "08",
      parent: 2106,
    },
    {
      nestId: 2505,
      name: "ריחאניה",
      code: "11",
      parent: 2106,
    },
    {
      nestId: 2506,
      name: "כפר חנניה",
      code: "10",
      parent: 2106,
    },
    {
      nestId: 2507,
      name: "שפר",
      code: "07",
      parent: 2106,
    },
    {
      nestId: 2508,
      name: "שזור",
      code: "03",
      parent: 2106,
    },
    {
      nestId: 2509,
      name: "ספסופה (כפר חושן)",
      code: "02",
      parent: 2106,
    },
    {
      nestId: 2510,
      name: "כפר שמאי",
      code: "01",
      parent: 2106,
    },
    {
      nestId: 2511,
      name: "דובב",
      code: "04",
      parent: 2106,
    },
    {
      nestId: 2512,
      name: "תל קציר",
      code: "19",
      parent: 2102,
    },
    {
      nestId: 2513,
      name: "כנרת מושבה",
      code: "12",
      parent: 2102,
    },
    {
      nestId: 2550,
      name: "סאג'ור",
      code: "22",
      parent: 1450,
    },
    {
      nestId: 2600,
      name: "עין ק'יניא",
      code: "08",
      parent: 1450,
    },
    {
      nestId: 2650,
      name: "יקנעם עילית",
      code: "50",
      parent: 1200,
    },
    {
      nestId: 2651,
      name: "כפר יונה",
      code: "58",
      parent: 1203,
    },
    {
      nestId: 2652,
      name: "אבן יהודה",
      code: "59",
      parent: 1203,
    },
    {
      nestId: 2653,
      name: "באר יעקב הצפון",
      code: "53",
      parent: 1701,
    },
    {
      nestId: 2654,
      name: "פתח תקווה שיפר נווה דקלים",
      code: "54",
      parent: 1702,
    },
    {
      nestId: 2655,
      name: "פתח תקווה - כפר גנים ג'",
      code: "55",
      parent: 1702,
    },
    {
      nestId: 2656,
      name: "נתניה גלי ים",
      code: "08",
      parent: 1202,
    },
    {
      nestId: 2657,
      name: "ירושלים מרכז",
      code: "57",
      parent: 1205,
    },
    {
      nestId: 2700,
      name: "חריש",
      code: "80",
      parent: 1202,
    },
    {
      nestId: 2701,
      name: "סניף דימונה",
      code: "16",
      parent: 1206,
    },
    {
      nestId: 2702,
      name: "חצור הגלילית",
      code: "09",
      parent: 1500,
    },
    {
      nestId: 2704,
      name: "הר גילה",
      code: "09",
      parent: 1205,
    },
    {
      nestId: 2705,
      name: "פתח תקווה שעריה",
      code: "56",
      parent: 1702,
    },
    {
      nestId: 2750,
      name: "סניף צפת",
      code: "10",
      parent: 1500,
    },
    {
      nestId: 2800,
      name: "יבנה הירוקה",
      code: "18",
      parent: 1204,
    },
    {
      nestId: 2801,
      name: "גדרה",
      code: "43",
      parent: 1204,
    },
    {
      nestId: 2802,
      name: "רמת השרון",
      code: "04",
      parent: 1203,
    },
    {
      nestId: 2803,
      name: "סניף נתיבות",
      code: "80",
      parent: 1206,
    },
    {
      nestId: 2850,
      name: "באר שבע רמות הרכס",
      code: "36",
      parent: 1206,
    },
    {
      nestId: 2851,
      name: "נתניה רבין",
      code: "14",
      parent: 1202,
    },
    {
      nestId: 2852,
      name: "ראש העין פסגות אפק",
      code: "08",
      parent: 1702,
    },
    {
      nestId: 2900,
      name: 'ת"א ביצרון',
      code: "11",
      parent: 1700,
    },
    {
      nestId: 2901,
      name: "קיום משותף לקיה",
      code: "53",
      parent: 1609,
    },
    {
      nestId: 2950,
      name: "נחלת יצחק",
      code: "12",
      parent: 1700,
    },
    {
      nestId: 2951,
      name: "ראמה",
      code: "24",
      parent: 1450,
    },
    {
      nestId: 3050,
      name: "צורן-קדימה",
      code: "01",
      parent: 2316,
    },
    {
      nestId: 3051,
      name: "אור יהודה",
      code: "16",
      parent: 1700,
    },
    {
      nestId: 3100,
      name: "קן בארי באר שבע",
      code: "49",
      parent: 1206,
    },
    {
      nestId: 3150,
      name: "אבו סנאן",
      code: "25",
      parent: 1450,
    },
    {
      nestId: 3200,
      name: 'ת"א התיכון החברתי',
      code: "70",
      parent: 1700,
    },
    {
      nestId: 3201,
      name: "ירושלים חושן",
      code: "71",
      parent: 1205,
    },
    {
      nestId: 3203,
      name: "מכינת יפתח",
      code: "73",
      parent: 1650,
    },
    {
      nestId: 3204,
      name: "נעלה",
      code: "74",
      parent: 1650,
    },
    {
      nestId: 3206,
      name: 'סניף קמ"ג',
      code: "19",
      parent: 1206,
    },
    {
      nestId: 3207,
      name: "דרור גליל",
      code: "79",
      parent: 1200,
    },
    {
      nestId: 3300,
      name: 'כפ"ס הירוקה',
      code: "09",
      parent: 1203,
    },
    {
      nestId: 3350,
      name: "עמיחי",
      code: "76",
      parent: 1650,
    },
    {
      nestId: 3351,
      name: "בת ים החוף",
      code: "11",
      parent: 1701,
    },
    {
      nestId: 3352,
      name: "צור יצחק",
      code: "63",
      parent: 1203,
    },
    {
      nestId: 3354,
      name: "מעלות-תרשיחא",
      code: "02",
      parent: 1500,
    },
    {
      nestId: 3355,
      name: "סניף קרית גת",
      code: "35",
      parent: 1206,
    },
    {
      nestId: 3356,
      name: "דיר חנא",
      code: "60",
      parent: 1607,
    },
    {
      nestId: 3357,
      name: "כפר סילבר",
      code: "50",
      parent: 1206,
    },
    {
      nestId: 3400,
      name: "חברת הנוער אשבל",
      code: "79",
      parent: 1500,
    },
    {
      nestId: 3450,
      name: "כפר עבודה",
      code: "11",
      parent: 2102,
    },
    {
      nestId: 3453,
      name: "אוהד",
      code: "01",
      parent: 2329,
    },
    {
      nestId: 3454,
      name: "שדה ניצן",
      code: "02",
      parent: 2329,
    },
    {
      nestId: 3455,
      name: "תלמי אליהו",
      code: "03",
      parent: 2329,
    },
    {
      nestId: 3456,
      name: "מבטחים",
      code: "04",
      parent: 2329,
    },
    {
      nestId: 3457,
      name: "עמיעוז",
      code: "05",
      parent: 2329,
    },
    {
      nestId: 3458,
      name: "אבשלום",
      code: "06",
      parent: 2329,
    },
    {
      nestId: 3459,
      name: "דקל",
      code: "07",
      parent: 2329,
    },
    {
      nestId: 3460,
      name: "יבול",
      code: "08",
      parent: 2329,
    },
    {
      nestId: 3461,
      name: "יתד",
      code: "09",
      parent: 2329,
    },
    {
      nestId: 3462,
      name: "פרי גן",
      code: "10",
      parent: 2329,
    },
    {
      nestId: 3463,
      name: "שדי אברהם",
      code: "11",
      parent: 2329,
    },
    {
      nestId: 3464,
      name: "תלמי יוסף",
      code: "12",
      parent: 2329,
    },
    {
      nestId: 3465,
      name: "ישע",
      code: "13",
      parent: 2329,
    },
    {
      nestId: 3466,
      name: "סופה",
      code: "14",
      parent: 2329,
    },
    {
      nestId: 3467,
      name: "עין הבשור",
      code: "15",
      parent: 2329,
    },
    {
      nestId: 3468,
      name: "צאלים",
      code: "16",
      parent: 2329,
    },
    {
      nestId: 3469,
      name: "צוחר",
      code: "17",
      parent: 2329,
    },
    {
      nestId: 3470,
      name: "אביגדור",
      code: "01",
      parent: 2322,
    },
    {
      nestId: 3471,
      name: "אורות",
      code: "02",
      parent: 2322,
    },
    {
      nestId: 3472,
      name: "אמונים",
      code: "03",
      parent: 2322,
    },
    {
      nestId: 3474,
      name: "בית עזרא",
      code: "05",
      parent: 2322,
    },
    {
      nestId: 3475,
      name: "ביצרון",
      code: "06",
      parent: 2322,
    },
    {
      nestId: 3476,
      name: "גבעתי",
      code: "07",
      parent: 2322,
    },
    {
      nestId: 3477,
      name: "חצב",
      code: "08",
      parent: 2322,
    },
    {
      nestId: 3478,
      name: "ינון",
      code: "09",
      parent: 2322,
    },
    {
      nestId: 3479,
      name: "כפר אחים",
      code: "10",
      parent: 2322,
    },
    {
      nestId: 3480,
      name: "כפר ורבורג",
      code: "11",
      parent: 2322,
    },
    {
      nestId: 3481,
      name: "נווה מבטח",
      code: "12",
      parent: 2322,
    },
    {
      nestId: 3482,
      name: "ניר בנים",
      code: "13",
      parent: 2322,
    },
    {
      nestId: 3483,
      name: "עזר",
      code: "14",
      parent: 2322,
    },
    {
      nestId: 3484,
      name: "עזריקם",
      code: "15",
      parent: 2322,
    },
    {
      nestId: 3485,
      name: "ערוגות",
      code: "16",
      parent: 2322,
    },
    {
      nestId: 3486,
      name: "שדה עוזיהו",
      code: "17",
      parent: 2322,
    },
    {
      nestId: 3487,
      name: "שתולים",
      code: "18",
      parent: 2322,
    },
    {
      nestId: 3488,
      name: "תלמי יחיאל",
      code: "19",
      parent: 2322,
    },
    {
      nestId: 3489,
      name: "בית שקמה",
      code: "01",
      parent: 2326,
    },
    {
      nestId: 3490,
      name: "בת הדר",
      code: "02",
      parent: 2326,
    },
    {
      nestId: 3491,
      name: "גיאה",
      code: "03",
      parent: 2326,
    },
    {
      nestId: 3492,
      name: "הודייה",
      code: "04",
      parent: 2326,
    },
    {
      nestId: 3493,
      name: "חלץ",
      code: "05",
      parent: 2326,
    },
    {
      nestId: 3494,
      name: "כוכב מיכאל",
      code: "06",
      parent: 2326,
    },
    {
      nestId: 3495,
      name: "מבקיעים",
      code: "07",
      parent: 2326,
    },
    {
      nestId: 3496,
      name: "משען",
      code: "08",
      parent: 2326,
    },
    {
      nestId: 3497,
      name: "ניר ישראל",
      code: "09",
      parent: 2326,
    },
    {
      nestId: 3498,
      name: "נתיב העשרה",
      code: "10",
      parent: 2326,
    },
    {
      nestId: 3499,
      name: "תלמי יפה",
      code: "11",
      parent: 2326,
    },
    {
      nestId: 3500,
      name: "אחוזם",
      code: "01",
      parent: 2328,
    },
    {
      nestId: 3501,
      name: "אמציה",
      code: "02",
      parent: 2328,
    },
    {
      nestId: 3502,
      name: "זוהר",
      code: "03",
      parent: 2328,
    },
    {
      nestId: 3503,
      name: "יד נתן",
      code: "04",
      parent: 2328,
    },
    {
      nestId: 3504,
      name: "לכיש",
      code: "05",
      parent: 2328,
    },
    {
      nestId: 3505,
      name: "מנוחה",
      code: "06",
      parent: 2328,
    },
    {
      nestId: 3506,
      name: "נהורה",
      code: "07",
      parent: 2328,
    },
    {
      nestId: 3507,
      name: "נוגה",
      code: "08",
      parent: 2328,
    },
    {
      nestId: 3508,
      name: 'ניר ח"ן',
      code: "09",
      parent: 2328,
    },
    {
      nestId: 3509,
      name: "עוצם",
      code: "10",
      parent: 2328,
    },
    {
      nestId: 3510,
      name: "שדה דוד",
      code: "11",
      parent: 2328,
    },
    {
      nestId: 3511,
      name: "שדה משה",
      code: "12",
      parent: 2328,
    },
    {
      nestId: 3512,
      name: "שחר",
      code: "13",
      parent: 2328,
    },
    {
      nestId: 3513,
      name: "אליאב",
      code: "14",
      parent: 2328,
    },
    {
      nestId: 3514,
      name: "שקף",
      code: "15",
      parent: 2328,
    },
    {
      nestId: 3515,
      name: "תלמים",
      code: "16",
      parent: 2328,
    },
    {
      nestId: 3516,
      name: "אביעזר",
      code: "01",
      parent: 2315,
    },
    {
      nestId: 3517,
      name: "אבן ספיר",
      code: "02",
      parent: 2315,
    },
    {
      nestId: 3518,
      name: "אורה",
      code: "03",
      parent: 2315,
    },
    {
      nestId: 3519,
      name: "אשתאול",
      code: "04",
      parent: 2315,
    },
    {
      nestId: 3520,
      name: "בית נקופה",
      code: "05",
      parent: 2315,
    },
    {
      nestId: 3521,
      name: "בקוע",
      code: "06",
      parent: 2315,
    },
    {
      nestId: 3522,
      name: "בר גיורא",
      code: "07",
      parent: 2315,
    },
    {
      nestId: 3523,
      name: "גבעת יערים",
      code: "08",
      parent: 2315,
    },
    {
      nestId: 3524,
      name: "גבעת ישעיהו",
      code: "09",
      parent: 2315,
    },
    {
      nestId: 3525,
      name: "גפן",
      code: "10",
      parent: 2315,
    },
    {
      nestId: 3526,
      name: "זכריה",
      code: "11",
      parent: 2315,
    },
    {
      nestId: 3527,
      name: "טל שחר",
      code: "12",
      parent: 2315,
    },
    {
      nestId: 3528,
      name: "כסלון",
      code: "13",
      parent: 2315,
    },
    {
      nestId: 3529,
      name: "כפר אוריה",
      code: "14",
      parent: 2315,
    },
    {
      nestId: 3530,
      name: "לוזית",
      code: "15",
      parent: 2315,
    },
    {
      nestId: 3531,
      name: "מבוא ביתר",
      code: "16",
      parent: 2315,
    },
    {
      nestId: 3532,
      name: "מוצא עילית",
      code: "17",
      parent: 2315,
    },
    {
      nestId: 3533,
      name: "מטע",
      code: "18",
      parent: 2315,
    },
    {
      nestId: 3534,
      name: "מסילת ציון",
      code: "19",
      parent: 2315,
    },
    {
      nestId: 3535,
      name: "נווה אילן",
      code: "20",
      parent: 2315,
    },
    {
      nestId: 3536,
      name: "נטף",
      code: "21",
      parent: 2315,
    },
    {
      nestId: 3537,
      name: "נס הרים",
      code: "22",
      parent: 2315,
    },
    {
      nestId: 3538,
      name: "עגור",
      code: "23",
      parent: 2315,
    },
    {
      nestId: 3539,
      name: "עמינדב",
      code: "24",
      parent: 2315,
    },
    {
      nestId: 3540,
      name: "צפרירים",
      code: "25",
      parent: 2315,
    },
    {
      nestId: 3541,
      name: "גיזו",
      code: "26",
      parent: 2315,
    },
    {
      nestId: 3542,
      name: "צלפון",
      code: "27",
      parent: 2315,
    },
    {
      nestId: 3543,
      name: "נווה מיכאל",
      code: "28",
      parent: 2315,
    },
    {
      nestId: 3544,
      name: "רמת רזיאל",
      code: "29",
      parent: 2315,
    },
    {
      nestId: 3545,
      name: "שדה מיכה",
      code: "30",
      parent: 2315,
    },
    {
      nestId: 3546,
      name: "תעוז",
      code: "31",
      parent: 2315,
    },
    {
      nestId: 3547,
      name: "נבטים",
      code: "01",
      parent: 2325,
    },
    {
      nestId: 3548,
      name: "חצבה",
      code: "01",
      parent: 2327,
    },
    {
      nestId: 3549,
      name: "ספיר",
      code: "02",
      parent: 2327,
    },
    {
      nestId: 3550,
      name: "עידן",
      code: "03",
      parent: 2327,
    },
    {
      nestId: 3551,
      name: "עין יהב",
      code: "04",
      parent: 2327,
    },
    {
      nestId: 3552,
      name: "פארן",
      code: "05",
      parent: 2327,
    },
    {
      nestId: 3553,
      name: "צופר",
      code: "06",
      parent: 2327,
    },
    {
      nestId: 3554,
      name: "צוקים",
      code: "07",
      parent: 2327,
    },
    {
      nestId: 3555,
      name: "אשלים",
      code: "01",
      parent: 2318,
    },
    {
      nestId: 3556,
      name: "באר מילכה",
      code: "02",
      parent: 2318,
    },
    {
      nestId: 3557,
      name: "טללים",
      code: "03",
      parent: 2318,
    },
    {
      nestId: 3558,
      name: "מדרשת בן גוריון",
      code: "04",
      parent: 2318,
    },
    {
      nestId: 3559,
      name: "משאבי שדה",
      code: "05",
      parent: 2318,
    },
    {
      nestId: 3560,
      name: "ניצנה (קהילת חינוך)",
      code: "06",
      parent: 2318,
    },
    {
      nestId: 3561,
      name: "כמהין",
      code: "07",
      parent: 2318,
    },
    {
      nestId: 3562,
      name: "ניצני סיני",
      code: "08",
      parent: 2318,
    },
    {
      nestId: 3563,
      name: "עזוז",
      code: "09",
      parent: 2318,
    },
    {
      nestId: 3564,
      name: "מחנה טלי",
      code: "10",
      parent: 2318,
    },
    {
      nestId: 3565,
      name: "שדה בוקר",
      code: "11",
      parent: 2318,
    },
    {
      nestId: 3566,
      name: "אביאל",
      code: "01",
      parent: 2314,
    },
    {
      nestId: 3567,
      name: 'גבעת ניל"י',
      code: "02",
      parent: 2314,
    },
    {
      nestId: 3568,
      name: "עמיקם",
      code: "03",
      parent: 2314,
    },
    {
      nestId: 3569,
      name: "אליכין",
      code: "35",
      parent: 1202,
    },
    {
      nestId: 3570,
      name: "בית אלעזרי",
      code: "01",
      parent: 2323,
    },
    {
      nestId: 3571,
      name: "בניה",
      code: "02",
      parent: 2323,
    },
    {
      nestId: 3572,
      name: "גבעת ברנר",
      code: "03",
      parent: 2323,
    },
    {
      nestId: 3573,
      name: "גינתון",
      code: "05",
      parent: 2321,
    },
    {
      nestId: 3574,
      name: "גן שלמה",
      code: "15",
      parent: 2324,
    },
    {
      nestId: 3575,
      name: "קדרון",
      code: "06",
      parent: 2323,
    },
    {
      nestId: 3576,
      name: "תל נוף",
      code: "07",
      parent: 2323,
    },
    {
      nestId: 3577,
      name: "בית עוזיאל",
      code: "01",
      parent: 2324,
    },
    {
      nestId: 3578,
      name: "גזר",
      code: "03",
      parent: 2107,
    },
    {
      nestId: 3579,
      name: "גני יוחנן",
      code: "03",
      parent: 2324,
    },
    {
      nestId: 3580,
      name: "חולדה",
      code: "04",
      parent: 2107,
    },
    {
      nestId: 3581,
      name: "יציץ",
      code: "05",
      parent: 2324,
    },
    {
      nestId: 3582,
      name: "ישרש",
      code: "06",
      parent: 2324,
    },
    {
      nestId: 3583,
      name: 'כפר ביל"ו',
      code: "07",
      parent: 2324,
    },
    {
      nestId: 3584,
      name: "מצליח",
      code: "08",
      parent: 2324,
    },
    {
      nestId: 3585,
      name: "משמר איילון",
      code: "09",
      parent: 2324,
    },
    {
      nestId: 3586,
      name: "משמר דוד",
      code: "10",
      parent: 2324,
    },
    {
      nestId: 3587,
      name: "עזריה",
      code: "11",
      parent: 2324,
    },
    {
      nestId: 3588,
      name: "פדיה",
      code: "12",
      parent: 2324,
    },
    {
      nestId: 3589,
      name: "גני הדר",
      code: "13",
      parent: 2324,
    },
    {
      nestId: 3590,
      name: "רמות מאיר",
      code: "14",
      parent: 2324,
    },
    {
      nestId: 3591,
      name: "אלישמע",
      code: "01",
      parent: 2319,
    },
    {
      nestId: 3592,
      name: 'גבעת ח"ן',
      code: "02",
      parent: 2319,
    },
    {
      nestId: 3593,
      name: "גן חיים",
      code: "03",
      parent: 2319,
    },
    {
      nestId: 3594,
      name: "צופית",
      code: "04",
      parent: 2319,
    },
    {
      nestId: 3595,
      name: "גני עם",
      code: "05",
      parent: 2319,
    },
    {
      nestId: 3596,
      name: "ירקונה",
      code: "06",
      parent: 2319,
    },
    {
      nestId: 3597,
      name: "נווה ירק",
      code: "07",
      parent: 2319,
    },
    {
      nestId: 3598,
      name: "עדנים",
      code: "08",
      parent: 2319,
    },
    {
      nestId: 3599,
      name: "חגור",
      code: "09",
      parent: 2319,
    },
    {
      nestId: 3600,
      name: "ירחיב",
      code: "10",
      parent: 2319,
    },
    {
      nestId: 3601,
      name: "כפר סירקין",
      code: "11",
      parent: 2319,
    },
    {
      nestId: 3602,
      name: "נווה ימין",
      code: "12",
      parent: 2319,
    },
    {
      nestId: 3603,
      name: "נירית",
      code: "13",
      parent: 2319,
    },
    {
      nestId: 3604,
      name: "גת רימון",
      code: "14",
      parent: 2319,
    },
    {
      nestId: 3605,
      name: "מעש",
      code: "15",
      parent: 2319,
    },
    {
      nestId: 3606,
      name: "שדי חמד",
      code: "16",
      parent: 2319,
    },
    {
      nestId: 3607,
      name: "בית נחמיה",
      code: "01",
      parent: 2321,
    },
    {
      nestId: 3608,
      name: "בן שמן (מושב)",
      code: "02",
      parent: 2321,
    },
    {
      nestId: 3609,
      name: "בני עטרות",
      code: "03",
      parent: 2321,
    },
    {
      nestId: 3610,
      name: 'גבעת כ"ח',
      code: "04",
      parent: 2321,
    },
    {
      nestId: 3612,
      name: "כפר דניאל",
      code: "06",
      parent: 2321,
    },
    {
      nestId: 3613,
      name: "כפר טרומן",
      code: "07",
      parent: 2321,
    },
    {
      nestId: 3614,
      name: "מזור",
      code: "08",
      parent: 2321,
    },
    {
      nestId: 3615,
      name: "נופך",
      code: "09",
      parent: 2321,
    },
    {
      nestId: 3616,
      name: "רינתיה",
      code: "10",
      parent: 2321,
    },
    {
      nestId: 3617,
      name: "שילת",
      code: "11",
      parent: 2321,
    },
    {
      nestId: 3618,
      name: "בני דרור",
      code: "01",
      parent: 2313,
    },
    {
      nestId: 3619,
      name: "גאולים",
      code: "02",
      parent: 2313,
    },
    {
      nestId: 3620,
      name: "גנות הדר",
      code: "03",
      parent: 2313,
    },
    {
      nestId: 3621,
      name: "נורדייה",
      code: "04",
      parent: 2313,
    },
    {
      nestId: 3622,
      name: "חירות",
      code: "05",
      parent: 2313,
    },
    {
      nestId: 3623,
      name: "ינוב",
      code: "06",
      parent: 2313,
    },
    {
      nestId: 3624,
      name: "כפר הס",
      code: "07",
      parent: 2313,
    },
    {
      nestId: 3625,
      name: "משמרת",
      code: "08",
      parent: 2313,
    },
    {
      nestId: 3626,
      name: "ניצני עוז",
      code: "09",
      parent: 2313,
    },
    {
      nestId: 3627,
      name: "עין ורד",
      code: "10",
      parent: 2313,
    },
    {
      nestId: 3628,
      name: "עין שריד",
      code: "11",
      parent: 2313,
    },
    {
      nestId: 3629,
      name: "צור משה",
      code: "12",
      parent: 2313,
    },
    {
      nestId: 3630,
      name: "שער אפרים",
      code: "13",
      parent: 2313,
    },
    {
      nestId: 3631,
      name: "תנובות",
      code: "14",
      parent: 2313,
    },
    {
      nestId: 3632,
      name: "אביחיל",
      code: "01",
      parent: 2312,
    },
    {
      nestId: 3633,
      name: "אחיטוב",
      code: "02",
      parent: 2312,
    },
    {
      nestId: 3634,
      name: "אומץ",
      code: "03",
      parent: 2312,
    },
    {
      nestId: 3635,
      name: "בחן",
      code: "04",
      parent: 2312,
    },
    {
      nestId: 3636,
      name: "בית הלוי",
      code: "05",
      parent: 2312,
    },
    {
      nestId: 3637,
      name: "בורגתה",
      code: "06",
      parent: 2312,
    },
    {
      nestId: 3638,
      name: "חניאל",
      code: "07",
      parent: 2312,
    },
    {
      nestId: 3639,
      name: "גאולי תימן",
      code: "08",
      parent: 2312,
    },
    {
      nestId: 3640,
      name: "גבעת חיים (איחוד)",
      code: "09",
      parent: 2312,
    },
    {
      nestId: 3641,
      name: "גבעת חיים (מאוחד)",
      code: "10",
      parent: 2312,
    },
    {
      nestId: 3642,
      name: "בית חירות",
      code: "11",
      parent: 2312,
    },
    {
      nestId: 3643,
      name: "בית ינאי",
      code: "12",
      parent: 2312,
    },
    {
      nestId: 3644,
      name: "ביתן אהרון",
      code: "13",
      parent: 2312,
    },
    {
      nestId: 3645,
      name: "בת חן",
      code: "14",
      parent: 2312,
    },
    {
      nestId: 3646,
      name: "גבעת שפירא",
      code: "15",
      parent: 2312,
    },
    {
      nestId: 3647,
      name: "חופית",
      code: "16",
      parent: 2312,
    },
    {
      nestId: 3648,
      name: "כפר ויתקין",
      code: "17",
      parent: 2312,
    },
    {
      nestId: 3649,
      name: "גן יאשיה",
      code: "18",
      parent: 2312,
    },
    {
      nestId: 3650,
      name: "הדר עם",
      code: "19",
      parent: 2312,
    },
    {
      nestId: 3651,
      name: "כפר חיים",
      code: "20",
      parent: 2312,
    },
    {
      nestId: 3652,
      name: "כפר ידידיה",
      code: "21",
      parent: 2312,
    },
    {
      nestId: 3653,
      name: "חבצלת השרון",
      code: "22",
      parent: 2312,
    },
    {
      nestId: 3654,
      name: "צוקי ים",
      code: "23",
      parent: 2312,
    },
    {
      nestId: 3655,
      name: "חגלה",
      code: "24",
      parent: 2312,
    },
    {
      nestId: 3656,
      name: "יד חנה",
      code: "25",
      parent: 2312,
    },
    {
      nestId: 3657,
      name: "כפר מונש",
      code: "26",
      parent: 2312,
    },
    {
      nestId: 3658,
      name: "מכמורת",
      code: "27",
      parent: 2312,
    },
    {
      nestId: 3659,
      name: "משמר השרון",
      code: "28",
      parent: 2312,
    },
    {
      nestId: 3660,
      name: "בארותיים",
      code: "29",
      parent: 2312,
    },
    {
      nestId: 3661,
      name: "עולש",
      code: "30",
      parent: 2312,
    },
    {
      nestId: 3662,
      name: "שושנת העמקים",
      code: "31",
      parent: 2312,
    },
    {
      nestId: 3663,
      name: "משמר השבעה",
      code: "01",
      parent: 2320,
    },
    {
      nestId: 3665,
      name: "ארגמן",
      code: "15",
      parent: 2317,
    },
    {
      nestId: 3666,
      name: "בקעות",
      code: "16",
      parent: 2317,
    },
    {
      nestId: 3667,
      name: "גלגל",
      code: "17",
      parent: 2317,
    },
    {
      nestId: 3668,
      name: "יפית",
      code: "18",
      parent: 2317,
    },
    {
      nestId: 3669,
      name: "מחולה",
      code: "19",
      parent: 2317,
    },
    {
      nestId: 3670,
      name: "מכורה",
      code: "20",
      parent: 2317,
    },
    {
      nestId: 3671,
      name: "משואה",
      code: "21",
      parent: 2317,
    },
    {
      nestId: 3672,
      name: 'נעמ"ה',
      code: "01",
      parent: 2317,
    },
    {
      nestId: 3673,
      name: "נירן",
      code: "02",
      parent: 2317,
    },
    {
      nestId: 3674,
      name: "נתיב הגדוד",
      code: "11",
      parent: 2317,
    },
    {
      nestId: 3675,
      name: "פצאל",
      code: "12",
      parent: 2317,
    },
    {
      nestId: 3676,
      name: "רועי",
      code: "13",
      parent: 2317,
    },
    {
      nestId: 3677,
      name: "תומר",
      code: "14",
      parent: 2317,
    },
    {
      nestId: 3678,
      name: "אודם",
      code: "41",
      parent: 2301,
    },
    {
      nestId: 3679,
      name: "אורטל",
      code: "42",
      parent: 2301,
    },
    {
      nestId: 3680,
      name: "אל-רום",
      code: "43",
      parent: 2301,
    },
    {
      nestId: 3681,
      name: "אלי-עד",
      code: "44",
      parent: 2301,
    },
    {
      nestId: 3682,
      name: "אניעם",
      code: "45",
      parent: 2301,
    },
    {
      nestId: 3683,
      name: "אפיק",
      code: "46",
      parent: 2301,
    },
    {
      nestId: 3684,
      name: "בני יהודה",
      code: "47",
      parent: 2301,
    },
    {
      nestId: 3685,
      name: "גבעת יואב",
      code: "08",
      parent: 2301,
    },
    {
      nestId: 3686,
      name: "גשור",
      code: "09",
      parent: 2301,
    },
    {
      nestId: 3687,
      name: "חד-נס",
      code: "10",
      parent: 2301,
    },
    {
      nestId: 3688,
      name: "כנף",
      code: "11",
      parent: 2301,
    },
    {
      nestId: 3689,
      name: "כפר חרוב",
      code: "12",
      parent: 2301,
    },
    {
      nestId: 3690,
      name: "מיצר",
      code: "13",
      parent: 2301,
    },
    {
      nestId: 3691,
      name: "מעלה גמלא",
      code: "48",
      parent: 2301,
    },
    {
      nestId: 3692,
      name: "מרום גולן",
      code: "49",
      parent: 2301,
    },
    {
      nestId: 3693,
      name: "נאות גולן",
      code: "50",
      parent: 2301,
    },
    {
      nestId: 3694,
      name: 'נווה אטי"ב',
      code: "51",
      parent: 2301,
    },
    {
      nestId: 3695,
      name: "נטור",
      code: "52",
      parent: 2301,
    },
    {
      nestId: 3696,
      name: "עין זיוון",
      code: "53",
      parent: 2301,
    },
    {
      nestId: 3697,
      name: "קדמת צבי",
      code: "54",
      parent: 2301,
    },
    {
      nestId: 3698,
      name: "קלע",
      code: "21",
      parent: 2301,
    },
    {
      nestId: 3699,
      name: "רמות",
      code: "22",
      parent: 2301,
    },
    {
      nestId: 3700,
      name: "שעל",
      code: "23",
      parent: 2301,
    },
    {
      nestId: 3701,
      name: "אביטל",
      code: "01",
      parent: 2306,
    },
    {
      nestId: 3702,
      name: "בית השיטה",
      code: "02",
      parent: 2306,
    },
    {
      nestId: 3703,
      name: "גבע",
      code: "03",
      parent: 2306,
    },
    {
      nestId: 3704,
      name: "גדעונה",
      code: "04",
      parent: 2306,
    },
    {
      nestId: 3705,
      name: "אומן",
      code: "05",
      parent: 2306,
    },
    {
      nestId: 3706,
      name: "גדיש",
      code: "06",
      parent: 2306,
    },
    {
      nestId: 3707,
      name: "מלאה",
      code: "07",
      parent: 2306,
    },
    {
      nestId: 3708,
      name: "ניר יפה",
      code: "08",
      parent: 2306,
    },
    {
      nestId: 3709,
      name: "אדירים",
      code: "09",
      parent: 2306,
    },
    {
      nestId: 3710,
      name: "ברק",
      code: "10",
      parent: 2306,
    },
    {
      nestId: 3711,
      name: "דבורה",
      code: "11",
      parent: 2306,
    },
    {
      nestId: 3712,
      name: "מיטב",
      code: "12",
      parent: 2306,
    },
    {
      nestId: 3713,
      name: "גן נר",
      code: "13",
      parent: 2306,
    },
    {
      nestId: 3714,
      name: "מרכז חבר (חבר)",
      code: "15",
      parent: 2306,
    },
    {
      nestId: 3715,
      name: "חפצי-בה",
      code: "16",
      parent: 2306,
    },
    {
      nestId: 3716,
      name: "יזרעאל",
      code: "17",
      parent: 2306,
    },
    {
      nestId: 3717,
      name: "כפר יחזקאל",
      code: "18",
      parent: 2306,
    },
    {
      nestId: 3718,
      name: "מגן שאול",
      code: "19",
      parent: 2306,
    },
    {
      nestId: 3719,
      name: "מולדת",
      code: "20",
      parent: 2306,
    },
    {
      nestId: 3720,
      name: "מרכז יעל",
      code: "21",
      parent: 2306,
    },
    {
      nestId: 3721,
      name: "עין חרוד (איחוד)",
      code: "22",
      parent: 2306,
    },
    {
      nestId: 3722,
      name: "עין חרוד (מאוחד)",
      code: "23",
      parent: 2306,
    },
    {
      nestId: 3723,
      name: "פרזון",
      code: "24",
      parent: 2306,
    },
    {
      nestId: 3724,
      name: "רם און",
      code: "25",
      parent: 2306,
    },
    {
      nestId: 3725,
      name: "רמת צבי",
      code: "26",
      parent: 2306,
    },
    {
      nestId: 3726,
      name: "תל יוסף",
      code: "27",
      parent: 2306,
    },
    {
      nestId: 3727,
      name: "אילנייה",
      code: "01",
      parent: 2303,
    },
    {
      nestId: 3728,
      name: "ארבל",
      code: "02",
      parent: 2303,
    },
    {
      nestId: 3729,
      name: "בית קשת",
      code: "03",
      parent: 2303,
    },
    {
      nestId: 3730,
      name: "גבעת אבני",
      code: "04",
      parent: 2303,
    },
    {
      nestId: 3731,
      name: "כפר חיטים",
      code: "05",
      parent: 2303,
    },
    {
      nestId: 3732,
      name: "כפר קיש",
      code: "06",
      parent: 2303,
    },
    {
      nestId: 3733,
      name: "מסד",
      code: "07",
      parent: 2303,
    },
    {
      nestId: 3734,
      name: "מצפה",
      code: "08",
      parent: 2303,
    },
    {
      nestId: 3735,
      name: "שדמות דבורה",
      code: "09",
      parent: 2303,
    },
    {
      nestId: 3736,
      name: "שרונה",
      code: "10",
      parent: 2303,
    },
    {
      nestId: 3737,
      name: "בית אורן",
      code: "01",
      parent: 2307,
    },
    {
      nestId: 3738,
      name: "בת שלמה",
      code: "02",
      parent: 2307,
    },
    {
      nestId: 3739,
      name: "גבע כרמל",
      code: "03",
      parent: 2307,
    },
    {
      nestId: 3740,
      name: "דור",
      code: "04",
      parent: 2307,
    },
    {
      nestId: 3741,
      name: "הבונים",
      code: "05",
      parent: 2307,
    },
    {
      nestId: 3742,
      name: "החותרים",
      code: "06",
      parent: 2307,
    },
    {
      nestId: 3743,
      name: 'כרם מהר"ל',
      code: "07",
      parent: 2307,
    },
    {
      nestId: 3744,
      name: "מגדים",
      code: "08",
      parent: 2307,
    },
    {
      nestId: 3745,
      name: "מעגן מיכאל",
      code: "09",
      parent: 2307,
    },
    {
      nestId: 3746,
      name: "מעיין צבי",
      code: "10",
      parent: 2307,
    },
    {
      nestId: 3747,
      name: "נווה ים",
      code: "11",
      parent: 2307,
    },
    {
      nestId: 3748,
      name: "נחשולים",
      code: "12",
      parent: 2307,
    },
    {
      nestId: 3749,
      name: "עופר",
      code: "13",
      parent: 2307,
    },
    {
      nestId: 3750,
      name: "עין איילה",
      code: "14",
      parent: 2307,
    },
    {
      nestId: 3751,
      name: "עין הוד",
      code: "15",
      parent: 2307,
    },
    {
      nestId: 3752,
      name: "עין כרמל",
      code: "16",
      parent: 2307,
    },
    {
      nestId: 3753,
      name: "צרופה",
      code: "17",
      parent: 2307,
    },
    {
      nestId: 3754,
      name: "שדות ים",
      code: "18",
      parent: 2307,
    },
    {
      nestId: 3756,
      name: "אליפלט",
      code: "11",
      parent: 2308,
    },
    {
      nestId: 3757,
      name: "אמנון",
      code: "12",
      parent: 2308,
    },
    {
      nestId: 3758,
      name: "כחל",
      code: "13",
      parent: 2308,
    },
    {
      nestId: 3759,
      name: "בית הלל",
      code: "01",
      parent: 2308,
    },
    {
      nestId: 3760,
      name: "דישון",
      code: "02",
      parent: 2308,
    },
    {
      nestId: 3761,
      name: "כורזים",
      code: "03",
      parent: 2308,
    },
    {
      nestId: 3762,
      name: "יובל",
      code: "04",
      parent: 2308,
    },
    {
      nestId: 3763,
      name: "כרכום",
      code: "05",
      parent: 2308,
    },
    {
      nestId: 3764,
      name: "מרגליות",
      code: "06",
      parent: 2308,
    },
    {
      nestId: 3765,
      name: "משמר הירדן",
      code: "07",
      parent: 2308,
    },
    {
      nestId: 3766,
      name: "רמות נפתלי",
      code: "08",
      parent: 2308,
    },
    {
      nestId: 3767,
      name: "שאר ישוב",
      code: "09",
      parent: 2308,
    },
    {
      nestId: 3768,
      name: "שדה אליעזר",
      code: "10",
      parent: 2308,
    },
    {
      nestId: 3769,
      name: "אדמית",
      code: "32",
      parent: 2104,
    },
    {
      nestId: 3770,
      name: "אשרת",
      code: "33",
      parent: 2104,
    },
    {
      nestId: 3771,
      name: "אפק",
      code: "34",
      parent: 2104,
    },
    {
      nestId: 3772,
      name: "בוסתן הגליל",
      code: "35",
      parent: 2104,
    },
    {
      nestId: 3773,
      name: "בית העמק",
      code: "36",
      parent: 2104,
    },
    {
      nestId: 3774,
      name: "בן עמי",
      code: "37",
      parent: 2104,
    },
    {
      nestId: 3775,
      name: "בצת",
      code: "38",
      parent: 2104,
    },
    {
      nestId: 3776,
      name: "חניתה",
      code: "39",
      parent: 2104,
    },
    {
      nestId: 3777,
      name: "כברי",
      code: "40",
      parent: 2104,
    },
    {
      nestId: 3778,
      name: "כליל",
      code: "41",
      parent: 2104,
    },
    {
      nestId: 3779,
      name: "לימן",
      code: "42",
      parent: 2104,
    },
    {
      nestId: 3780,
      name: "מצובה",
      code: "43",
      parent: 2104,
    },
    {
      nestId: 3781,
      name: "נתיב השיירה",
      code: "44",
      parent: 2104,
    },
    {
      nestId: 3782,
      name: "עמקה",
      code: "45",
      parent: 2104,
    },
    {
      nestId: 3783,
      name: "שבי ציון",
      code: "46",
      parent: 2104,
    },
    {
      nestId: 3784,
      name: "מטולה",
      code: "01",
      parent: 2305,
    },
    {
      nestId: 3785,
      name: "אלוני יצחק",
      code: "01",
      parent: 2309,
    },
    {
      nestId: 3786,
      name: "כפר גליקסון",
      code: "02",
      parent: 2309,
    },
    {
      nestId: 3787,
      name: "רגבים",
      code: "03",
      parent: 2309,
    },
    {
      nestId: 3788,
      name: "מאור",
      code: "04",
      parent: 2309,
    },
    {
      nestId: 3789,
      name: "מי עמי",
      code: "05",
      parent: 2309,
    },
    {
      nestId: 3790,
      name: "משמרות",
      code: "06",
      parent: 2309,
    },
    {
      nestId: 3791,
      name: "עין עירון",
      code: "07",
      parent: 2309,
    },
    {
      nestId: 3792,
      name: "שדה יצחק",
      code: "08",
      parent: 2309,
    },
    {
      nestId: 3793,
      name: "אבירים",
      code: "01",
      parent: 2311,
    },
    {
      nestId: 3794,
      name: "אבן מנחם",
      code: "02",
      parent: 2311,
    },
    {
      nestId: 3795,
      name: "אלקוש",
      code: "03",
      parent: 2311,
    },
    {
      nestId: 3796,
      name: "גורן",
      code: "04",
      parent: 2311,
    },
    {
      nestId: 3797,
      name: "גיתה",
      code: "05",
      parent: 2311,
    },
    {
      nestId: 3798,
      name: "גרנות הגליל",
      code: "06",
      parent: 2311,
    },
    {
      nestId: 3799,
      name: "הילה",
      code: "07",
      parent: 2311,
    },
    {
      nestId: 3800,
      name: "כפר רוזנואלד (זרעית)",
      code: "08",
      parent: 2311,
    },
    {
      nestId: 3801,
      name: "חוסן",
      code: "09",
      parent: 2311,
    },
    {
      nestId: 3802,
      name: "יערה",
      code: "10",
      parent: 2311,
    },
    {
      nestId: 3803,
      name: "לפידות",
      code: "11",
      parent: 2311,
    },
    {
      nestId: 3804,
      name: "מנות",
      code: "12",
      parent: 2311,
    },
    {
      nestId: 3805,
      name: "מעונה",
      code: "13",
      parent: 2311,
    },
    {
      nestId: 3806,
      name: "מתת",
      code: "14",
      parent: 2311,
    },
    {
      nestId: 3807,
      name: "נווה זיו",
      code: "15",
      parent: 2311,
    },
    {
      nestId: 3808,
      name: "נטועה",
      code: "16",
      parent: 2311,
    },
    {
      nestId: 3809,
      name: "עבדון",
      code: "17",
      parent: 2311,
    },
    {
      nestId: 3810,
      name: "עין יעקב",
      code: "18",
      parent: 2311,
    },
    {
      nestId: 3811,
      name: "פקיעין חדשה",
      code: "19",
      parent: 2311,
    },
    {
      nestId: 3812,
      name: "צוריאל",
      code: "20",
      parent: 2311,
    },
    {
      nestId: 3813,
      name: "שומרה",
      code: "21",
      parent: 2311,
    },
    {
      nestId: 3814,
      name: "שתולה",
      code: "22",
      parent: 2311,
    },
    {
      nestId: 3815,
      name: "חמדיה",
      code: "02",
      parent: 2304,
    },
    {
      nestId: 3816,
      name: "בית יוסף",
      code: "03",
      parent: 2304,
    },
    {
      nestId: 3817,
      name: "ירדנה",
      code: "04",
      parent: 2304,
    },
    {
      nestId: 3818,
      name: "כפר רופין",
      code: "05",
      parent: 2304,
    },
    {
      nestId: 3819,
      name: "מנחמיה",
      code: "06",
      parent: 2304,
    },
    {
      nestId: 3820,
      name: "מעוז חיים",
      code: "07",
      parent: 2304,
    },
    {
      nestId: 3821,
      name: "נווה אור",
      code: "08",
      parent: 2304,
    },
    {
      nestId: 3822,
      name: "נווה איתן",
      code: "09",
      parent: 2304,
    },
    {
      nestId: 3823,
      name: "רשפים",
      code: "10",
      parent: 2304,
    },
    {
      nestId: 3824,
      name: "שדה נחום",
      code: "11",
      parent: 2304,
    },
    {
      nestId: 3825,
      name: "אחוזת ברק",
      code: "01",
      parent: 2310,
    },
    {
      nestId: 3826,
      name: "אלון הגליל",
      code: "02",
      parent: 2310,
    },
    {
      nestId: 3827,
      name: "אלוני אבא",
      code: "03",
      parent: 2310,
    },
    {
      nestId: 3828,
      name: "אלונים",
      code: "04",
      parent: 2310,
    },
    {
      nestId: 3829,
      name: "בית לחם הגלילית",
      code: "05",
      parent: 2310,
    },
    {
      nestId: 3830,
      name: "בית שערים",
      code: "06",
      parent: 2310,
    },
    {
      nestId: 3831,
      name: "בלפוריה",
      code: "07",
      parent: 2310,
    },
    {
      nestId: 3832,
      name: "גבעת אלה",
      code: "08",
      parent: 2310,
    },
    {
      nestId: 3833,
      name: "גבת",
      code: "09",
      parent: 2310,
    },
    {
      nestId: 3834,
      name: "גניגר",
      code: "10",
      parent: 2310,
    },
    {
      nestId: 3835,
      name: "דברת",
      code: "11",
      parent: 2310,
    },
    {
      nestId: 3836,
      name: "היוגב",
      code: "12",
      parent: 2310,
    },
    {
      nestId: 3837,
      name: "הסוללים",
      code: "13",
      parent: 2310,
    },
    {
      nestId: 3838,
      name: "הרדוף",
      code: "14",
      parent: 2310,
    },
    {
      nestId: 3839,
      name: "חנתון",
      code: "15",
      parent: 2310,
    },
    {
      nestId: 3840,
      name: "יפעת",
      code: "16",
      parent: 2310,
    },
    {
      nestId: 3841,
      name: "כפר ברוך",
      code: "17",
      parent: 2310,
    },
    {
      nestId: 3842,
      name: "כפר החורש",
      code: "18",
      parent: 2310,
    },
    {
      nestId: 3843,
      name: "מזרע",
      code: "19",
      parent: 2310,
    },
    {
      nestId: 3844,
      name: "כפר יהושע",
      code: "20",
      parent: 2310,
    },
    {
      nestId: 3845,
      name: "מחנה יהודית (רמת דוד)",
      code: "21",
      parent: 2310,
    },
    {
      nestId: 3846,
      name: "מרחביה (מושב)",
      code: "22",
      parent: 2310,
    },
    {
      nestId: 3847,
      name: "נהלל",
      code: "23",
      parent: 2310,
    },
    {
      nestId: 3848,
      name: "עדי",
      code: "24",
      parent: 2310,
    },
    {
      nestId: 3849,
      name: "ציפורי",
      code: "25",
      parent: 2310,
    },
    {
      nestId: 3850,
      name: "רמת דוד",
      code: "26",
      parent: 2310,
    },
    {
      nestId: 3851,
      name: "שמשית",
      code: "27",
      parent: 2310,
    },
    {
      nestId: 3852,
      name: "תל עדשים",
      code: "28",
      parent: 2310,
    },
    {
      nestId: 3853,
      name: "תמרת",
      code: "29",
      parent: 2310,
    },
    {
      nestId: 200050,
      name: "התאגדויות במזון המהיר",
      code: "01",
      parent: 2050,
    },
    {
      nestId: 200100,
      name: "איגוד מקצועי כללי",
      code: "11",
      parent: 2050,
    },
    {
      nestId: 200150,
      name: "כלל תנועתי",
      code: "98",
      parent: 2100,
    },
    {
      nestId: 200151,
      name: "נוער תלם - קיבוץ לוטן",
      code: "40",
      parent: 2101,
    },
    {
      nestId: 200152,
      name: "נוער תלם - גדרה",
      code: "41",
      parent: 2101,
    },
    {
      nestId: 200153,
      name: "נוער תלם - חולון קודש וחול",
      code: "42",
      parent: 2101,
    },
    {
      nestId: 200154,
      name: "נוער תלם - תל אביב בית דניאל",
      code: "43",
      parent: 2101,
    },
    {
      nestId: 200155,
      name: "נוער תלם - מודיעין יוזמה",
      code: "44",
      parent: 2101,
    },
    {
      nestId: 200156,
      name: "נוער תלם - ירושלים כל הנשמה",
      code: "45",
      parent: 2101,
    },
    {
      nestId: 200157,
      name: "נוער תלם - מבשרת קמץ",
      code: "46",
      parent: 2101,
    },
    {
      nestId: 200158,
      name: "נוער תלם - צור הדסה",
      code: "47",
      parent: 2101,
    },
    {
      nestId: 200159,
      name: "נוער תלם - זכרון יעקב סולם יעקב",
      code: "48",
      parent: 2101,
    },
    {
      nestId: 200160,
      name: "נוער תלם - חיפה אור חדש",
      code: "49",
      parent: 2101,
    },
    {
      nestId: 200161,
      name: "נוער תלם - חיפה אהל אברהם",
      code: "50",
      parent: 2101,
    },
    {
      nestId: 200162,
      name: "נוער תלם - סניף גליל",
      code: "51",
      parent: 2101,
    },
    {
      nestId: 200163,
      name: "נוער תלם - ארצי",
      code: "99",
      parent: 2101,
    },
    {
      nestId: 200164,
      name: "נוער תלם - אבן יהודה",
      code: "52",
      parent: 2101,
    },
    {
      nestId: 200165,
      name: "גני תקווה",
      code: "10",
      parent: 1702,
    },
    {
      nestId: 200200,
      name: "נוער תלם - תכנית חמולה",
      code: "53",
      parent: 2101,
    },
    {
      nestId: 200250,
      name: "כפר קרע",
      code: "01",
      parent: 1652,
    },
    {
      nestId: 200251,
      name: "רהט",
      code: "01",
      parent: 1653,
    },
    {
      nestId: 200350,
      name: "מכמנים",
      code: "04",
      parent: 2103,
    },
    {
      nestId: 200450,
      name: "דפנה",
      code: "09",
      parent: 2105,
    },
    {
      nestId: 200451,
      name: "משגב עם",
      code: "10",
      parent: 2105,
    },
    {
      nestId: 200550,
      name: "הכנה לצהל",
      code: "81",
      parent: 1650,
    },
    {
      nestId: 200551,
      name: "באקה אל גרבייה",
      code: "02",
      parent: 1652,
    },
    {
      nestId: 200552,
      name: "טירה",
      code: "03",
      parent: 1652,
    },
    {
      nestId: 200553,
      name: "עין ראפה",
      code: "04",
      parent: 1652,
    },
    {
      nestId: 200554,
      name: "עין נקובה",
      code: "05",
      parent: 1652,
    },
    {
      nestId: 200555,
      name: "חוסנייה",
      code: "15",
      parent: 1651,
    },
    {
      nestId: 200600,
      name: "קרית ביאליק צור שלום",
      code: "55",
      parent: 1201,
    },
    {
      nestId: 200608,
      name: "הקנים הערבים - סח'נין",
      code: "02",
      parent: 2300,
    },
    {
      nestId: 200609,
      name: "ביר אלמכסור",
      code: "03",
      parent: 2300,
    },
    {
      nestId: 200610,
      name: "ואדי סלמה",
      code: "05",
      parent: 1651,
    },
    {
      nestId: 200611,
      name: "נצרת",
      code: "06",
      parent: 2300,
    },
    {
      nestId: 200612,
      name: "שעב",
      code: "07",
      parent: 2300,
    },
    {
      nestId: 200613,
      name: "נחף",
      code: "08",
      parent: 1651,
    },
    {
      nestId: 200614,
      name: "הקנים הערבים - עכו",
      code: "10",
      parent: 2300,
    },
    {
      nestId: 200615,
      name: "מ.ירושלים",
      code: "06",
      parent: 1652,
    },
    {
      nestId: 200616,
      name: "תרשיחא",
      code: "21",
      parent: 1651,
    },
    {
      nestId: 200617,
      name: "מזרעה",
      code: "22",
      parent: 1651,
    },
    {
      nestId: 200618,
      name: "טובא זנגרייה",
      code: "23",
      parent: 1651,
    },
    {
      nestId: 200619,
      name: "בועיינה נוג'דאת",
      code: "24",
      parent: 1651,
    },
    {
      nestId: 200620,
      name: "זרזיר",
      code: "25",
      parent: 2300,
    },
    {
      nestId: 200621,
      name: "טורעאן",
      code: "26",
      parent: 1651,
    },
    {
      nestId: 200622,
      name: "כעביה",
      code: "27",
      parent: 2300,
    },
    {
      nestId: 200623,
      name: "שיח דנון",
      code: "28",
      parent: 1651,
    },
    {
      nestId: 200624,
      name: "בסמת טבעון",
      code: "29",
      parent: 2300,
    },
    {
      nestId: 200625,
      name: "בענה",
      code: "30",
      parent: 1651,
    },
    {
      nestId: 200626,
      name: "טמרה",
      code: "31",
      parent: 2300,
    },
    {
      nestId: 200627,
      name: "כפר מצר",
      code: "32",
      parent: 2300,
    },
    {
      nestId: 200628,
      name: "עילוט",
      code: "33",
      parent: 1651,
    },
    {
      nestId: 200629,
      name: "הקנים הערבים - חיפה",
      code: "34",
      parent: 2300,
    },
    {
      nestId: 200630,
      name: "כסייפה",
      code: "03",
      parent: 1653,
    },
    {
      nestId: 200631,
      name: "אום בטין - אלקסום",
      code: "02",
      parent: 1653,
    },
    {
      nestId: 200632,
      name: "לקיה - קנים ערבים",
      code: "04",
      parent: 1653,
    },
    {
      nestId: 200633,
      name: "נווה מדבר",
      code: "05",
      parent: 1653,
    },
    {
      nestId: 200634,
      name: "חורה",
      code: "06",
      parent: 1653,
    },
    {
      nestId: 200635,
      name: "תל שבע",
      code: "07",
      parent: 1653,
    },
    {
      nestId: 200636,
      name: "פורדיס",
      code: "07",
      parent: 1652,
    },
    {
      nestId: 200637,
      name: "קבוצות מחנכים",
      code: "90",
      parent: 2200,
    },
    {
      nestId: 200650,
      name: "טייבה",
      code: "08",
      parent: 1652,
    },
    {
      nestId: 200651,
      name: "אום אלפחם",
      code: "09",
      parent: 1652,
    },
    {
      nestId: 200652,
      name: "אבו גוש",
      code: "10",
      parent: 1652,
    },
    {
      nestId: 200750,
      name: "קן הציפורים הוד השרון",
      code: "23",
      parent: 1203,
    },
    {
      nestId: 200751,
      name: "קרית אונו דרום",
      code: "15",
      parent: 1700,
    },
    {
      nestId: 200800,
      name: "קרית אתא התיכון החברתי",
      code: "16",
      parent: 1201,
    },
    {
      nestId: 200850,
      name: "עמל אנרג'י טק",
      code: "11",
      parent: 1202,
    },
    {
      nestId: 200900,
      name: "עין חוד",
      code: "11",
      parent: 1652,
    },
    {
      nestId: 200950,
      name: "גסר אלזרקא",
      code: "12",
      parent: 1652,
    },
    {
      nestId: 200951,
      name: "כפר גלים",
      code: "20",
      parent: 2307,
    },
    {
      nestId: 200952,
      name: 'נתיב הל"ה',
      code: "06",
      parent: 2108,
    },
    {
      nestId: 200953,
      name: "חולתה",
      code: "12",
      parent: 2105,
    },
    {
      nestId: 200954,
      name: "כפר הנשיא",
      code: "11",
      parent: 2105,
    },
    {
      nestId: 200955,
      name: "נאות מרדכי",
      code: "13",
      parent: 2105,
    },
    {
      nestId: 200956,
      name: "גיתית",
      code: "03",
      parent: 2317,
    },
    {
      nestId: 200957,
      name: "חמדת",
      code: "04",
      parent: 2317,
    },
    {
      nestId: 200958,
      name: "חמרה",
      code: "05",
      parent: 2317,
    },
    {
      nestId: 200959,
      name: 'ייט"ב',
      code: "06",
      parent: 2317,
    },
    {
      nestId: 200960,
      name: "מבואות יריחו",
      code: "07",
      parent: 2317,
    },
    {
      nestId: 200961,
      name: "משכיות",
      code: "08",
      parent: 2317,
    },
    {
      nestId: 200962,
      name: "רותם",
      code: "09",
      parent: 2317,
    },
    {
      nestId: 200963,
      name: "שדמות מחולה",
      code: "10",
      parent: 2317,
    },
    {
      nestId: 200964,
      name: "נורית",
      code: "14",
      parent: 2306,
    },
    {
      nestId: 200965,
      name: "נשר",
      code: "33",
      parent: 1201,
    },
    {
      nestId: 201000,
      name: "ערערה בנגב",
      code: "08",
      parent: 1653,
    },
    {
      nestId: 201001,
      name: "בני ברק",
      code: "18",
      parent: 1700,
    },
    {
      nestId: 201002,
      name: "גבעת שמואל",
      code: "19",
      parent: 1700,
    },
    {
      nestId: 201003,
      name: "כפר ורדים",
      code: "11",
      parent: 1500,
    },
    {
      nestId: 201005,
      name: "קצרין",
      code: "13",
      parent: 1500,
    },
    {
      nestId: 201006,
      name: "קרית מלאכי",
      code: "19",
      parent: 1204,
    },
    {
      nestId: 201007,
      name: "בני עייש",
      code: "36",
      parent: 1204,
    },
    {
      nestId: 201008,
      name: "אזור",
      code: "20",
      parent: 1701,
    },
    {
      nestId: 201009,
      name: "בית דגן",
      code: "21",
      parent: 1701,
    },
    {
      nestId: 201010,
      name: "אור עקיבא",
      code: "30",
      parent: 1202,
    },
    {
      nestId: 201011,
      name: "טירת הכרמל",
      code: "26",
      parent: 1201,
    },
    {
      nestId: 201012,
      name: "רכסים",
      code: "25",
      parent: 1201,
    },
    {
      nestId: 201013,
      name: "קן עין כרם",
      code: "13",
      parent: 1205,
    },
    {
      nestId: 201014,
      name: "מודיעין עילית",
      code: "14",
      parent: 1205,
    },
    {
      nestId: 201015,
      name: "קדם ערבה",
      code: "06",
      parent: 2109,
    },
    {
      nestId: 201016,
      name: "אורנית",
      code: "14",
      parent: 1702,
    },
    {
      nestId: 201017,
      name: "אלעד",
      code: "15",
      parent: 1702,
    },
    {
      nestId: 201018,
      name: "אריאל",
      code: "16",
      parent: 1702,
    },
    {
      nestId: 201019,
      name: "סביון",
      code: "17",
      parent: 1702,
    },
    {
      nestId: 201020,
      name: "ירוחם",
      code: "03",
      parent: 1206,
    },
    {
      nestId: 201021,
      name: "להבים",
      code: "38",
      parent: 1206,
    },
    {
      nestId: 201022,
      name: "יבנאל",
      code: "15",
      parent: 1200,
    },
    {
      nestId: 201023,
      name: "אלפי מנשה",
      code: "02",
      parent: 1203,
    },
    {
      nestId: 201024,
      name: "כוכב יאיר",
      code: "03",
      parent: 1203,
    },
    {
      nestId: 201025,
      name: "רעננה",
      code: "05",
      parent: 1203,
    },
    {
      nestId: 201026,
      name: "תל מונד",
      code: "06",
      parent: 1203,
    },
    {
      nestId: 201027,
      name: "פלורנטין",
      code: "21",
      parent: 1700,
    },
    {
      nestId: 201028,
      name: 'שלוחת הל"ה - גבעתיים',
      code: "22",
      parent: 1700,
    },
    {
      nestId: 201029,
      name: "חולית",
      code: "18",
      parent: 2111,
    },
    {
      nestId: 201030,
      name: "כרם שלום",
      code: "19",
      parent: 2111,
    },
    {
      nestId: 201031,
      name: "מבוא חמה",
      code: "24",
      parent: 2301,
    },
    {
      nestId: 201032,
      name: "באר טוביה",
      code: "04",
      parent: 2322,
    },
    {
      nestId: 201033,
      name: "גן שלושה",
      code: "04",
      parent: 2323,
    },
    {
      nestId: 201034,
      name: "גינתון",
      code: "05",
      parent: 2324,
    },
    {
      nestId: 201035,
      name: "קיום משותף ירושלים",
      code: "22",
      parent: 1205,
    },
    {
      nestId: 201036,
      name: "באר שבע כלניות",
      code: "21",
      parent: 1206,
    },
    {
      nestId: 201037,
      name: "מנרה",
      code: "14",
      parent: 2105,
    },
    {
      nestId: 201038,
      name: "עילבון",
      code: "34",
      parent: 1651,
    },
    {
      nestId: 201050,
      name: "מחוז עמקים",
      code: "99",
      parent: 1200,
    },
    {
      nestId: 201051,
      name: "אלפרעה",
      code: "10",
      parent: 1653,
    },
    {
      nestId: 201052,
      name: "דרום",
      code: "99",
      parent: 1204,
    },
    {
      nestId: 201053,
      name: "נגב",
      code: "99",
      parent: 1206,
    },
    {
      nestId: 201054,
      name: "ירושלים",
      code: "99",
      parent: 1205,
    },
    {
      nestId: 201055,
      name: "נצרת - ביר אלאמיר",
      code: "05",
      parent: 2300,
    },
    {
      nestId: 201100,
      name: "זנוח",
      code: "32",
      parent: 2315,
    },
    {
      nestId: 201101,
      name: "מחסניה",
      code: "33",
      parent: 2315,
    },
    {
      nestId: 201102,
      name: "תירוש",
      code: "34",
      parent: 2315,
    },
    {
      nestId: 201103,
      name: "רחוב",
      code: "12",
      parent: 2304,
    },
    {
      nestId: 201104,
      name: "רוויה",
      code: "13",
      parent: 2304,
    },
    {
      nestId: 201105,
      name: "תל תאומים",
      code: "14",
      parent: 2304,
    },
    {
      nestId: 201106,
      name: "שדי תרומות",
      code: "15",
      parent: 2304,
    },
    {
      nestId: 201150,
      name: "ויצו נהלל",
      code: "01",
      parent: 1200,
    },
    {
      nestId: 201151,
      name: "קלנסווה",
      code: "13",
      parent: 1652,
    },
    {
      nestId: 201152,
      name: "מחוז גליל",
      code: "99",
      parent: 1500,
    },
    {
      nestId: 201153,
      name: "כרמיאל - גבעת רם",
      code: "16",
      parent: 1500,
    },
    {
      nestId: 201154,
      name: "כרמיאל - ניצנים",
      code: "17",
      parent: 1500,
    },
    {
      nestId: 201155,
      name: "חדרה - נווה חיים",
      code: "20",
      parent: 1202,
    },
    {
      nestId: 201156,
      name: "מדרך עוז",
      code: "28",
      parent: 2306,
    },
    {
      nestId: 201157,
      name: "נתניה צפון",
      code: "15",
      parent: 1202,
    },
    {
      nestId: 201158,
      name: "דבוריה",
      code: "53",
      parent: 2300,
    },
    {
      nestId: 201159,
      name: "אולפן רעננה",
      code: "24",
      parent: 1203,
    },
    {
      nestId: 201160,
      name: "מוסינזון",
      code: "25",
      parent: 1203,
    },
    {
      nestId: 201161,
      name: "גרעין חוסן",
      code: "02",
      parent: 2002,
    },
    {
      nestId: 201162,
      name: "סולם",
      code: "09",
      parent: 1651,
    },
    {
      nestId: 201163,
      name: "ערב א-נעים",
      code: "14",
      parent: 1651,
    },
    {
      nestId: 201164,
      name: "קצר א-סר",
      code: "11",
      parent: 1653,
    },
    {
      nestId: 201200,
      name: "ימין אורד",
      code: "36",
      parent: 1202,
    },
    {
      nestId: 201201,
      name: "לוטם",
      code: "15",
      parent: 2103,
    },
  ],
  allNests: [
    {
      nestId: 650,
      nestName: "קרית טבעון",
      nestCode: "14",
    },
    {
      nestId: 651,
      nestName: "רמתיים",
      nestCode: "17",
    },
    {
      nestId: 652,
      nestName: "מעלה אדומים",
      nestCode: "07",
    },
    {
      nestId: 653,
      nestName: "הגבעה הצרפתית",
      nestCode: "10",
    },
    {
      nestId: 654,
      nestName: "קרית יובל",
      nestCode: "20",
    },
    {
      nestId: 656,
      nestName: "מודיעין הנחלים",
      nestCode: "04",
    },
    {
      nestId: 657,
      nestName: "שהם",
      nestCode: "04",
    },
    {
      nestId: 658,
      nestName: "בית שמש",
      nestCode: "06",
    },
    {
      nestId: 659,
      nestName: "פסגת זאב",
      nestCode: "08",
    },
    {
      nestId: 660,
      nestName: "הר חומה",
      nestCode: "21",
    },
    {
      nestId: 661,
      nestName: "פרדסיה",
      nestCode: "15",
    },
    {
      nestId: 663,
      nestName: 'כפ"ס ישן',
      nestCode: "11",
    },
    {
      nestId: 664,
      nestName: 'כפ"ס חדש',
      nestCode: "10",
    },
    {
      nestId: 665,
      nestName: "הנשיאים",
      nestCode: "42",
    },
    {
      nestId: 666,
      nestName: "הדר גנים",
      nestCode: "01",
    },
    {
      nestId: 667,
      nestName: "ראש העין",
      nestCode: "03",
    },
    {
      nestId: 669,
      nestName: "קרית אונו צפון",
      nestCode: "03",
    },
    {
      nestId: 670,
      nestName: "כרמל צרפתי",
      nestCode: "10",
    },
    {
      nestId: 671,
      nestName: "נווה שאנן",
      nestCode: "12",
    },
    {
      nestId: 672,
      nestName: "הדר",
      nestCode: "94",
    },
    {
      nestId: 673,
      nestName: "קרית חיים",
      nestCode: "13",
    },
    {
      nestId: 674,
      nestName: "קרית ים",
      nestCode: "14",
    },
    {
      nestId: 675,
      nestName: "עכו",
      nestCode: "49",
    },
    {
      nestId: 676,
      nestName: "נהריה צפון",
      nestCode: "15",
    },
    {
      nestId: 677,
      nestName: "כרמיאל - רבין",
      nestCode: "03",
    },
    {
      nestId: 679,
      nestName: "זכרון יעקב",
      nestCode: "04",
    },
    {
      nestId: 681,
      nestName: "בנימינה",
      nestCode: "05",
    },
    {
      nestId: 682,
      nestName: "פרדס חנה-כרכור",
      nestCode: "25",
    },
    {
      nestId: 683,
      nestName: "חדרה - בית אליעזר",
      nestCode: "21",
    },
    {
      nestId: 684,
      nestName: "נתניה מזרח",
      nestCode: "09",
    },
    {
      nestId: 685,
      nestName: "קרית נורדאו",
      nestCode: "34",
    },
    {
      nestId: 686,
      nestName: "הרצליה",
      nestCode: "51",
    },
    {
      nestId: 687,
      nestName: "לב העיר",
      nestCode: "06",
    },
    {
      nestId: 688,
      nestName: "כפר שלם",
      nestCode: "02",
    },
    {
      nestId: 689,
      nestName: "בורוכוב",
      nestCode: "01",
    },
    {
      nestId: 691,
      nestName: "מיתר",
      nestCode: "17",
    },
    {
      nestId: 700,
      nestName: "חולון",
      nestCode: "02",
    },
    {
      nestId: 701,
      nestName: "יבנה",
      nestCode: "13",
    },
    {
      nestId: 703,
      nestName: "רמז - ראשון לציון",
      nestCode: "07",
    },
    {
      nestId: 705,
      nestName: "גן יבנה",
      nestCode: "20",
    },
    {
      nestId: 706,
      nestName: "נס ציונה",
      nestCode: "04",
    },
    {
      nestId: 707,
      nestName: "רמלה אפקה",
      nestCode: "05",
    },
    {
      nestId: 708,
      nestName: "לוד גני אביב",
      nestCode: "06",
    },
    {
      nestId: 709,
      nestName: "קרית גנים - המרחב - ראשון לציון",
      nestCode: "05",
    },
    {
      nestId: 710,
      nestName: "חבצלת והחדשה",
      nestCode: "31",
    },
    {
      nestId: 711,
      nestName: "מזכרת בתיה",
      nestCode: "32",
    },
    {
      nestId: 712,
      nestName: "רחובות ההולנדית",
      nestCode: "34",
    },
    {
      nestId: 713,
      nestName: "תל גיבורים",
      nestCode: "10",
    },
    {
      nestId: 714,
      nestName: "ראשון מזרח",
      nestCode: "06",
    },
    {
      nestId: 715,
      nestName: "קרית עקרון",
      nestCode: "42",
    },
    {
      nestId: 719,
      nestName: "מצפה רמון",
      nestCode: "01",
    },
    {
      nestId: 721,
      nestName: "ערד",
      nestCode: "11",
    },
    {
      nestId: 722,
      nestName: "נווה נוי",
      nestCode: "12",
    },
    {
      nestId: 723,
      nestName: "נווה זאב",
      nestCode: "13",
    },
    {
      nestId: 725,
      nestName: "שדרות",
      nestCode: "20",
    },
    {
      nestId: 726,
      nestName: "אופקים",
      nestCode: "33",
    },
    {
      nestId: 727,
      nestName: "אשדוד דרום",
      nestCode: "51",
    },
    {
      nestId: 729,
      nestName: "קן ט'",
      nestCode: "46",
    },
    {
      nestId: 734,
      nestName: "מרכז ט'",
      nestCode: "47",
    },
    {
      nestId: 750,
      nestName: "ראש פינה",
      nestCode: "04",
    },
    {
      nestId: 801,
      nestName: "נווה יעקב",
      nestCode: "70",
    },
    {
      nestId: 802,
      nestName: "כפר תבור",
      nestCode: "51",
    },
    {
      nestId: 803,
      nestName: 'מ"א עמק הירדן',
      nestCode: "99",
    },
    {
      nestId: 804,
      nestName: "רמת ישי",
      nestCode: "12",
    },
    {
      nestId: 805,
      nestName: "מגדל העמק",
      nestCode: "22",
    },
    {
      nestId: 806,
      nestName: "נוף הגליל",
      nestCode: "23",
    },
    {
      nestId: 807,
      nestName: "קן עפולה",
      nestCode: "24",
    },
    {
      nestId: 808,
      nestName: "סניף קרית שמונה",
      nestCode: "14",
    },
    {
      nestId: 809,
      nestName: "טבריה",
      nestCode: "32",
    },
    {
      nestId: 810,
      nestName: "פרוד",
      nestCode: "05",
    },
    {
      nestId: 955,
      nestName: "קרית ביאליק הבונים",
      nestCode: "01",
    },
    {
      nestId: 1050,
      nestName: "ג'וליס",
      nestCode: "10",
    },
    {
      nestId: 1100,
      nestName: "בית ג'אן",
      nestCode: "20",
    },
    {
      nestId: 1101,
      nestName: "כסרא",
      nestCode: "03",
    },
    {
      nestId: 1102,
      nestName: "כפר סמיע",
      nestCode: "12",
    },
    {
      nestId: 1103,
      nestName: "מע'אר",
      nestCode: "21",
    },
    {
      nestId: 1104,
      nestName: "ינוח",
      nestCode: "23",
    },
    {
      nestId: 1105,
      nestName: "ג'ת",
      nestCode: "15",
    },
    {
      nestId: 1106,
      nestName: "חורפיש",
      nestCode: "17",
    },
    {
      nestId: 1107,
      nestName: "ירכא",
      nestCode: "09",
    },
    {
      nestId: 1108,
      nestName: "עוספיה",
      nestCode: "14",
    },
    {
      nestId: 1150,
      nestName: "קרית אתא",
      nestCode: "50",
    },
    {
      nestId: 1200,
      nestName: "קן יא באר שבע",
      nestCode: "48",
    },
    {
      nestId: 1201,
      nestName: "קן אשדוד ים",
      nestCode: "53",
    },
    {
      nestId: 1251,
      nestName: 'מ"א מרום גליל',
      nestCode: "99",
    },
    {
      nestId: 1257,
      nestName: "נס עמים",
      nestCode: "50",
    },
    {
      nestId: 1259,
      nestName: 'מ"א גזר',
      nestCode: "99",
    },
    {
      nestId: 1260,
      nestName: "נען",
      nestCode: "02",
    },
    {
      nestId: 1261,
      nestName: "נצר סרני",
      nestCode: "01",
    },
    {
      nestId: 1266,
      nestName: "ברור חיל",
      nestCode: "01",
    },
    {
      nestId: 1269,
      nestName: "רביבים",
      nestCode: "12",
    },
    {
      nestId: 1270,
      nestName: "יסוד המעלה",
      nestCode: "01",
    },
    {
      nestId: 1271,
      nestName: "פתח תקווה החורשה",
      nestCode: "02",
    },
    {
      nestId: 1301,
      nestName: "כמון",
      nestCode: "11",
    },
    {
      nestId: 1302,
      nestName: "הר חלוץ",
      nestCode: "10",
    },
    {
      nestId: 1303,
      nestName: "טל-אל",
      nestCode: "08",
    },
    {
      nestId: 1304,
      nestName: "שכורנית",
      nestCode: "09",
    },
    {
      nestId: 1305,
      nestName: "יובלים",
      nestCode: "12",
    },
    {
      nestId: 1307,
      nestName: "עצמון",
      nestCode: "14",
    },
    {
      nestId: 1308,
      nestName: "מצפה אביב",
      nestCode: "13",
    },
    {
      nestId: 1350,
      nestName: "גשר הזיו",
      nestCode: "31",
    },
    {
      nestId: 1351,
      nestName: "רגבה",
      nestCode: "49",
    },
    {
      nestId: 1352,
      nestName: "לוחמי הגטאות",
      nestCode: "48",
    },
    {
      nestId: 1353,
      nestName: "ראש הנקרה",
      nestCode: "47",
    },
    {
      nestId: 1354,
      nestName: 'מ"א מגילות',
      nestCode: "99",
    },
    {
      nestId: 1355,
      nestName: "שפיים",
      nestCode: "78",
    },
    {
      nestId: 1358,
      nestName: "צרעה",
      nestCode: "03",
    },
    {
      nestId: 1359,
      nestName: "שואבה",
      nestCode: "04",
    },
    {
      nestId: 1360,
      nestName: "מעלה החמישה",
      nestCode: "05",
    },
    {
      nestId: 1361,
      nestName: "קרית ענבים",
      nestCode: "01",
    },
    {
      nestId: 1362,
      nestName: "רמת רחל",
      nestCode: "02",
    },
    {
      nestId: 1363,
      nestName: "משמר הנגב",
      nestCode: "02",
    },
    {
      nestId: 1365,
      nestName: "רקפת",
      nestCode: "07",
    },
    {
      nestId: 1366,
      nestName: "אורים",
      nestCode: "02",
    },
    {
      nestId: 1367,
      nestName: "רעים",
      nestCode: "01",
    },
    {
      nestId: 1368,
      nestName: "כיסופים",
      nestCode: "03",
    },
    {
      nestId: 1369,
      nestName: "עין השלושה",
      nestCode: "04",
    },
    {
      nestId: 1370,
      nestName: "אור הנר",
      nestCode: "03",
    },
    {
      nestId: 1371,
      nestName: "מפלסים",
      nestCode: "05",
    },
    {
      nestId: 1372,
      nestName: "ניר עם",
      nestCode: "09",
    },
    {
      nestId: 1374,
      nestName: "גבים",
      nestCode: "07",
    },
    {
      nestId: 1375,
      nestName: "רוחמה",
      nestCode: "02",
    },
    {
      nestId: 1376,
      nestName: "ארז",
      nestCode: "06",
    },
    {
      nestId: 1377,
      nestName: "יכיני",
      nestCode: "04",
    },
    {
      nestId: 1378,
      nestName: "דורות",
      nestCode: "08",
    },
    {
      nestId: 1379,
      nestName: "נחל עוז",
      nestCode: "10",
    },
    {
      nestId: 1400,
      nestName: "מצפה שלם",
      nestCode: "02",
    },
    {
      nestId: 1401,
      nestName: "קליה",
      nestCode: "05",
    },
    {
      nestId: 1402,
      nestName: "אלמוג",
      nestCode: "04",
    },
    {
      nestId: 1403,
      nestName: "ורד יריחו",
      nestCode: "03",
    },
    {
      nestId: 1404,
      nestName: "בית הערבה",
      nestCode: "01",
    },
    {
      nestId: 1450,
      nestName: "קיסריה",
      nestCode: "03",
    },
    {
      nestId: 1501,
      nestName: "תובל",
      nestCode: "05",
    },
    {
      nestId: 1502,
      nestName: "אבטליון",
      nestCode: "03",
    },
    {
      nestId: 1503,
      nestName: "הררית יחד",
      nestCode: "06",
    },
    {
      nestId: 1550,
      nestName: 'רמב"ם - הביתלה - ראשון לציון',
      nestCode: "15",
    },
    {
      nestId: 1552,
      nestName: "מועדון ספיר",
      nestCode: "07",
    },
    {
      nestId: 1553,
      nestName: "אשדוד מרכז",
      nestCode: "52",
    },
    {
      nestId: 1554,
      nestName: "עמיעד",
      nestCode: "02",
    },
    {
      nestId: 1555,
      nestName: 'מ"א אשכול',
      nestCode: "99",
    },
    {
      nestId: 1556,
      nestName: "איילת השחר",
      nestCode: "07",
    },
    {
      nestId: 1557,
      nestName: "מחניים",
      nestCode: "06",
    },
    {
      nestId: 1558,
      nestName: "יפתח",
      nestCode: "05",
    },
    {
      nestId: 1559,
      nestName: "כפר גלעדי",
      nestCode: "03",
    },
    {
      nestId: 1560,
      nestName: "מעין ברוך",
      nestCode: "08",
    },
    {
      nestId: 1561,
      nestName: "הגושרים",
      nestCode: "01",
    },
    {
      nestId: 1562,
      nestName: "גדות",
      nestCode: "04",
    },
    {
      nestId: 1563,
      nestName: 'מ"א שער הנגב',
      nestCode: "99",
    },
    {
      nestId: 1564,
      nestName: "דגניה א",
      nestCode: "08",
    },
    {
      nestId: 1565,
      nestName: "דגניה ב",
      nestCode: "09",
    },
    {
      nestId: 1566,
      nestName: "אפיקים",
      nestCode: "03",
    },
    {
      nestId: 1567,
      nestName: "שער הגולן/מסדה",
      nestCode: "18",
    },
    {
      nestId: 1568,
      nestName: "בית זרע",
      nestCode: "05",
    },
    {
      nestId: 1569,
      nestName: "מעגן",
      nestCode: "13",
    },
    {
      nestId: 1570,
      nestName: "אלומות",
      nestCode: "01",
    },
    {
      nestId: 1571,
      nestName: "אשדות יעקב",
      nestCode: "04",
    },
    {
      nestId: 1572,
      nestName: "נווה עובד",
      nestCode: "14",
    },
    {
      nestId: 1573,
      nestName: "חוקוק",
      nestCode: "10",
    },
    {
      nestId: 1574,
      nestName: "גינוסר",
      nestCode: "06",
    },
    {
      nestId: 1575,
      nestName: "אלמגור",
      nestCode: "02",
    },
    {
      nestId: 1576,
      nestName: "לבנים",
      nestCode: "06",
    },
    {
      nestId: 1577,
      nestName: "מגדל",
      nestCode: "20",
    },
    {
      nestId: 1578,
      nestName: "עין גב",
      nestCode: "15",
    },
    {
      nestId: 1579,
      nestName: "פוריה עילית",
      nestCode: "16",
    },
    {
      nestId: 1580,
      nestName: "גשר",
      nestCode: "01",
    },
    {
      nestId: 1581,
      nestName: "קיבוץ כנרת",
      nestCode: "17",
    },
    {
      nestId: 1582,
      nestName: "קרית מוצקין",
      nestCode: "28",
    },
    {
      nestId: 1601,
      nestName: "חרשים",
      nestCode: "02",
    },
    {
      nestId: 1609,
      nestName: "אאא",
      nestCode: "98",
    },
    {
      nestId: 1612,
      nestName: "ברנע אשקלון",
      nestCode: "09",
    },
    {
      nestId: 1613,
      nestName: 'מ"א גליל עליון',
      nestCode: "99",
    },
    {
      nestId: 1651,
      nestName: "חיפה הטכני",
      nestCode: "08",
    },
    {
      nestId: 1654,
      nestName: "סניף גילה",
      nestCode: "11",
    },
    {
      nestId: 1655,
      nestName: "לוד",
      nestCode: "11",
    },
    {
      nestId: 1658,
      nestName: "פתח תקווה עין גנים",
      nestCode: "12",
    },
    {
      nestId: 1660,
      nestName: "רמת אליהו - ראשון לציון",
      nestCode: "22",
    },
    {
      nestId: 1661,
      nestName: "סניף רמלה",
      nestCode: "13",
    },
    {
      nestId: 1662,
      nestName: "סניף אשקלון",
      nestCode: "04",
    },
    {
      nestId: 1800,
      nestName: "אשקלון דרום",
      nestCode: "06",
    },
    {
      nestId: 1850,
      nestName: "בית שאן",
      nestCode: "30",
    },
    {
      nestId: 1851,
      nestName: "בני המושבים ארצי",
      nestCode: "01",
    },
    {
      nestId: 1852,
      nestName: "נווה עופר",
      nestCode: "20",
    },
    {
      nestId: 1900,
      nestName: "אשדוד אורט ימי",
      nestCode: "90",
    },
    {
      nestId: 1901,
      nestName: "עפולה עילית",
      nestCode: "27",
    },
    {
      nestId: 1902,
      nestName: "מבשרת ציון",
      nestCode: "03",
    },
    {
      nestId: 1903,
      nestName: "נהריה הירוקה",
      nestCode: "07",
    },
    {
      nestId: 1904,
      nestName: "עמל רמת דוד",
      nestCode: "62",
    },
    {
      nestId: 1905,
      nestName: "חיפה קטרפילר",
      nestCode: "44",
    },
    {
      nestId: 1906,
      nestName: "סניף בת גלים",
      nestCode: "07",
    },
    {
      nestId: 1907,
      nestName: "עמל טק אין",
      nestCode: "52",
    },
    {
      nestId: 1908,
      nestName: "אורט תעשייה אווירית",
      nestCode: "53",
    },
    {
      nestId: 1909,
      nestName: "אורט בית הערבה",
      nestCode: "54",
    },
    {
      nestId: 1910,
      nestName: "עתיד פלמחים",
      nestCode: "55",
    },
    {
      nestId: 1912,
      nestName: "בת ים",
      nestCode: "01",
    },
    {
      nestId: 1913,
      nestName: "ראשון מרכז - עבודה + - ראשון לציון",
      nestCode: "19",
    },
    {
      nestId: 1915,
      nestName: "אורט צריפין",
      nestCode: "58",
    },
    {
      nestId: 1916,
      nestName: "אורט תל נוף",
      nestCode: "59",
    },
    {
      nestId: 1917,
      nestName: "כפר מנדא",
      nestCode: "51",
    },
    {
      nestId: 1918,
      nestName: "אעבלין",
      nestCode: "52",
    },
    {
      nestId: 1919,
      nestName: "קיום משותף סח'נין",
      nestCode: "53",
    },
    {
      nestId: 1920,
      nestName: "מנשייה זבדה",
      nestCode: "54",
    },
    {
      nestId: 1921,
      nestName: "כמאנה",
      nestCode: "16",
    },
    {
      nestId: 1924,
      nestName: "יפו",
      nestCode: "17",
    },
    {
      nestId: 1925,
      nestName: "קיום משותף רהט",
      nestCode: "51",
    },
    {
      nestId: 1926,
      nestName: "שגב שלום",
      nestCode: "09",
    },
    {
      nestId: 1950,
      nestName: "שלומי",
      nestCode: "05",
    },
    {
      nestId: 1951,
      nestName: "מודיעין כרמים",
      nestCode: "12",
    },
    {
      nestId: 2000,
      nestName: "קרית בורוכוב",
      nestCode: "07",
    },
    {
      nestId: 2050,
      nestName: "שכבת יב",
      nestCode: "01",
    },
    {
      nestId: 2051,
      nestName: "דיר אל אסד",
      nestCode: "20",
    },
    {
      nestId: 2052,
      nestName: "עין מאהל",
      nestCode: "01",
    },
    {
      nestId: 2100,
      nestName: "רמת גן הראשונים",
      nestCode: "04",
    },
    {
      nestId: 2201,
      nestName: "קורנית",
      nestCode: "01",
    },
    {
      nestId: 2300,
      nestName: "חיפה התיכון החברתי",
      nestCode: "93",
    },
    {
      nestId: 2301,
      nestName: "יפו ד'",
      nestCode: "09",
    },
    {
      nestId: 2350,
      nestName: "רכס הכרמל",
      nestCode: "54",
    },
    {
      nestId: 2400,
      nestName: "יהוד",
      nestCode: "7",
    },
    {
      nestId: 2401,
      nestName: "רחובות היובל (לא פעיל)",
      nestCode: "54",
    },
    {
      nestId: 2406,
      nestName: "דלית אל כרמל",
      nestCode: "13",
    },
    {
      nestId: 2450,
      nestName: "פקיעין",
      nestCode: "19",
    },
    {
      nestId: 2451,
      nestName: "מסעדה",
      nestCode: "04",
    },
    {
      nestId: 2452,
      nestName: "מגדל שמס",
      nestCode: "01",
    },
    {
      nestId: 2453,
      nestName: "בוקעאת'א",
      nestCode: "16",
    },
    {
      nestId: 2500,
      nestName: "אמירים",
      nestCode: "09",
    },
    {
      nestId: 2501,
      nestName: "בארי",
      nestCode: "05",
    },
    {
      nestId: 2502,
      nestName: 'מ"א משגב',
      nestCode: "99",
    },
    {
      nestId: 2503,
      nestName: 'מ"א מטה אשר',
      nestCode: "99",
    },
    {
      nestId: 2504,
      nestName: "אביבים",
      nestCode: "08",
    },
    {
      nestId: 2505,
      nestName: "ריחאניה",
      nestCode: "11",
    },
    {
      nestId: 2506,
      nestName: "כפר חנניה",
      nestCode: "10",
    },
    {
      nestId: 2507,
      nestName: "שפר",
      nestCode: "07",
    },
    {
      nestId: 2508,
      nestName: "שזור",
      nestCode: "03",
    },
    {
      nestId: 2509,
      nestName: "ספסופה (כפר חושן)",
      nestCode: "02",
    },
    {
      nestId: 2510,
      nestName: "כפר שמאי",
      nestCode: "01",
    },
    {
      nestId: 2511,
      nestName: "דובב",
      nestCode: "04",
    },
    {
      nestId: 2512,
      nestName: "תל קציר",
      nestCode: "19",
    },
    {
      nestId: 2513,
      nestName: "כנרת מושבה",
      nestCode: "12",
    },
    {
      nestId: 2550,
      nestName: "סאג'ור",
      nestCode: "22",
    },
    {
      nestId: 2600,
      nestName: "עין ק'יניא",
      nestCode: "08",
    },
    {
      nestId: 2650,
      nestName: "יקנעם עילית",
      nestCode: "50",
    },
    {
      nestId: 2651,
      nestName: "כפר יונה",
      nestCode: "58",
    },
    {
      nestId: 2652,
      nestName: "אבן יהודה",
      nestCode: "59",
    },
    {
      nestId: 2653,
      nestName: "באר יעקב הצפון",
      nestCode: "53",
    },
    {
      nestId: 2654,
      nestName: "פתח תקווה שיפר נווה דקלים",
      nestCode: "54",
    },
    {
      nestId: 2655,
      nestName: "פתח תקווה - כפר גנים ג'",
      nestCode: "55",
    },
    {
      nestId: 2656,
      nestName: "נתניה גלי ים",
      nestCode: "08",
    },
    {
      nestId: 2657,
      nestName: "ירושלים מרכז",
      nestCode: "57",
    },
    {
      nestId: 2700,
      nestName: "חריש",
      nestCode: "80",
    },
    {
      nestId: 2701,
      nestName: "סניף דימונה",
      nestCode: "16",
    },
    {
      nestId: 2702,
      nestName: "חצור הגלילית",
      nestCode: "09",
    },
    {
      nestId: 2704,
      nestName: "הר גילה",
      nestCode: "09",
    },
    {
      nestId: 2705,
      nestName: "פתח תקווה שעריה",
      nestCode: "56",
    },
    {
      nestId: 2750,
      nestName: "סניף צפת",
      nestCode: "10",
    },
    {
      nestId: 2800,
      nestName: "יבנה הירוקה",
      nestCode: "18",
    },
    {
      nestId: 2801,
      nestName: "גדרה",
      nestCode: "43",
    },
    {
      nestId: 2802,
      nestName: "רמת השרון",
      nestCode: "04",
    },
    {
      nestId: 2803,
      nestName: "סניף נתיבות",
      nestCode: "80",
    },
    {
      nestId: 2850,
      nestName: "באר שבע רמות הרכס",
      nestCode: "36",
    },
    {
      nestId: 2851,
      nestName: "נתניה רבין",
      nestCode: "14",
    },
    {
      nestId: 2852,
      nestName: "ראש העין פסגות אפק",
      nestCode: "08",
    },
    {
      nestId: 2900,
      nestName: 'ת"א ביצרון',
      nestCode: "11",
    },
    {
      nestId: 2901,
      nestName: "קיום משותף לקיה",
      nestCode: "53",
    },
    {
      nestId: 2950,
      nestName: "נחלת יצחק",
      nestCode: "12",
    },
    {
      nestId: 2951,
      nestName: "ראמה",
      nestCode: "24",
    },
    {
      nestId: 3050,
      nestName: "צורן-קדימה",
      nestCode: "01",
    },
    {
      nestId: 3051,
      nestName: "אור יהודה",
      nestCode: "16",
    },
    {
      nestId: 3100,
      nestName: "קן בארי באר שבע",
      nestCode: "49",
    },
    {
      nestId: 3150,
      nestName: "אבו סנאן",
      nestCode: "25",
    },
    {
      nestId: 3200,
      nestName: 'ת"א התיכון החברתי',
      nestCode: "70",
    },
    {
      nestId: 3201,
      nestName: "ירושלים חושן",
      nestCode: "71",
    },
    {
      nestId: 3203,
      nestName: "מכינת יפתח",
      nestCode: "73",
    },
    {
      nestId: 3204,
      nestName: "נעלה",
      nestCode: "74",
    },
    {
      nestId: 3206,
      nestName: 'סניף קמ"ג',
      nestCode: "19",
    },
    {
      nestId: 3207,
      nestName: "דרור גליל",
      nestCode: "79",
    },
    {
      nestId: 3300,
      nestName: 'כפ"ס הירוקה',
      nestCode: "09",
    },
    {
      nestId: 3350,
      nestName: "עמיחי",
      nestCode: "76",
    },
    {
      nestId: 3351,
      nestName: "בת ים החוף",
      nestCode: "11",
    },
    {
      nestId: 3352,
      nestName: "צור יצחק",
      nestCode: "63",
    },
    {
      nestId: 3354,
      nestName: "מעלות-תרשיחא",
      nestCode: "02",
    },
    {
      nestId: 3355,
      nestName: "סניף קרית גת",
      nestCode: "35",
    },
    {
      nestId: 3356,
      nestName: "דיר חנא",
      nestCode: "60",
    },
    {
      nestId: 3357,
      nestName: "כפר סילבר",
      nestCode: "50",
    },
    {
      nestId: 3400,
      nestName: "חברת הנוער אשבל",
      nestCode: "79",
    },
    {
      nestId: 3450,
      nestName: "כפר עבודה",
      nestCode: "11",
    },
    {
      nestId: 3453,
      nestName: "אוהד",
      nestCode: "01",
    },
    {
      nestId: 3454,
      nestName: "שדה ניצן",
      nestCode: "02",
    },
    {
      nestId: 3455,
      nestName: "תלמי אליהו",
      nestCode: "03",
    },
    {
      nestId: 3456,
      nestName: "מבטחים",
      nestCode: "04",
    },
    {
      nestId: 3457,
      nestName: "עמיעוז",
      nestCode: "05",
    },
    {
      nestId: 3458,
      nestName: "אבשלום",
      nestCode: "06",
    },
    {
      nestId: 3459,
      nestName: "דקל",
      nestCode: "07",
    },
    {
      nestId: 3460,
      nestName: "יבול",
      nestCode: "08",
    },
    {
      nestId: 3461,
      nestName: "יתד",
      nestCode: "09",
    },
    {
      nestId: 3462,
      nestName: "פרי גן",
      nestCode: "10",
    },
    {
      nestId: 3463,
      nestName: "שדי אברהם",
      nestCode: "11",
    },
    {
      nestId: 3464,
      nestName: "תלמי יוסף",
      nestCode: "12",
    },
    {
      nestId: 3465,
      nestName: "ישע",
      nestCode: "13",
    },
    {
      nestId: 3466,
      nestName: "סופה",
      nestCode: "14",
    },
    {
      nestId: 3467,
      nestName: "עין הבשור",
      nestCode: "15",
    },
    {
      nestId: 3468,
      nestName: "צאלים",
      nestCode: "16",
    },
    {
      nestId: 3469,
      nestName: "צוחר",
      nestCode: "17",
    },
    {
      nestId: 3470,
      nestName: "אביגדור",
      nestCode: "01",
    },
    {
      nestId: 3471,
      nestName: "אורות",
      nestCode: "02",
    },
    {
      nestId: 3472,
      nestName: "אמונים",
      nestCode: "03",
    },
    {
      nestId: 3474,
      nestName: "בית עזרא",
      nestCode: "05",
    },
    {
      nestId: 3475,
      nestName: "ביצרון",
      nestCode: "06",
    },
    {
      nestId: 3476,
      nestName: "גבעתי",
      nestCode: "07",
    },
    {
      nestId: 3477,
      nestName: "חצב",
      nestCode: "08",
    },
    {
      nestId: 3478,
      nestName: "ינון",
      nestCode: "09",
    },
    {
      nestId: 3479,
      nestName: "כפר אחים",
      nestCode: "10",
    },
    {
      nestId: 3480,
      nestName: "כפר ורבורג",
      nestCode: "11",
    },
    {
      nestId: 3481,
      nestName: "נווה מבטח",
      nestCode: "12",
    },
    {
      nestId: 3482,
      nestName: "ניר בנים",
      nestCode: "13",
    },
    {
      nestId: 3483,
      nestName: "עזר",
      nestCode: "14",
    },
    {
      nestId: 3484,
      nestName: "עזריקם",
      nestCode: "15",
    },
    {
      nestId: 3485,
      nestName: "ערוגות",
      nestCode: "16",
    },
    {
      nestId: 3486,
      nestName: "שדה עוזיהו",
      nestCode: "17",
    },
    {
      nestId: 3487,
      nestName: "שתולים",
      nestCode: "18",
    },
    {
      nestId: 3488,
      nestName: "תלמי יחיאל",
      nestCode: "19",
    },
    {
      nestId: 3489,
      nestName: "בית שקמה",
      nestCode: "01",
    },
    {
      nestId: 3490,
      nestName: "בת הדר",
      nestCode: "02",
    },
    {
      nestId: 3491,
      nestName: "גיאה",
      nestCode: "03",
    },
    {
      nestId: 3492,
      nestName: "הודייה",
      nestCode: "04",
    },
    {
      nestId: 3493,
      nestName: "חלץ",
      nestCode: "05",
    },
    {
      nestId: 3494,
      nestName: "כוכב מיכאל",
      nestCode: "06",
    },
    {
      nestId: 3495,
      nestName: "מבקיעים",
      nestCode: "07",
    },
    {
      nestId: 3496,
      nestName: "משען",
      nestCode: "08",
    },
    {
      nestId: 3497,
      nestName: "ניר ישראל",
      nestCode: "09",
    },
    {
      nestId: 3498,
      nestName: "נתיב העשרה",
      nestCode: "10",
    },
    {
      nestId: 3499,
      nestName: "תלמי יפה",
      nestCode: "11",
    },
    {
      nestId: 3500,
      nestName: "אחוזם",
      nestCode: "01",
    },
    {
      nestId: 3501,
      nestName: "אמציה",
      nestCode: "02",
    },
    {
      nestId: 3502,
      nestName: "זוהר",
      nestCode: "03",
    },
    {
      nestId: 3503,
      nestName: "יד נתן",
      nestCode: "04",
    },
    {
      nestId: 3504,
      nestName: "לכיש",
      nestCode: "05",
    },
    {
      nestId: 3505,
      nestName: "מנוחה",
      nestCode: "06",
    },
    {
      nestId: 3506,
      nestName: "נהורה",
      nestCode: "07",
    },
    {
      nestId: 3507,
      nestName: "נוגה",
      nestCode: "08",
    },
    {
      nestId: 3508,
      nestName: 'ניר ח"ן',
      nestCode: "09",
    },
    {
      nestId: 3509,
      nestName: "עוצם",
      nestCode: "10",
    },
    {
      nestId: 3510,
      nestName: "שדה דוד",
      nestCode: "11",
    },
    {
      nestId: 3511,
      nestName: "שדה משה",
      nestCode: "12",
    },
    {
      nestId: 3512,
      nestName: "שחר",
      nestCode: "13",
    },
    {
      nestId: 3513,
      nestName: "אליאב",
      nestCode: "14",
    },
    {
      nestId: 3514,
      nestName: "שקף",
      nestCode: "15",
    },
    {
      nestId: 3515,
      nestName: "תלמים",
      nestCode: "16",
    },
    {
      nestId: 3516,
      nestName: "אביעזר",
      nestCode: "01",
    },
    {
      nestId: 3517,
      nestName: "אבן ספיר",
      nestCode: "02",
    },
    {
      nestId: 3518,
      nestName: "אורה",
      nestCode: "03",
    },
    {
      nestId: 3519,
      nestName: "אשתאול",
      nestCode: "04",
    },
    {
      nestId: 3520,
      nestName: "בית נקופה",
      nestCode: "05",
    },
    {
      nestId: 3521,
      nestName: "בקוע",
      nestCode: "06",
    },
    {
      nestId: 3522,
      nestName: "בר גיורא",
      nestCode: "07",
    },
    {
      nestId: 3523,
      nestName: "גבעת יערים",
      nestCode: "08",
    },
    {
      nestId: 3524,
      nestName: "גבעת ישעיהו",
      nestCode: "09",
    },
    {
      nestId: 3525,
      nestName: "גפן",
      nestCode: "10",
    },
    {
      nestId: 3526,
      nestName: "זכריה",
      nestCode: "11",
    },
    {
      nestId: 3527,
      nestName: "טל שחר",
      nestCode: "12",
    },
    {
      nestId: 3528,
      nestName: "כסלון",
      nestCode: "13",
    },
    {
      nestId: 3529,
      nestName: "כפר אוריה",
      nestCode: "14",
    },
    {
      nestId: 3530,
      nestName: "לוזית",
      nestCode: "15",
    },
    {
      nestId: 3531,
      nestName: "מבוא ביתר",
      nestCode: "16",
    },
    {
      nestId: 3532,
      nestName: "מוצא עילית",
      nestCode: "17",
    },
    {
      nestId: 3533,
      nestName: "מטע",
      nestCode: "18",
    },
    {
      nestId: 3534,
      nestName: "מסילת ציון",
      nestCode: "19",
    },
    {
      nestId: 3535,
      nestName: "נווה אילן",
      nestCode: "20",
    },
    {
      nestId: 3536,
      nestName: "נטף",
      nestCode: "21",
    },
    {
      nestId: 3537,
      nestName: "נס הרים",
      nestCode: "22",
    },
    {
      nestId: 3538,
      nestName: "עגור",
      nestCode: "23",
    },
    {
      nestId: 3539,
      nestName: "עמינדב",
      nestCode: "24",
    },
    {
      nestId: 3540,
      nestName: "צפרירים",
      nestCode: "25",
    },
    {
      nestId: 3541,
      nestName: "גיזו",
      nestCode: "26",
    },
    {
      nestId: 3542,
      nestName: "צלפון",
      nestCode: "27",
    },
    {
      nestId: 3543,
      nestName: "נווה מיכאל",
      nestCode: "28",
    },
    {
      nestId: 3544,
      nestName: "רמת רזיאל",
      nestCode: "29",
    },
    {
      nestId: 3545,
      nestName: "שדה מיכה",
      nestCode: "30",
    },
    {
      nestId: 3546,
      nestName: "תעוז",
      nestCode: "31",
    },
    {
      nestId: 3547,
      nestName: "נבטים",
      nestCode: "01",
    },
    {
      nestId: 3548,
      nestName: "חצבה",
      nestCode: "01",
    },
    {
      nestId: 3549,
      nestName: "ספיר",
      nestCode: "02",
    },
    {
      nestId: 3550,
      nestName: "עידן",
      nestCode: "03",
    },
    {
      nestId: 3551,
      nestName: "עין יהב",
      nestCode: "04",
    },
    {
      nestId: 3552,
      nestName: "פארן",
      nestCode: "05",
    },
    {
      nestId: 3553,
      nestName: "צופר",
      nestCode: "06",
    },
    {
      nestId: 3554,
      nestName: "צוקים",
      nestCode: "07",
    },
    {
      nestId: 3555,
      nestName: "אשלים",
      nestCode: "01",
    },
    {
      nestId: 3556,
      nestName: "באר מילכה",
      nestCode: "02",
    },
    {
      nestId: 3557,
      nestName: "טללים",
      nestCode: "03",
    },
    {
      nestId: 3558,
      nestName: "מדרשת בן גוריון",
      nestCode: "04",
    },
    {
      nestId: 3559,
      nestName: "משאבי שדה",
      nestCode: "05",
    },
    {
      nestId: 3560,
      nestName: "ניצנה (קהילת חינוך)",
      nestCode: "06",
    },
    {
      nestId: 3561,
      nestName: "כמהין",
      nestCode: "07",
    },
    {
      nestId: 3562,
      nestName: "ניצני סיני",
      nestCode: "08",
    },
    {
      nestId: 3563,
      nestName: "עזוז",
      nestCode: "09",
    },
    {
      nestId: 3564,
      nestName: "מחנה טלי",
      nestCode: "10",
    },
    {
      nestId: 3565,
      nestName: "שדה בוקר",
      nestCode: "11",
    },
    {
      nestId: 3566,
      nestName: "אביאל",
      nestCode: "01",
    },
    {
      nestId: 3567,
      nestName: 'גבעת ניל"י',
      nestCode: "02",
    },
    {
      nestId: 3568,
      nestName: "עמיקם",
      nestCode: "03",
    },
    {
      nestId: 3569,
      nestName: "אליכין",
      nestCode: "35",
    },
    {
      nestId: 3570,
      nestName: "בית אלעזרי",
      nestCode: "01",
    },
    {
      nestId: 3571,
      nestName: "בניה",
      nestCode: "02",
    },
    {
      nestId: 3572,
      nestName: "גבעת ברנר",
      nestCode: "03",
    },
    {
      nestId: 3573,
      nestName: "גינתון",
      nestCode: "05",
    },
    {
      nestId: 3574,
      nestName: "גן שלמה",
      nestCode: "15",
    },
    {
      nestId: 3575,
      nestName: "קדרון",
      nestCode: "06",
    },
    {
      nestId: 3576,
      nestName: "תל נוף",
      nestCode: "07",
    },
    {
      nestId: 3577,
      nestName: "בית עוזיאל",
      nestCode: "01",
    },
    {
      nestId: 3578,
      nestName: "גזר",
      nestCode: "03",
    },
    {
      nestId: 3579,
      nestName: "גני יוחנן",
      nestCode: "03",
    },
    {
      nestId: 3580,
      nestName: "חולדה",
      nestCode: "04",
    },
    {
      nestId: 3581,
      nestName: "יציץ",
      nestCode: "05",
    },
    {
      nestId: 3582,
      nestName: "ישרש",
      nestCode: "06",
    },
    {
      nestId: 3583,
      nestName: 'כפר ביל"ו',
      nestCode: "07",
    },
    {
      nestId: 3584,
      nestName: "מצליח",
      nestCode: "08",
    },
    {
      nestId: 3585,
      nestName: "משמר איילון",
      nestCode: "09",
    },
    {
      nestId: 3586,
      nestName: "משמר דוד",
      nestCode: "10",
    },
    {
      nestId: 3587,
      nestName: "עזריה",
      nestCode: "11",
    },
    {
      nestId: 3588,
      nestName: "פדיה",
      nestCode: "12",
    },
    {
      nestId: 3589,
      nestName: "גני הדר",
      nestCode: "13",
    },
    {
      nestId: 3590,
      nestName: "רמות מאיר",
      nestCode: "14",
    },
    {
      nestId: 3591,
      nestName: "אלישמע",
      nestCode: "01",
    },
    {
      nestId: 3592,
      nestName: 'גבעת ח"ן',
      nestCode: "02",
    },
    {
      nestId: 3593,
      nestName: "גן חיים",
      nestCode: "03",
    },
    {
      nestId: 3594,
      nestName: "צופית",
      nestCode: "04",
    },
    {
      nestId: 3595,
      nestName: "גני עם",
      nestCode: "05",
    },
    {
      nestId: 3596,
      nestName: "ירקונה",
      nestCode: "06",
    },
    {
      nestId: 3597,
      nestName: "נווה ירק",
      nestCode: "07",
    },
    {
      nestId: 3598,
      nestName: "עדנים",
      nestCode: "08",
    },
    {
      nestId: 3599,
      nestName: "חגור",
      nestCode: "09",
    },
    {
      nestId: 3600,
      nestName: "ירחיב",
      nestCode: "10",
    },
    {
      nestId: 3601,
      nestName: "כפר סירקין",
      nestCode: "11",
    },
    {
      nestId: 3602,
      nestName: "נווה ימין",
      nestCode: "12",
    },
    {
      nestId: 3603,
      nestName: "נירית",
      nestCode: "13",
    },
    {
      nestId: 3604,
      nestName: "גת רימון",
      nestCode: "14",
    },
    {
      nestId: 3605,
      nestName: "מעש",
      nestCode: "15",
    },
    {
      nestId: 3606,
      nestName: "שדי חמד",
      nestCode: "16",
    },
    {
      nestId: 3607,
      nestName: "בית נחמיה",
      nestCode: "01",
    },
    {
      nestId: 3608,
      nestName: "בן שמן (מושב)",
      nestCode: "02",
    },
    {
      nestId: 3609,
      nestName: "בני עטרות",
      nestCode: "03",
    },
    {
      nestId: 3610,
      nestName: 'גבעת כ"ח',
      nestCode: "04",
    },
    {
      nestId: 3612,
      nestName: "כפר דניאל",
      nestCode: "06",
    },
    {
      nestId: 3613,
      nestName: "כפר טרומן",
      nestCode: "07",
    },
    {
      nestId: 3614,
      nestName: "מזור",
      nestCode: "08",
    },
    {
      nestId: 3615,
      nestName: "נופך",
      nestCode: "09",
    },
    {
      nestId: 3616,
      nestName: "רינתיה",
      nestCode: "10",
    },
    {
      nestId: 3617,
      nestName: "שילת",
      nestCode: "11",
    },
    {
      nestId: 3618,
      nestName: "בני דרור",
      nestCode: "01",
    },
    {
      nestId: 3619,
      nestName: "גאולים",
      nestCode: "02",
    },
    {
      nestId: 3620,
      nestName: "גנות הדר",
      nestCode: "03",
    },
    {
      nestId: 3621,
      nestName: "נורדייה",
      nestCode: "04",
    },
    {
      nestId: 3622,
      nestName: "חירות",
      nestCode: "05",
    },
    {
      nestId: 3623,
      nestName: "ינוב",
      nestCode: "06",
    },
    {
      nestId: 3624,
      nestName: "כפר הס",
      nestCode: "07",
    },
    {
      nestId: 3625,
      nestName: "משמרת",
      nestCode: "08",
    },
    {
      nestId: 3626,
      nestName: "ניצני עוז",
      nestCode: "09",
    },
    {
      nestId: 3627,
      nestName: "עין ורד",
      nestCode: "10",
    },
    {
      nestId: 3628,
      nestName: "עין שריד",
      nestCode: "11",
    },
    {
      nestId: 3629,
      nestName: "צור משה",
      nestCode: "12",
    },
    {
      nestId: 3630,
      nestName: "שער אפרים",
      nestCode: "13",
    },
    {
      nestId: 3631,
      nestName: "תנובות",
      nestCode: "14",
    },
    {
      nestId: 3632,
      nestName: "אביחיל",
      nestCode: "01",
    },
    {
      nestId: 3633,
      nestName: "אחיטוב",
      nestCode: "02",
    },
    {
      nestId: 3634,
      nestName: "אומץ",
      nestCode: "03",
    },
    {
      nestId: 3635,
      nestName: "בחן",
      nestCode: "04",
    },
    {
      nestId: 3636,
      nestName: "בית הלוי",
      nestCode: "05",
    },
    {
      nestId: 3637,
      nestName: "בורגתה",
      nestCode: "06",
    },
    {
      nestId: 3638,
      nestName: "חניאל",
      nestCode: "07",
    },
    {
      nestId: 3639,
      nestName: "גאולי תימן",
      nestCode: "08",
    },
    {
      nestId: 3640,
      nestName: "גבעת חיים (איחוד)",
      nestCode: "09",
    },
    {
      nestId: 3641,
      nestName: "גבעת חיים (מאוחד)",
      nestCode: "10",
    },
    {
      nestId: 3642,
      nestName: "בית חירות",
      nestCode: "11",
    },
    {
      nestId: 3643,
      nestName: "בית ינאי",
      nestCode: "12",
    },
    {
      nestId: 3644,
      nestName: "ביתן אהרון",
      nestCode: "13",
    },
    {
      nestId: 3645,
      nestName: "בת חן",
      nestCode: "14",
    },
    {
      nestId: 3646,
      nestName: "גבעת שפירא",
      nestCode: "15",
    },
    {
      nestId: 3647,
      nestName: "חופית",
      nestCode: "16",
    },
    {
      nestId: 3648,
      nestName: "כפר ויתקין",
      nestCode: "17",
    },
    {
      nestId: 3649,
      nestName: "גן יאשיה",
      nestCode: "18",
    },
    {
      nestId: 3650,
      nestName: "הדר עם",
      nestCode: "19",
    },
    {
      nestId: 3651,
      nestName: "כפר חיים",
      nestCode: "20",
    },
    {
      nestId: 3652,
      nestName: "כפר ידידיה",
      nestCode: "21",
    },
    {
      nestId: 3653,
      nestName: "חבצלת השרון",
      nestCode: "22",
    },
    {
      nestId: 3654,
      nestName: "צוקי ים",
      nestCode: "23",
    },
    {
      nestId: 3655,
      nestName: "חגלה",
      nestCode: "24",
    },
    {
      nestId: 3656,
      nestName: "יד חנה",
      nestCode: "25",
    },
    {
      nestId: 3657,
      nestName: "כפר מונש",
      nestCode: "26",
    },
    {
      nestId: 3658,
      nestName: "מכמורת",
      nestCode: "27",
    },
    {
      nestId: 3659,
      nestName: "משמר השרון",
      nestCode: "28",
    },
    {
      nestId: 3660,
      nestName: "בארותיים",
      nestCode: "29",
    },
    {
      nestId: 3661,
      nestName: "עולש",
      nestCode: "30",
    },
    {
      nestId: 3662,
      nestName: "שושנת העמקים",
      nestCode: "31",
    },
    {
      nestId: 3663,
      nestName: "משמר השבעה",
      nestCode: "01",
    },
    {
      nestId: 3665,
      nestName: "ארגמן",
      nestCode: "15",
    },
    {
      nestId: 3666,
      nestName: "בקעות",
      nestCode: "16",
    },
    {
      nestId: 3667,
      nestName: "גלגל",
      nestCode: "17",
    },
    {
      nestId: 3668,
      nestName: "יפית",
      nestCode: "18",
    },
    {
      nestId: 3669,
      nestName: "מחולה",
      nestCode: "19",
    },
    {
      nestId: 3670,
      nestName: "מכורה",
      nestCode: "20",
    },
    {
      nestId: 3671,
      nestName: "משואה",
      nestCode: "21",
    },
    {
      nestId: 3672,
      nestName: 'נעמ"ה',
      nestCode: "01",
    },
    {
      nestId: 3673,
      nestName: "נירן",
      nestCode: "02",
    },
    {
      nestId: 3674,
      nestName: "נתיב הגדוד",
      nestCode: "11",
    },
    {
      nestId: 3675,
      nestName: "פצאל",
      nestCode: "12",
    },
    {
      nestId: 3676,
      nestName: "רועי",
      nestCode: "13",
    },
    {
      nestId: 3677,
      nestName: "תומר",
      nestCode: "14",
    },
    {
      nestId: 3678,
      nestName: "אודם",
      nestCode: "41",
    },
    {
      nestId: 3679,
      nestName: "אורטל",
      nestCode: "42",
    },
    {
      nestId: 3680,
      nestName: "אל-רום",
      nestCode: "43",
    },
    {
      nestId: 3681,
      nestName: "אלי-עד",
      nestCode: "44",
    },
    {
      nestId: 3682,
      nestName: "אניעם",
      nestCode: "45",
    },
    {
      nestId: 3683,
      nestName: "אפיק",
      nestCode: "46",
    },
    {
      nestId: 3684,
      nestName: "בני יהודה",
      nestCode: "47",
    },
    {
      nestId: 3685,
      nestName: "גבעת יואב",
      nestCode: "08",
    },
    {
      nestId: 3686,
      nestName: "גשור",
      nestCode: "09",
    },
    {
      nestId: 3687,
      nestName: "חד-נס",
      nestCode: "10",
    },
    {
      nestId: 3688,
      nestName: "כנף",
      nestCode: "11",
    },
    {
      nestId: 3689,
      nestName: "כפר חרוב",
      nestCode: "12",
    },
    {
      nestId: 3690,
      nestName: "מיצר",
      nestCode: "13",
    },
    {
      nestId: 3691,
      nestName: "מעלה גמלא",
      nestCode: "48",
    },
    {
      nestId: 3692,
      nestName: "מרום גולן",
      nestCode: "49",
    },
    {
      nestId: 3693,
      nestName: "נאות גולן",
      nestCode: "50",
    },
    {
      nestId: 3694,
      nestName: 'נווה אטי"ב',
      nestCode: "51",
    },
    {
      nestId: 3695,
      nestName: "נטור",
      nestCode: "52",
    },
    {
      nestId: 3696,
      nestName: "עין זיוון",
      nestCode: "53",
    },
    {
      nestId: 3697,
      nestName: "קדמת צבי",
      nestCode: "54",
    },
    {
      nestId: 3698,
      nestName: "קלע",
      nestCode: "21",
    },
    {
      nestId: 3699,
      nestName: "רמות",
      nestCode: "22",
    },
    {
      nestId: 3700,
      nestName: "שעל",
      nestCode: "23",
    },
    {
      nestId: 3701,
      nestName: "אביטל",
      nestCode: "01",
    },
    {
      nestId: 3702,
      nestName: "בית השיטה",
      nestCode: "02",
    },
    {
      nestId: 3703,
      nestName: "גבע",
      nestCode: "03",
    },
    {
      nestId: 3704,
      nestName: "גדעונה",
      nestCode: "04",
    },
    {
      nestId: 3705,
      nestName: "אומן",
      nestCode: "05",
    },
    {
      nestId: 3706,
      nestName: "גדיש",
      nestCode: "06",
    },
    {
      nestId: 3707,
      nestName: "מלאה",
      nestCode: "07",
    },
    {
      nestId: 3708,
      nestName: "ניר יפה",
      nestCode: "08",
    },
    {
      nestId: 3709,
      nestName: "אדירים",
      nestCode: "09",
    },
    {
      nestId: 3710,
      nestName: "ברק",
      nestCode: "10",
    },
    {
      nestId: 3711,
      nestName: "דבורה",
      nestCode: "11",
    },
    {
      nestId: 3712,
      nestName: "מיטב",
      nestCode: "12",
    },
    {
      nestId: 3713,
      nestName: "גן נר",
      nestCode: "13",
    },
    {
      nestId: 3714,
      nestName: "מרכז חבר (חבר)",
      nestCode: "15",
    },
    {
      nestId: 3715,
      nestName: "חפצי-בה",
      nestCode: "16",
    },
    {
      nestId: 3716,
      nestName: "יזרעאל",
      nestCode: "17",
    },
    {
      nestId: 3717,
      nestName: "כפר יחזקאל",
      nestCode: "18",
    },
    {
      nestId: 3718,
      nestName: "מגן שאול",
      nestCode: "19",
    },
    {
      nestId: 3719,
      nestName: "מולדת",
      nestCode: "20",
    },
    {
      nestId: 3720,
      nestName: "מרכז יעל",
      nestCode: "21",
    },
    {
      nestId: 3721,
      nestName: "עין חרוד (איחוד)",
      nestCode: "22",
    },
    {
      nestId: 3722,
      nestName: "עין חרוד (מאוחד)",
      nestCode: "23",
    },
    {
      nestId: 3723,
      nestName: "פרזון",
      nestCode: "24",
    },
    {
      nestId: 3724,
      nestName: "רם און",
      nestCode: "25",
    },
    {
      nestId: 3725,
      nestName: "רמת צבי",
      nestCode: "26",
    },
    {
      nestId: 3726,
      nestName: "תל יוסף",
      nestCode: "27",
    },
    {
      nestId: 3727,
      nestName: "אילנייה",
      nestCode: "01",
    },
    {
      nestId: 3728,
      nestName: "ארבל",
      nestCode: "02",
    },
    {
      nestId: 3729,
      nestName: "בית קשת",
      nestCode: "03",
    },
    {
      nestId: 3730,
      nestName: "גבעת אבני",
      nestCode: "04",
    },
    {
      nestId: 3731,
      nestName: "כפר חיטים",
      nestCode: "05",
    },
    {
      nestId: 3732,
      nestName: "כפר קיש",
      nestCode: "06",
    },
    {
      nestId: 3733,
      nestName: "מסד",
      nestCode: "07",
    },
    {
      nestId: 3734,
      nestName: "מצפה",
      nestCode: "08",
    },
    {
      nestId: 3735,
      nestName: "שדמות דבורה",
      nestCode: "09",
    },
    {
      nestId: 3736,
      nestName: "שרונה",
      nestCode: "10",
    },
    {
      nestId: 3737,
      nestName: "בית אורן",
      nestCode: "01",
    },
    {
      nestId: 3738,
      nestName: "בת שלמה",
      nestCode: "02",
    },
    {
      nestId: 3739,
      nestName: "גבע כרמל",
      nestCode: "03",
    },
    {
      nestId: 3740,
      nestName: "דור",
      nestCode: "04",
    },
    {
      nestId: 3741,
      nestName: "הבונים",
      nestCode: "05",
    },
    {
      nestId: 3742,
      nestName: "החותרים",
      nestCode: "06",
    },
    {
      nestId: 3743,
      nestName: 'כרם מהר"ל',
      nestCode: "07",
    },
    {
      nestId: 3744,
      nestName: "מגדים",
      nestCode: "08",
    },
    {
      nestId: 3745,
      nestName: "מעגן מיכאל",
      nestCode: "09",
    },
    {
      nestId: 3746,
      nestName: "מעיין צבי",
      nestCode: "10",
    },
    {
      nestId: 3747,
      nestName: "נווה ים",
      nestCode: "11",
    },
    {
      nestId: 3748,
      nestName: "נחשולים",
      nestCode: "12",
    },
    {
      nestId: 3749,
      nestName: "עופר",
      nestCode: "13",
    },
    {
      nestId: 3750,
      nestName: "עין איילה",
      nestCode: "14",
    },
    {
      nestId: 3751,
      nestName: "עין הוד",
      nestCode: "15",
    },
    {
      nestId: 3752,
      nestName: "עין כרמל",
      nestCode: "16",
    },
    {
      nestId: 3753,
      nestName: "צרופה",
      nestCode: "17",
    },
    {
      nestId: 3754,
      nestName: "שדות ים",
      nestCode: "18",
    },
    {
      nestId: 3756,
      nestName: "אליפלט",
      nestCode: "11",
    },
    {
      nestId: 3757,
      nestName: "אמנון",
      nestCode: "12",
    },
    {
      nestId: 3758,
      nestName: "כחל",
      nestCode: "13",
    },
    {
      nestId: 3759,
      nestName: "בית הלל",
      nestCode: "01",
    },
    {
      nestId: 3760,
      nestName: "דישון",
      nestCode: "02",
    },
    {
      nestId: 3761,
      nestName: "כורזים",
      nestCode: "03",
    },
    {
      nestId: 3762,
      nestName: "יובל",
      nestCode: "04",
    },
    {
      nestId: 3763,
      nestName: "כרכום",
      nestCode: "05",
    },
    {
      nestId: 3764,
      nestName: "מרגליות",
      nestCode: "06",
    },
    {
      nestId: 3765,
      nestName: "משמר הירדן",
      nestCode: "07",
    },
    {
      nestId: 3766,
      nestName: "רמות נפתלי",
      nestCode: "08",
    },
    {
      nestId: 3767,
      nestName: "שאר ישוב",
      nestCode: "09",
    },
    {
      nestId: 3768,
      nestName: "שדה אליעזר",
      nestCode: "10",
    },
    {
      nestId: 3769,
      nestName: "אדמית",
      nestCode: "32",
    },
    {
      nestId: 3770,
      nestName: "אשרת",
      nestCode: "33",
    },
    {
      nestId: 3771,
      nestName: "אפק",
      nestCode: "34",
    },
    {
      nestId: 3772,
      nestName: "בוסתן הגליל",
      nestCode: "35",
    },
    {
      nestId: 3773,
      nestName: "בית העמק",
      nestCode: "36",
    },
    {
      nestId: 3774,
      nestName: "בן עמי",
      nestCode: "37",
    },
    {
      nestId: 3775,
      nestName: "בצת",
      nestCode: "38",
    },
    {
      nestId: 3776,
      nestName: "חניתה",
      nestCode: "39",
    },
    {
      nestId: 3777,
      nestName: "כברי",
      nestCode: "40",
    },
    {
      nestId: 3778,
      nestName: "כליל",
      nestCode: "41",
    },
    {
      nestId: 3779,
      nestName: "לימן",
      nestCode: "42",
    },
    {
      nestId: 3780,
      nestName: "מצובה",
      nestCode: "43",
    },
    {
      nestId: 3781,
      nestName: "נתיב השיירה",
      nestCode: "44",
    },
    {
      nestId: 3782,
      nestName: "עמקה",
      nestCode: "45",
    },
    {
      nestId: 3783,
      nestName: "שבי ציון",
      nestCode: "46",
    },
    {
      nestId: 3784,
      nestName: "מטולה",
      nestCode: "01",
    },
    {
      nestId: 3785,
      nestName: "אלוני יצחק",
      nestCode: "01",
    },
    {
      nestId: 3786,
      nestName: "כפר גליקסון",
      nestCode: "02",
    },
    {
      nestId: 3787,
      nestName: "רגבים",
      nestCode: "03",
    },
    {
      nestId: 3788,
      nestName: "מאור",
      nestCode: "04",
    },
    {
      nestId: 3789,
      nestName: "מי עמי",
      nestCode: "05",
    },
    {
      nestId: 3790,
      nestName: "משמרות",
      nestCode: "06",
    },
    {
      nestId: 3791,
      nestName: "עין עירון",
      nestCode: "07",
    },
    {
      nestId: 3792,
      nestName: "שדה יצחק",
      nestCode: "08",
    },
    {
      nestId: 3793,
      nestName: "אבירים",
      nestCode: "01",
    },
    {
      nestId: 3794,
      nestName: "אבן מנחם",
      nestCode: "02",
    },
    {
      nestId: 3795,
      nestName: "אלקוש",
      nestCode: "03",
    },
    {
      nestId: 3796,
      nestName: "גורן",
      nestCode: "04",
    },
    {
      nestId: 3797,
      nestName: "גיתה",
      nestCode: "05",
    },
    {
      nestId: 3798,
      nestName: "גרנות הגליל",
      nestCode: "06",
    },
    {
      nestId: 3799,
      nestName: "הילה",
      nestCode: "07",
    },
    {
      nestId: 3800,
      nestName: "כפר רוזנואלד (זרעית)",
      nestCode: "08",
    },
    {
      nestId: 3801,
      nestName: "חוסן",
      nestCode: "09",
    },
    {
      nestId: 3802,
      nestName: "יערה",
      nestCode: "10",
    },
    {
      nestId: 3803,
      nestName: "לפידות",
      nestCode: "11",
    },
    {
      nestId: 3804,
      nestName: "מנות",
      nestCode: "12",
    },
    {
      nestId: 3805,
      nestName: "מעונה",
      nestCode: "13",
    },
    {
      nestId: 3806,
      nestName: "מתת",
      nestCode: "14",
    },
    {
      nestId: 3807,
      nestName: "נווה זיו",
      nestCode: "15",
    },
    {
      nestId: 3808,
      nestName: "נטועה",
      nestCode: "16",
    },
    {
      nestId: 3809,
      nestName: "עבדון",
      nestCode: "17",
    },
    {
      nestId: 3810,
      nestName: "עין יעקב",
      nestCode: "18",
    },
    {
      nestId: 3811,
      nestName: "פקיעין חדשה",
      nestCode: "19",
    },
    {
      nestId: 3812,
      nestName: "צוריאל",
      nestCode: "20",
    },
    {
      nestId: 3813,
      nestName: "שומרה",
      nestCode: "21",
    },
    {
      nestId: 3814,
      nestName: "שתולה",
      nestCode: "22",
    },
    {
      nestId: 3815,
      nestName: "חמדיה",
      nestCode: "02",
    },
    {
      nestId: 3816,
      nestName: "בית יוסף",
      nestCode: "03",
    },
    {
      nestId: 3817,
      nestName: "ירדנה",
      nestCode: "04",
    },
    {
      nestId: 3818,
      nestName: "כפר רופין",
      nestCode: "05",
    },
    {
      nestId: 3819,
      nestName: "מנחמיה",
      nestCode: "06",
    },
    {
      nestId: 3820,
      nestName: "מעוז חיים",
      nestCode: "07",
    },
    {
      nestId: 3821,
      nestName: "נווה אור",
      nestCode: "08",
    },
    {
      nestId: 3822,
      nestName: "נווה איתן",
      nestCode: "09",
    },
    {
      nestId: 3823,
      nestName: "רשפים",
      nestCode: "10",
    },
    {
      nestId: 3824,
      nestName: "שדה נחום",
      nestCode: "11",
    },
    {
      nestId: 3825,
      nestName: "אחוזת ברק",
      nestCode: "01",
    },
    {
      nestId: 3826,
      nestName: "אלון הגליל",
      nestCode: "02",
    },
    {
      nestId: 3827,
      nestName: "אלוני אבא",
      nestCode: "03",
    },
    {
      nestId: 3828,
      nestName: "אלונים",
      nestCode: "04",
    },
    {
      nestId: 3829,
      nestName: "בית לחם הגלילית",
      nestCode: "05",
    },
    {
      nestId: 3830,
      nestName: "בית שערים",
      nestCode: "06",
    },
    {
      nestId: 3831,
      nestName: "בלפוריה",
      nestCode: "07",
    },
    {
      nestId: 3832,
      nestName: "גבעת אלה",
      nestCode: "08",
    },
    {
      nestId: 3833,
      nestName: "גבת",
      nestCode: "09",
    },
    {
      nestId: 3834,
      nestName: "גניגר",
      nestCode: "10",
    },
    {
      nestId: 3835,
      nestName: "דברת",
      nestCode: "11",
    },
    {
      nestId: 3836,
      nestName: "היוגב",
      nestCode: "12",
    },
    {
      nestId: 3837,
      nestName: "הסוללים",
      nestCode: "13",
    },
    {
      nestId: 3838,
      nestName: "הרדוף",
      nestCode: "14",
    },
    {
      nestId: 3839,
      nestName: "חנתון",
      nestCode: "15",
    },
    {
      nestId: 3840,
      nestName: "יפעת",
      nestCode: "16",
    },
    {
      nestId: 3841,
      nestName: "כפר ברוך",
      nestCode: "17",
    },
    {
      nestId: 3842,
      nestName: "כפר החורש",
      nestCode: "18",
    },
    {
      nestId: 3843,
      nestName: "מזרע",
      nestCode: "19",
    },
    {
      nestId: 3844,
      nestName: "כפר יהושע",
      nestCode: "20",
    },
    {
      nestId: 3845,
      nestName: "מחנה יהודית (רמת דוד)",
      nestCode: "21",
    },
    {
      nestId: 3846,
      nestName: "מרחביה (מושב)",
      nestCode: "22",
    },
    {
      nestId: 3847,
      nestName: "נהלל",
      nestCode: "23",
    },
    {
      nestId: 3848,
      nestName: "עדי",
      nestCode: "24",
    },
    {
      nestId: 3849,
      nestName: "ציפורי",
      nestCode: "25",
    },
    {
      nestId: 3850,
      nestName: "רמת דוד",
      nestCode: "26",
    },
    {
      nestId: 3851,
      nestName: "שמשית",
      nestCode: "27",
    },
    {
      nestId: 3852,
      nestName: "תל עדשים",
      nestCode: "28",
    },
    {
      nestId: 3853,
      nestName: "תמרת",
      nestCode: "29",
    },
    {
      nestId: 200050,
      nestName: "התאגדויות במזון המהיר",
      nestCode: "01",
    },
    {
      nestId: 200100,
      nestName: "איגוד מקצועי כללי",
      nestCode: "11",
    },
    {
      nestId: 200150,
      nestName: "כלל תנועתי",
      nestCode: "98",
    },
    {
      nestId: 200151,
      nestName: "נוער תלם - קיבוץ לוטן",
      nestCode: "40",
    },
    {
      nestId: 200152,
      nestName: "נוער תלם - גדרה",
      nestCode: "41",
    },
    {
      nestId: 200153,
      nestName: "נוער תלם - חולון קודש וחול",
      nestCode: "42",
    },
    {
      nestId: 200154,
      nestName: "נוער תלם - תל אביב בית דניאל",
      nestCode: "43",
    },
    {
      nestId: 200155,
      nestName: "נוער תלם - מודיעין יוזמה",
      nestCode: "44",
    },
    {
      nestId: 200156,
      nestName: "נוער תלם - ירושלים כל הנשמה",
      nestCode: "45",
    },
    {
      nestId: 200157,
      nestName: "נוער תלם - מבשרת קמץ",
      nestCode: "46",
    },
    {
      nestId: 200158,
      nestName: "נוער תלם - צור הדסה",
      nestCode: "47",
    },
    {
      nestId: 200159,
      nestName: "נוער תלם - זכרון יעקב סולם יעקב",
      nestCode: "48",
    },
    {
      nestId: 200160,
      nestName: "נוער תלם - חיפה אור חדש",
      nestCode: "49",
    },
    {
      nestId: 200161,
      nestName: "נוער תלם - חיפה אהל אברהם",
      nestCode: "50",
    },
    {
      nestId: 200162,
      nestName: "נוער תלם - סניף גליל",
      nestCode: "51",
    },
    {
      nestId: 200163,
      nestName: "נוער תלם - ארצי",
      nestCode: "99",
    },
    {
      nestId: 200164,
      nestName: "נוער תלם - אבן יהודה",
      nestCode: "52",
    },
    {
      nestId: 200165,
      nestName: "גני תקווה",
      nestCode: "10",
    },
    {
      nestId: 200200,
      nestName: "נוער תלם - תכנית חמולה",
      nestCode: "53",
    },
    {
      nestId: 200250,
      nestName: "כפר קרע",
      nestCode: "01",
    },
    {
      nestId: 200251,
      nestName: "רהט",
      nestCode: "01",
    },
    {
      nestId: 200350,
      nestName: "מכמנים",
      nestCode: "04",
    },
    {
      nestId: 200450,
      nestName: "דפנה",
      nestCode: "09",
    },
    {
      nestId: 200451,
      nestName: "משגב עם",
      nestCode: "10",
    },
    {
      nestId: 200550,
      nestName: "הכנה לצהל",
      nestCode: "81",
    },
    {
      nestId: 200551,
      nestName: "באקה אל גרבייה",
      nestCode: "02",
    },
    {
      nestId: 200552,
      nestName: "טירה",
      nestCode: "03",
    },
    {
      nestId: 200553,
      nestName: "עין ראפה",
      nestCode: "04",
    },
    {
      nestId: 200554,
      nestName: "עין נקובה",
      nestCode: "05",
    },
    {
      nestId: 200555,
      nestName: "חוסנייה",
      nestCode: "15",
    },
    {
      nestId: 200600,
      nestName: "קרית ביאליק צור שלום",
      nestCode: "55",
    },
    {
      nestId: 200608,
      nestName: "הקנים הערבים - סח'נין",
      nestCode: "02",
    },
    {
      nestId: 200609,
      nestName: "ביר אלמכסור",
      nestCode: "03",
    },
    {
      nestId: 200610,
      nestName: "ואדי סלמה",
      nestCode: "05",
    },
    {
      nestId: 200611,
      nestName: "נצרת",
      nestCode: "06",
    },
    {
      nestId: 200612,
      nestName: "שעב",
      nestCode: "07",
    },
    {
      nestId: 200613,
      nestName: "נחף",
      nestCode: "08",
    },
    {
      nestId: 200614,
      nestName: "הקנים הערבים - עכו",
      nestCode: "10",
    },
    {
      nestId: 200615,
      nestName: "מ.ירושלים",
      nestCode: "06",
    },
    {
      nestId: 200616,
      nestName: "תרשיחא",
      nestCode: "21",
    },
    {
      nestId: 200617,
      nestName: "מזרעה",
      nestCode: "22",
    },
    {
      nestId: 200618,
      nestName: "טובא זנגרייה",
      nestCode: "23",
    },
    {
      nestId: 200619,
      nestName: "בועיינה נוג'דאת",
      nestCode: "24",
    },
    {
      nestId: 200620,
      nestName: "זרזיר",
      nestCode: "25",
    },
    {
      nestId: 200621,
      nestName: "טורעאן",
      nestCode: "26",
    },
    {
      nestId: 200622,
      nestName: "כעביה",
      nestCode: "27",
    },
    {
      nestId: 200623,
      nestName: "שיח דנון",
      nestCode: "28",
    },
    {
      nestId: 200624,
      nestName: "בסמת טבעון",
      nestCode: "29",
    },
    {
      nestId: 200625,
      nestName: "בענה",
      nestCode: "30",
    },
    {
      nestId: 200626,
      nestName: "טמרה",
      nestCode: "31",
    },
    {
      nestId: 200627,
      nestName: "כפר מצר",
      nestCode: "32",
    },
    {
      nestId: 200628,
      nestName: "עילוט",
      nestCode: "33",
    },
    {
      nestId: 200629,
      nestName: "הקנים הערבים - חיפה",
      nestCode: "34",
    },
    {
      nestId: 200630,
      nestName: "כסייפה",
      nestCode: "03",
    },
    {
      nestId: 200631,
      nestName: "אום בטין - אלקסום",
      nestCode: "02",
    },
    {
      nestId: 200632,
      nestName: "לקיה - קנים ערבים",
      nestCode: "04",
    },
    {
      nestId: 200633,
      nestName: "נווה מדבר",
      nestCode: "05",
    },
    {
      nestId: 200634,
      nestName: "חורה",
      nestCode: "06",
    },
    {
      nestId: 200635,
      nestName: "תל שבע",
      nestCode: "07",
    },
    {
      nestId: 200636,
      nestName: "פורדיס",
      nestCode: "07",
    },
    {
      nestId: 200637,
      nestName: "קבוצות מחנכים",
      nestCode: "90",
    },
    {
      nestId: 200650,
      nestName: "טייבה",
      nestCode: "08",
    },
    {
      nestId: 200651,
      nestName: "אום אלפחם",
      nestCode: "09",
    },
    {
      nestId: 200652,
      nestName: "אבו גוש",
      nestCode: "10",
    },
    {
      nestId: 200750,
      nestName: "קן הציפורים הוד השרון",
      nestCode: "23",
    },
    {
      nestId: 200751,
      nestName: "קרית אונו דרום",
      nestCode: "15",
    },
    {
      nestId: 200800,
      nestName: "קרית אתא התיכון החברתי",
      nestCode: "16",
    },
    {
      nestId: 200850,
      nestName: "עמל אנרג'י טק",
      nestCode: "11",
    },
    {
      nestId: 200900,
      nestName: "עין חוד",
      nestCode: "11",
    },
    {
      nestId: 200950,
      nestName: "גסר אלזרקא",
      nestCode: "12",
    },
    {
      nestId: 200951,
      nestName: "כפר גלים",
      nestCode: "20",
    },
    {
      nestId: 200952,
      nestName: 'נתיב הל"ה',
      nestCode: "06",
    },
    {
      nestId: 200953,
      nestName: "חולתה",
      nestCode: "12",
    },
    {
      nestId: 200954,
      nestName: "כפר הנשיא",
      nestCode: "11",
    },
    {
      nestId: 200955,
      nestName: "נאות מרדכי",
      nestCode: "13",
    },
    {
      nestId: 200956,
      nestName: "גיתית",
      nestCode: "03",
    },
    {
      nestId: 200957,
      nestName: "חמדת",
      nestCode: "04",
    },
    {
      nestId: 200958,
      nestName: "חמרה",
      nestCode: "05",
    },
    {
      nestId: 200959,
      nestName: 'ייט"ב',
      nestCode: "06",
    },
    {
      nestId: 200960,
      nestName: "מבואות יריחו",
      nestCode: "07",
    },
    {
      nestId: 200961,
      nestName: "משכיות",
      nestCode: "08",
    },
    {
      nestId: 200962,
      nestName: "רותם",
      nestCode: "09",
    },
    {
      nestId: 200963,
      nestName: "שדמות מחולה",
      nestCode: "10",
    },
    {
      nestId: 200964,
      nestName: "נורית",
      nestCode: "14",
    },
    {
      nestId: 200965,
      nestName: "נשר",
      nestCode: "33",
    },
    {
      nestId: 201000,
      nestName: "ערערה בנגב",
      nestCode: "08",
    },
    {
      nestId: 201001,
      nestName: "בני ברק",
      nestCode: "18",
    },
    {
      nestId: 201002,
      nestName: "גבעת שמואל",
      nestCode: "19",
    },
    {
      nestId: 201003,
      nestName: "כפר ורדים",
      nestCode: "11",
    },
    {
      nestId: 201005,
      nestName: "קצרין",
      nestCode: "13",
    },
    {
      nestId: 201006,
      nestName: "קרית מלאכי",
      nestCode: "19",
    },
    {
      nestId: 201007,
      nestName: "בני עייש",
      nestCode: "36",
    },
    {
      nestId: 201008,
      nestName: "אזור",
      nestCode: "20",
    },
    {
      nestId: 201009,
      nestName: "בית דגן",
      nestCode: "21",
    },
    {
      nestId: 201010,
      nestName: "אור עקיבא",
      nestCode: "30",
    },
    {
      nestId: 201011,
      nestName: "טירת הכרמל",
      nestCode: "26",
    },
    {
      nestId: 201012,
      nestName: "רכסים",
      nestCode: "25",
    },
    {
      nestId: 201013,
      nestName: "קן עין כרם",
      nestCode: "13",
    },
    {
      nestId: 201014,
      nestName: "מודיעין עילית",
      nestCode: "14",
    },
    {
      nestId: 201015,
      nestName: "קדם ערבה",
      nestCode: "06",
    },
    {
      nestId: 201016,
      nestName: "אורנית",
      nestCode: "14",
    },
    {
      nestId: 201017,
      nestName: "אלעד",
      nestCode: "15",
    },
    {
      nestId: 201018,
      nestName: "אריאל",
      nestCode: "16",
    },
    {
      nestId: 201019,
      nestName: "סביון",
      nestCode: "17",
    },
    {
      nestId: 201020,
      nestName: "ירוחם",
      nestCode: "03",
    },
    {
      nestId: 201021,
      nestName: "להבים",
      nestCode: "38",
    },
    {
      nestId: 201022,
      nestName: "יבנאל",
      nestCode: "15",
    },
    {
      nestId: 201023,
      nestName: "אלפי מנשה",
      nestCode: "02",
    },
    {
      nestId: 201024,
      nestName: "כוכב יאיר",
      nestCode: "03",
    },
    {
      nestId: 201025,
      nestName: "רעננה",
      nestCode: "05",
    },
    {
      nestId: 201026,
      nestName: "תל מונד",
      nestCode: "06",
    },
    {
      nestId: 201027,
      nestName: "פלורנטין",
      nestCode: "21",
    },
    {
      nestId: 201028,
      nestName: 'שלוחת הל"ה - גבעתיים',
      nestCode: "22",
    },
    {
      nestId: 201029,
      nestName: "חולית",
      nestCode: "18",
    },
    {
      nestId: 201030,
      nestName: "כרם שלום",
      nestCode: "19",
    },
    {
      nestId: 201031,
      nestName: "מבוא חמה",
      nestCode: "24",
    },
    {
      nestId: 201032,
      nestName: "באר טוביה",
      nestCode: "04",
    },
    {
      nestId: 201033,
      nestName: "גן שלושה",
      nestCode: "04",
    },
    {
      nestId: 201034,
      nestName: "גינתון",
      nestCode: "05",
    },
    {
      nestId: 201035,
      nestName: "קיום משותף ירושלים",
      nestCode: "22",
    },
    {
      nestId: 201036,
      nestName: "באר שבע כלניות",
      nestCode: "21",
    },
    {
      nestId: 201037,
      nestName: "מנרה",
      nestCode: "14",
    },
    {
      nestId: 201038,
      nestName: "עילבון",
      nestCode: "34",
    },
    {
      nestId: 201050,
      nestName: "מחוז עמקים",
      nestCode: "99",
    },
    {
      nestId: 201051,
      nestName: "אלפרעה",
      nestCode: "10",
    },
    {
      nestId: 201052,
      nestName: "דרום",
      nestCode: "99",
    },
    {
      nestId: 201053,
      nestName: "נגב",
      nestCode: "99",
    },
    {
      nestId: 201054,
      nestName: "ירושלים",
      nestCode: "99",
    },
    {
      nestId: 201055,
      nestName: "נצרת - ביר אלאמיר",
      nestCode: "05",
    },
    {
      nestId: 201100,
      nestName: "זנוח",
      nestCode: "32",
    },
    {
      nestId: 201101,
      nestName: "מחסניה",
      nestCode: "33",
    },
    {
      nestId: 201102,
      nestName: "תירוש",
      nestCode: "34",
    },
    {
      nestId: 201103,
      nestName: "רחוב",
      nestCode: "12",
    },
    {
      nestId: 201104,
      nestName: "רוויה",
      nestCode: "13",
    },
    {
      nestId: 201105,
      nestName: "תל תאומים",
      nestCode: "14",
    },
    {
      nestId: 201106,
      nestName: "שדי תרומות",
      nestCode: "15",
    },
    {
      nestId: 201150,
      nestName: "ויצו נהלל",
      nestCode: "01",
    },
    {
      nestId: 201151,
      nestName: "קלנסווה",
      nestCode: "13",
    },
    {
      nestId: 201152,
      nestName: "מחוז גליל",
      nestCode: "99",
    },
    {
      nestId: 201153,
      nestName: "כרמיאל - גבעת רם",
      nestCode: "16",
    },
    {
      nestId: 201154,
      nestName: "כרמיאל - ניצנים",
      nestCode: "17",
    },
    {
      nestId: 201155,
      nestName: "חדרה - נווה חיים",
      nestCode: "20",
    },
    {
      nestId: 201156,
      nestName: "מדרך עוז",
      nestCode: "28",
    },
    {
      nestId: 201157,
      nestName: "נתניה צפון",
      nestCode: "15",
    },
    {
      nestId: 201158,
      nestName: "דבוריה",
      nestCode: "53",
    },
    {
      nestId: 201159,
      nestName: "אולפן רעננה",
      nestCode: "24",
    },
    {
      nestId: 201160,
      nestName: "מוסינזון",
      nestCode: "25",
    },
    {
      nestId: 201161,
      nestName: "גרעין חוסן",
      nestCode: "02",
    },
    {
      nestId: 201162,
      nestName: "סולם",
      nestCode: "09",
    },
    {
      nestId: 201163,
      nestName: "ערב א-נעים",
      nestCode: "14",
    },
    {
      nestId: 201164,
      nestName: "קצר א-סר",
      nestCode: "11",
    },
    {
      nestId: 201200,
      nestName: "ימין אורד",
      nestCode: "36",
    },
    {
      nestId: 201201,
      nestName: "לוטם",
      nestCode: "15",
    },
  ],
  hasRefundCode: true,
  refundCode: "1234",
  messages: messagesFixture,
  docs: [
    {
      name: "הסכם הבנות עם הורי החניכים המשתתפים במפעלי התנועה",
      url: "https://d981667oth2p9.cloudfront.net/wp-content/uploads/2016/07/11120913/%D7%97%D7%95%D7%96%D7%A8-%D7%9C%D7%94%D7%95%D7%A8%D7%99-%D7%94%D7%97%D7%A0%D7%99%D7%9B%D7%99%D7%9D-%D7%94%D7%9E%D7%A9%D7%AA%D7%AA%D7%A4%D7%99%D7%9D-%D7%91%D7%9E%D7%A4%D7%A2%D7%9C%D7%99-%D7%94%D7%AA%D7%A0%D7%95%D7%A2%D7%94-%D7%99%D7%95%D7%A0%D7%99-2015.pdf",
    },
    {
      name: "אישור הורים שנתי לפעילות התנועה",
      url: "https://noal.org.il/app/uploads/2016/07/אישור-הורים.pdf",
    },
    {
      name: "רשימת ציוד לטיולים",
      url: "https://d981667oth2p9.cloudfront.net/wp-content/uploads/2016/07/11120941/%D7%A8%D7%A9%D7%99%D7%9E%D7%AA-%D7%A6%D7%99%D7%95%D7%93-%D7%9C%D7%98%D7%99%D7%95%D7%9C1.pdf",
    },
    {
      name: "נוסח תדרוך של הורים לחניכים לפני טיול",
      url: "https://d981667oth2p9.cloudfront.net/wp-content/uploads/2016/07/11120959/%D7%AA%D7%93%D7%A8%D7%95%D7%9A-%D7%94%D7%95%D7%A8%D7%99%D7%9D-%D7%9C%D7%97%D7%A0%D7%99%D7%9B%D7%99%D7%9D1.pdf",
    },
    {
      name: "טופס הסכמה לצילום ופרסום תמונות קטין/ה",
      url: "https://d981667oth2p9.cloudfront.net/wp-content/uploads/2018/09/20200210/%D7%98%D7%95%D7%A4%D7%A1-%D7%90%D7%99%D7%A9%D7%95%D7%A8-%D7%94%D7%95%D7%A8%D7%99%D7%9D-%D7%9C%D7%A9%D7%99%D7%9E%D7%95%D7%A9-%D7%91%D7%AA%D7%9E%D7%95%D7%A0%D7%95%D7%AA-%D7%9C%D7%A6%D7%95%D7%A8%D7%9A-%D7%A7%D7%9E%D7%A4%D7%99%D7%99%D7%9F-%D7%AA%D7%A7%D7%A9%D7%95%D7%A8%D7%AA-%D7%90%D7%95-%D7%A9%D7%99%D7%95%D7%95%D7%A7-%D7%A2%D7%93%D7%9B%D7%A0%D7%99-2016.pdf",
    },
  ],
  sitecptch: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
  generalTexts: [
    {
      circle: 0,
      id: 5,
      definitionId: 3,
      name: "שאלות ותשובות",
      divId: "questions",
      divText:
        '<div class="wow FadeInLegacyUp" style="visibility: visible;">\n    <h5>\n        במידה ולא מצאתם תשובה לשאלתכם בדף זה- כתבו אלינו ,דרך מסך צור קשר.</h5></div><blockquote style="margin: 0 0 0 40px; border: none; padding: 0px;"><blockquote style="margin: 0 0 0 40px; border: none; padding: 0px;"><blockquote style="margin: 0 0 0 40px; border: none; padding: 0px;"><div class="wow FadeInLegacyUp" style="visibility: visible;"><div style="text-align: right;"><br></div><div style="text-align: right;"><b>&nbsp; &nbsp;&nbsp; מהו תקנון האתר?</b></div><div style="text-align: right;"><br></div></div></blockquote></blockquote></blockquote><div class="wow FadeInLegacyUp" style="visibility: visible;"><div><br></div><div><p class="MsoNormal" align="center" dir="RTL" style="mso-margin-top-alt:auto;\nmso-margin-bottom-alt:auto;text-align:center;line-height:normal"><b><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">תנועת הנוער העובד והלומד</span></b><span dir="LTR" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p>\n\n<p class="MsoNormal" align="center" dir="RTL" style="mso-margin-top-alt:auto;\nmso-margin-bottom-alt:auto;text-align:center;line-height:normal"><b><u><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">תקנון שירות תשלומים</span></u></b><span dir="LTR"></span><span dir="LTR"></span><b><u><span dir="LTR" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><span dir="LTR"></span><span dir="LTR"></span>&nbsp;</span></u></b><b><u><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">באמצעות האינטרנט</span></u></b><span dir="LTR"></span><span dir="LTR"></span><b><u><span dir="LTR" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><span dir="LTR"></span><span dir="LTR"></span>&nbsp;</span></u></b><span dir="RTL"></span><span dir="RTL"></span><b><u><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><span dir="RTL"></span><span dir="RTL"></span>(רישום ותשלום לפעילות)</span></u></b><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">&nbsp;<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><u><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">&nbsp;כללי</span></u><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">1.&nbsp;&nbsp;אתר האינטרנט (להלן: "האתר") מופעל על ידי\nתנועת הנוער העובד והלומד (להלן: "התנועה").<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">2.&nbsp;האתר מאפשר, בין היתר,למשלמים עבור ההשתתפות בפעילות של\nהתנועה שהם בגירים (להלן: ""המשתמשים") להעביר הוראות לתשלום\nבאמצעות כרטיס אשראי, עבור השתתפות החניך/כה&nbsp;&nbsp;בפעילויות השונות שמפעילה\nהתנועה, וזאת בכפוף לתנאי תקנון שירות תשלומים זה (להלן:"התקנון").\nהתקנון חל על אתר התשלומים של התנועה בלבד.<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">3.&nbsp;המשתמשים מתבקשים לקרוא בעיון ובקפידה את הוראות התקנון\nלהלן, ולהקפיד על כך שכל הפרטים הנמסרים על ידם לצורך שימוש באתר מדויקים, וזאת\nבטרם מתן הוראת התשלום. המשתמשים נדרשים לאשר במקום המיועד לכך, כי קראו את\nהתקנון. אישור קריאת התקנון מהווה אישור והסכמה לכל הסעיפים המופיעים בו.<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">4.&nbsp;בכל מקרה של סתירה ו/או אי התאמה בין הוראות התקנון לבין\nפרסום אחר של התנועה, תגברנה הוראות התקנון.&nbsp;<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">5.&nbsp;&nbsp;התנועה שומרת לעצמה את הזכות לשנות ו/או לעדכן את\nהתקנון בכל עת, לפי שיקול דעתה הבלעדי, וכל שינוי יחייב את המשתמשים באתר תוך 14\nיום&nbsp;&nbsp;מפרסומו באתר.<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">6.&nbsp;הוראות התקנון התקפות לגבי הוראת תשלום כלשהי הינן אלה\nהמפורסמות באתר במועד העברת הוראת התשלום.<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">7.&nbsp;האמור בתקנון זה בלשון זכר, גם לשון נקבה במשמע.<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">8.&nbsp;במקרה של סתירה בין הנוסח בשפה העברית לבין נוסח בשפה אחרת,\nהנוסח בשפה העברית הוא המחייב.<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><b><u><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">רישום לפעילות ואישור השתתפות</span></u></b><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">9.&nbsp;ההרשמה לפעילות מהווה הסכמה לחוזר ההבנות עם ההורים, אשר\nמופיע באתר התנועה&nbsp;<a href="https://noal.org.il/2015/06/13/%D7%94%D7%A1%D7%9B%D7%9D-%D7%94%D7%91%D7%A0%D7%95%D7%AA-%D7%A2%D7%9D-%D7%94%D7%94%D7%95%D7%A8%D7%99%D7%9D/" target="_blank">ו<u><font color="#0000ff">בקישור זה</font></u></a>.<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">10.&nbsp;המשלם מחויב לדווח על בעיה רפואית לפני היציאה לפעילות\nוהתשלום מהווה את אישורו ליציאה והיכרותו עם התוכנית של הפעילות.<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">11.&nbsp;התנועה שומרת לעצמה את הזכות לשנות, בכל עת, את התנאים\nוהתעריפים להשתתפות בפעילויות השונות, לפי שיקול דעתה, וללא הודעה מראש. התנאים והתעריף\nהמחייבים הינם אלה המפורטים באתר במועד הרישום לפעילות.<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">12.&nbsp;השתתפות החניך בפעילות מותנית באישור רכז הפעילות, ולפי\nשיקול דעתו בלבד. רכז הפעילות רשאי לבטל השתתפותו של חניך בפעילות, בכל עת, ומכל\nסיבה שהיא.<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><b><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">&nbsp;</span></b><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><b><u><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">הוראות תשלום</span></u></b><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal">\n\n<span lang="HE" dir="RTL" style="font-size: 14.5pt; line-height: 107%; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">13.&nbsp;הוראת התשלום מבוצעת באתר מאובטח של חברת "קרדיטגארד" (</span><span dir="RTL" style="font-size: 14.5pt; line-height: 107%; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><a href="http://www.creditguard.co.il"><span dir="LTR"><u>www.creditguard.co.il</u></span></a><span dir="RTL"></span><span dir="RTL"></span><span lang="HE"><span dir="RTL"></span><span dir="RTL"></span>)&nbsp;-חברה שהתמחותה בסליקת כרטיסי אשראי וניהול תשלומים\nבאינטרנט ועומדת בתקן&nbsp;</span></span><span style="font-size: 14.5pt; line-height: 107%; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">PCI-DSS<span dir="RTL"></span><span dir="RTL"></span><span lang="HE" dir="RTL"><span dir="RTL"></span><span dir="RTL"></span>&nbsp;לאבטחת מידע של\nכרטיסי אשראי (להלן-"חברת הסליקה"). התנועה שומרת לעצמה את הזכות להחליף\nאת חברת הסליקה, ומתחייבת שכל חברת סליקה שעימה היא תתקשר בהסכם תעמוד בתקן\nהנ"ל או בתקן התקף באותו מועד.</span></span><br></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">14.&nbsp;לאחר מילוי כל פרטי התשלום והעברת הוראת התשלום על ידי\nהמשתמש, חברת הסליקה&nbsp;&nbsp;תעביר את הוראת התשלום לחברת כרטיסי האשראי\nשבאמצעותה מבקש המשתמש לבצע את התשלום (להלן:"חברת\nהאשראי").&nbsp;&nbsp;<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">15.&nbsp;התנועה באמצעות חברת הסליקה, שומרת לעצמה את הזכות שלא\nלקבל&nbsp;&nbsp;הוראת תשלום כלשהי לחברת האשראי בכל אחד מהמקרים הבאים:<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">&nbsp; &nbsp; א.&nbsp;אם יתברר כי קיימת מניעה חוקית או אחרת להעברת\nהוראת התשלום.<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">&nbsp; &nbsp; ב.&nbsp;אם התנועה תהא סבורה כי הוראת התשלום אינה\nברורה במידה מספקת או חסרה פרטי זיהוי או מידע נדרש אחר.<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">16.&nbsp;לאחר העברת הוראת התשלום לחברת האשראי, תישלח למשתמש,\nבאמצעות דואר אלקטרוני, קבלה אלקטרונית.<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">17.&nbsp;למען הסר ספק, יובהר כי חברת האשראי אחראית לביצוע החיוב\nבפועל, וכי התנועה אינה נושאת בכל אחריות או חבות בקשר לכך.<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">&nbsp;<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><b><u><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">&nbsp;ביטול הוראות תשלום והחזרים&nbsp;&nbsp;</span></u></b><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">18.&nbsp;הוראות תשלום באמצעות האתר מחייבות את המשתמש לכל דבר\nועניין.<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">19.&nbsp;ביטול הוראות תשלומים וקבלת החזר כספי מלא או חלקי, יעשו\nבהתאם לנוהל ההחזרים המלא של התנועה המפורסם באתר התנועה בכתובת:&nbsp;<a href="http://noal.me/hechzer"><span lang="EN-US" dir="LTR" style="color:blue"><u>noal.me/hechzer</u></span></a><span dir="RTL"></span><span dir="RTL"></span><span dir="RTL"></span><span dir="RTL"></span>,\nוכפי שיהיה בתוקף מעת לעת.&nbsp;<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">20.&nbsp;לבקשות החזר כספי יש להיכנס להיסטורית התשלומים באתר התשלומים ולבקש בקשת החזר או\nלהתקשר למוקד התמיכה הטכנית בטלפון 03-5125888 הפועל בימים א\'-ה\' בשעות 16:00-22:00 וביום ו\' בשעות 8:00-13:00.&nbsp;<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><br></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><b style="background-color: transparent;"><u><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">הגבלת אחריות</span></u></b><br></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">21.&nbsp;התנועה לא תישא באחריות לנזק, הפסד, לרבות חסרון כיס או\nאבדן רווח, הוצאות או תשלומים העלולים להיגרם, במישרין או בעקיפין, בנסיבות שאין\nלתנועה שליטה עליהן ושהיא לא יכלה לצפותם מראש, ובלבד שנקטה במאמצים סבירים כדי\nלעמוד בהתחייבויותיה, או&nbsp;בשל מעשה או מחדל רשלני של חברת האשראי או ההורה או\nמי מטעמם.<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><b><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">&nbsp;</span></b><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><b><u><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">&nbsp;זכויות באתר</span></u></b><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">22.&nbsp;כל הזכויות לרבות זכויות הקניין הרוחני הקיימות והעתידיות\nבאתר ובתכניו (ובכלל זה - בעיצובו, בשמו, בסימנים המסחריים שבו ובכל תוכנה, יישום,\nקובץ גרפי, טקסטים, קוד מחשב וכל חומר אחר הכלול בו) הינן של התנועה בלבד.<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">22.&nbsp;אין להעתיק, להפיץ, להציג בפומבי, לתרגם או למסור לצד שלישי\nכל חלק מהנ"ל בלא קבלת הסכמת התנועה בכתב ומראש. על אף האמור לעיל, המשתמשים\nבאתר רשאים להדפיס כל מידע מן האתר ולעשות בו שימוש לא מסחרי לצרכיהם\nהאישיים/הארגוניים וכן לשלוח לצדדים שלישיים קישורים לתכני האתר.<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">&nbsp;<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">&nbsp;<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><b><u><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">&nbsp;אבטחת מידע והגנת הפרטיות</span></u></b><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">23.&nbsp;התנועה מתפעלת את האתר באמצעי הגנה והצפנה כמקובל באתרים\nכאמור, ובהתאם לנדרש לפי דין.<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">24.&nbsp;באתר לא יישמר מידע על פרטי כרטיסי האשראי.<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">25.&nbsp;התנועה תאפשר לרכזי הפעילויות השונות, לעקוב אחר סטאטוס\nההרשמות לכל פעילות, על מנת להיערך בצורה ראויה ומתאימה לפעילות.&nbsp;&nbsp;להסרת\nכל ספק, לא יימסרו פרטי כרטיס אשראי.<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">26.&nbsp;מסירת כתובת הדוא"ל של המשתמש מהווה הסכמה מצידו לקבלת\nעדכונים תקופתיים שישלחו על הפעילות והנעשה בתנועה</span><span dir="LTR"></span><span dir="LTR"></span><span dir="LTR" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><span dir="LTR"></span><span dir="LTR"></span>&nbsp;&nbsp; .</span><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">27.&nbsp;מידע שימסור&nbsp;משתמש במסגרת השימוש באתר יישמר בסוד על\nידי התנועה בהתאם להוראות כל דין לרבות חוק הגנת הפרטיות, התשמ"ב-1982.<o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><b><u><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">הדין החל וסמכות שיפוט</span></u></b><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p>\n\n<p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">28.&nbsp;תקנון זה מהווה חוזה בין התנועה לבין המשתמשים וכפוף לדיני\nמדינת ישראל. סמכות השיפוט הייחודית והבלעדית לעניין תקנון זה, נתונה אך ורק לבתי\nהמשפט המוסמכים לכך בעיר תל-אביב בלבד.<o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><span style="background-color: transparent; font-family: &quot;Almoni DL AAA&quot;, sans-serif; font-size: 14.5pt;"><br></span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;mso-margin-bottom-alt:\nauto;line-height:normal"><b style="background-color: transparent;"><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">נרשמתי בהרשמה\nלתנועה,&nbsp; מה זה כולל בעצם?</span></b><br></p></div></div><div><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:18.0pt;\nmso-margin-bottom-alt:auto;line-height:normal">\n\n\n\n</p><p class="MsoNormal" dir="RTL" style="margin: 0cm 54pt 0.0001pt 0cm; line-height: normal; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial;"><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">הרשמה לתנועה כוללת את\nדמי החבר, אירועים, טיולים ומפעלים לאורך השנה, מוצרים שונים כדוגמת:&nbsp;</span><span lang="HE" style="background-color: transparent; font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">חולצת תנועה, מארז גרביים\nתנועתיות, תיק וכדומה. ההרשמה אינה כוללת את מפעלי הקיץ. את תהליך ההכנה ואת המסע\nלפולין (שכבת יא), ואת ההתנסות בבניית תפריט בעליית לתל חי (שכבת ט)</span><span lang="HE" style="background-color: transparent; font-size: 14.5pt; font-family: &quot;Times New Roman&quot;, serif;">.</span></p>\n\n<p class="MsoNormal" dir="RTL" style="margin-bottom: 0.0001pt; line-height: normal; background-image: initial; background-position: initial; background-size: initial; background-repeat: initial; background-attachment: initial; background-origin: initial; background-clip: initial;"><span lang="HE" style="font-size: 14.5pt; font-family: &quot;Times New Roman&quot;, serif;">&nbsp;&nbsp;<o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:18.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><br></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:18.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><b><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">איפה אני רואה את הקבלה על התשלום</span></b><b><span dir="LTR" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">?</span></b><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:54.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">בדרך אליכם בדואר אלקטרוני ממש עכשיו. מיד אחרי התשלום תקבלו אימייל\nעם קישור מאתנו ובקישור תהיה קבלה דיגיטלית תקפה.</span><span dir="LTR" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:18.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><b><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><br></span></b></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:18.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><b><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">אוי, איבדתי את הקישור לקבלה</span></b><span dir="LTR"></span><span dir="LTR"></span><b><span dir="LTR" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><span dir="LTR"></span><span dir="LTR"></span>.</span></b><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:54.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">אין בעיה! תוכל תמיד לראות העתק של הקבלה ב"היסטוריית התשלומים".</span><span dir="LTR" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:18.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><b><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><br></span></b></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:18.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><b><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">שכחתי את הסיסמא שלי לכניסה למוקד ההרשמה... מה\nלעשות</span></b><span dir="LTR"></span><span dir="LTR"></span><b><span dir="LTR" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><span dir="LTR"></span><span dir="LTR"></span>?</span></b><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:54.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">לחץ על "שכחתי סיסמא" בדף הבית, הכנס את כתובת המייל שלך\nוקישור לשינוי סיסמא יישלח אלייך מיידית.</span><span dir="LTR" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:18.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><b><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><br></span></b></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:18.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><b><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">עשיתי טעות – אני צריך עזרה! לאן אני פונה</span></b><span dir="LTR"></span><span dir="LTR"></span><b><span dir="LTR" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><span dir="LTR"></span><span dir="LTR"></span>?</span></b><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:54.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">נשמח לסייע לך ב"<a href="https://harshama.noal.org.il/noal.html?page=hjgdhgfs73AA"><span style="color:blue"><u>צור קשר</u></span></a>".</span><span dir="LTR" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:18.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><b><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><br></span></b></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:18.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><b><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">התחרטתי, אני רוצה לבטל</span></b><span dir="LTR"></span><span dir="LTR"></span><b><span dir="LTR" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><span dir="LTR"></span><span dir="LTR"></span>.</span></b><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:54.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">בהיסטורית התשלומים שלכם, תוכלו למצוא את האירוע עליו את רוצים לבקש\nהחזר ולשלוח לנו טופס עם פרטי הבקשה. כל מה שצריך לעשות זה ללחוץ על כפתור\n"בקשת החזר כספי"&nbsp; - ולמלא את "סיבת ההחזר".</span><span dir="LTR" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:54.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">ניתן גם להתקשר&nbsp;</span><span style="font-family: &quot;Almoni DL AAA&quot;, sans-serif; font-size: 19.3333px; background-color: transparent;">למוקד התמיכה הטכנית בטלפון 03-5125888 הפועל בימים א\'-ה\' בשעות 16:00-22:00 וביום ו\' בשעות 8:00-13:00.</span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:18.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><b><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><br></span></b></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:18.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><b><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">אוף, הייתי חולה ולא יכולתי לצאת, איך מקבלים כאן\nהחזר</span></b><span dir="LTR"></span><span dir="LTR"></span><b><span dir="LTR" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><span dir="LTR"></span><span dir="LTR"></span>?</span></b><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="margin-top:0cm;margin-right:18.0pt;\nmargin-bottom:5.0pt;margin-left:0cm;line-height:normal"><span lang="HE" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;">חבל, ראו סעיף קודם לגבי פנייה למוקד ההחזרים.</span><span dir="LTR" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:18.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><br></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:18.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><b><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">רשמתי יותר מילד אחד לפעילות באותה תקופת זמן, כמה\nהנחת אחים מגיע לי</span></b><span dir="LTR"></span><span dir="LTR"></span><b><span dir="LTR" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><span dir="LTR"></span><span dir="LTR"></span>?</span></b><span dir="LTR" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:54.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">עבור האח/ות השני/יה – 10% עבור התשלום הזול מבין שניהם</span><span dir="LTR" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:54.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">עבור האח/ות השלישי/ת – 20% עבור התשלום הזול מבין שלושתם<o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:54.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">עבור האח/ות הרביעי/ת – 30% עבור התשלום הזול מבין ארבעתם.<o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:54.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">בכל מקרה, הנחות אחים ינתנו עבור אירועים שעלות כל אחד מהם בנפרד היא\nמעל 100 ש"ח<o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="margin-top:0cm;margin-right:18.0pt;\nmargin-bottom:0cm;margin-left:0cm;margin-bottom:.0001pt;line-height:normal"><span dir="LTR" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><br>\n<!--[if !supportLineBreakNewLine]--><br>\n<!--[endif]--></span><span lang="HE" style="font-size:12.0pt;font-family:&quot;Almoni DL AAA&quot;,sans-serif;\nmso-fareast-font-family:&quot;Times New Roman&quot;"><o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:18.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><b><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">הסתבכתי, אני רוצה לדבר עם מישהו אנושי</span></b><span dir="LTR"></span><span dir="LTR"></span><b><span dir="LTR" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><span dir="LTR"></span><span dir="LTR"></span>.</span></b><span dir="LTR" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:54.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">אנחנו ממש משתדלים שהשימוש באתר, יהיה קל, פשוט וזורם לכולם. אם בכל\nזאת אתה מעדיף מענה אנושי תוכל להתקשר&nbsp;</span><span style="font-family: &quot;Almoni DL AAA&quot;, sans-serif; font-size: 19.3333px; background-color: transparent;">למוקד התמיכה הטכנית בטלפון 03-5125888 הפועל בימים א\'-ה\' בשעות 16:00-22:00 וביום ו\' בשעות 8:00-13:00.</span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:18.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><b><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><br></span></b></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:18.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><b><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">כאן זה אתר התנועה? איפה כולם</span></b><span dir="LTR"></span><span dir="LTR"></span><b><span dir="LTR" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><span dir="LTR"></span><span dir="LTR"></span>?</span></b><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:54.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">לא, אתר התנועה נמצא&nbsp;<a href="http://noal.org.il/"><span style="color:blue"><u>כאן</u></span></a>, פה זה אתר התשלומים של תנועת הנוער העובד\nוהלומד.</span><span dir="LTR" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:54.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><br></span></p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:18.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><b><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">וואו, זה ממש מרשים, איפה אפשר להחמיא לכם</span></b><span dir="LTR"></span><span dir="LTR"></span><b><span dir="LTR" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><span dir="LTR"></span><span dir="LTR"></span>?</span></b><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p><p class="MsoNormal" align="center" dir="RTL" style="line-height: normal;">\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n</p><p class="MsoNormal" dir="RTL" style="mso-margin-top-alt:auto;margin-right:54.0pt;\nmso-margin-bottom-alt:auto;line-height:normal"><span lang="HE" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;">תודה, זרוק לנו הערה ב "צור קשר" בתחתית העמוד&nbsp;או ב<a href="http://www.facebook.com/noaroved"><span style="color:blue"><u>דף הפייסבוק</u></span></a>&nbsp;של\nהנוער העובד והלומד. אפשר כמובן גם לתת ביקורת בונה ובכלל.</span><span dir="LTR" style="font-size: 13.5pt; font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p><p class="MsoNormal" dir="RTL"><br></p>\n</div>',
    },
    {
      circle: 0,
      id: 6,
      definitionId: 1,
      name: "עמוד החזרים",
      divId: "refund",
      divText:
        '<p class="MsoNormal" dir="RTL" style="margin-bottom:0cm;margin-bottom:.0001pt;\nline-height:115%;mso-outline-level:2;vertical-align:baseline"><span lang="HE" style="font-size: 22.5pt; line-height: 115%; font-family: &quot;Almoni DL AAA&quot;, sans-serif; letter-spacing: 0.35pt;">מה\nשצריך לדעת על מדיניות ההחזרים<o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="margin-bottom:0cm;margin-bottom:.0001pt;\nline-height:115%;mso-outline-level:2;vertical-align:baseline"><span lang="HE" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;">ידוע ומוסכם, כי קיום הפעילות תלוי בגורמים רבים כדוגמת מספר נרשמים</span><span dir="LTR"></span><span dir="LTR"></span><span dir="LTR" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><span dir="LTR"></span><span dir="LTR"></span>, </span><span lang="HE" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;">מזג האוויר, מצב ביטחוני,\nצדדים שלישיים ושיקולים נוספים. לפיכך, שומרת לעצמה התנועה, את הזכות לשנות ו/או\nלבטל כל פעילות, מכל סיבה שהיא, על פי שיקול דעת התנועה. התנועה רשאית לבצע\nשינויים בתוכנית הפעילות, שינוי מקום הפעילות, מועדיה ו/או תכניה, והדבר לא יהווה\nנימוק לביטול ההרשמה ו/או לדרישה להחזר כספי. נדגיש כי לאור מגפת הקורונה, כל\nהפעילות בתנועה תבוצע בהתאמה להנחיות העדכניות של משרד הבריאות והחינוך/המשרד להשכלה\nגבוהה ומשלימה.<o:p></o:p></span></p><p class="MsoNoSpacing" dir="RTL" style="margin-right:18.0pt;text-align:justify;\ntext-indent:-18.0pt;line-height:130%;mso-list:l0 level1 lfo2"><!--[if !supportLists]--><b><span style="font-family:&quot;Almoni DL AAA&quot;,sans-serif;mso-fareast-font-family:&quot;Almoni DL AAA&quot;">1.<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-weight: normal; font-stretch: normal; font-size: 7pt; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp;</span></span></b><b><span lang="HE" style="font-family:&quot;Almoni DL AAA&quot;,sans-serif">יידוע המדריך/ה/רכז הקן/ סניף&nbsp; בעל-פה או בכתב אינו מהווה אישור לביטול הרשמה.\nרק בקשות שהתקבלו במערכת ייענו, בהתאם לנוהל ההחזרים.<o:p></o:p></span></b></p><p class="MsoNoSpacing" dir="RTL" style="margin-right:18.0pt;text-align:justify;\ntext-indent:-18.0pt;line-height:130%;mso-list:l0 level1 lfo2"><!--[if !supportLists]--><span style="font-family:&quot;Almoni DL AAA&quot;,sans-serif;mso-fareast-font-family:&quot;Almoni DL AAA&quot;">2.<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 7pt; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp;</span></span><span lang="HE" style="font-family:&quot;Almoni DL AAA&quot;,sans-serif">במקרה של ביטול פעילות ע"י\nהתנועה לפני תחילתה, יבוצע החזר מלא, ללא צורך בהגשת בקשה, בניכוי עמלת סליקת\nאשראי של עד 5 ₪, </span><span lang="HE" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;">ככל שהתשלום בוצע בכרטיס\nאשראי.</span><span dir="LTR" style="font-family:&quot;Almoni DL AAA&quot;,sans-serif"><o:p></o:p></span></p><p class="MsoNoSpacing" dir="RTL" style="margin-right:18.0pt;text-align:justify;\ntext-indent:-18.0pt;line-height:130%;mso-list:l0 level1 lfo2"><!--[if !supportLists]--><span style="font-family:&quot;Almoni DL AAA&quot;,sans-serif;mso-fareast-font-family:&quot;Almoni DL AAA&quot;">3.&nbsp;</span><span lang="HE" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;">בקשות החזר כספי יש לפנות לאתר ההרשמה בכתובת&nbsp;</span><span style="font-family:&quot;Almoni DL AAA&quot;,sans-serif"><a href="http://harshama.noal.org.il/"><span dir="LTR" style="mso-fareast-font-family:\n&quot;Times New Roman&quot;;color:#C1272D;border:none windowtext 1.0pt;mso-border-alt:\nnone windowtext 0cm;padding:0cm">harshama.noal.org.il</span></a></span><span dir="LTR" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;">&nbsp;</span><span dir="RTL"></span><span dir="RTL"></span><span style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><span dir="RTL"></span><span dir="RTL"></span> <span lang="HE">ולבחור ב"היסטוריית\nתשלומים". בדף זה יש לבחור את הפעילות המבוקשת ולמלא את טופס בקשת ההחזר על\nפי ההנחיות באתר.</span></span><span lang="HE" style="font-family:&quot;Almoni DL AAA&quot;,sans-serif">\nיש להגיש בקשת החזר עבור כל הפעילויות המופיעות אותן מעוניינים לבטל.</span><span dir="LTR" style="font-family:&quot;Almoni DL AAA&quot;,sans-serif"><o:p></o:p></span></p><p class="MsoNoSpacing" dir="RTL" style="margin-right:18.0pt;line-height:130%"><span lang="HE" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;">למוקד תמיכה טכנית לבקשת החזר באתר: 03-5125888,\nבימים א</span><span lang="HE" style="font-family: Arial, sans-serif;">׳</span><span lang="HE" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;">-ה</span><span lang="HE" style="font-family: Arial, sans-serif;">׳</span><span lang="HE" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;"> בשעות 16:00 עד 22:00 וביום\nו\' בשעות 8:00 עד 13:00</span><span dir="LTR"></span><span dir="LTR"></span><span dir="LTR" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><span dir="LTR"></span><span dir="LTR"></span>.<br>\n</span><span lang="HE" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;">הוראה זו מתייחסת הן לתשלומים שבוצעו באשראי והן\nלתשלומים שבוצעו במזומן.</span><span lang="HE" style="font-family:&quot;Almoni DL AAA&quot;,sans-serif">\n<b>לתשומת לבכם – יידוע המדריכים אינו מהווה בקשת החזר! יש להגיד בקשה באתר ככתוב\nלעיל.</b> זהו תפקידכם, ההורים, להגיש את בקשת ההחזר במערכת.<o:p></o:p></span></p><p class="MsoNoSpacing" dir="RTL" style="margin-right:18.0pt;text-indent:-18.0pt;\nline-height:130%;mso-list:l0 level1 lfo2"><!--[if !supportLists]--><span style="font-family:&quot;Almoni DL AAA&quot;,sans-serif;mso-fareast-font-family:&quot;Almoni DL AAA&quot;">4.&nbsp;</span><span lang="HE" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;">לוחות זמנ</span><span lang="HE" style="font-family:&quot;Almoni DL AAA&quot;,sans-serif">ים\nלאישור קבלת החזר בגין ביטול השתתפות:</span><span dir="LTR" style="font-family:\n&quot;Almoni DL AAA&quot;,sans-serif"><o:p></o:p></span></p><ul style="margin-top:0cm" type="disc">\n <li class="MsoNormal" dir="RTL" style="margin-bottom:0cm;margin-bottom:.0001pt;\n     line-height:115%;mso-list:l1 level1 lfo1;tab-stops:list 36.0pt;vertical-align:\n     baseline"><span lang="HE" style="font-family:&quot;Almoni DL AAA&quot;,sans-serif">ביטול\n     עד 5 ימי עסקים לפני הפעילות מזכה בהחזר מלא באופן אוטומטי, בניכוי עמלת\n     סליקת אשראי של עד 5 ₪.<o:p></o:p></span></li>\n <li class="MsoNormal" dir="RTL" style="margin-bottom:0cm;margin-bottom:.0001pt;\n     line-height:115%;mso-list:l1 level1 lfo1;tab-stops:list 36.0pt;vertical-align:\n     baseline"><span lang="HE" style="font-family:&quot;Almoni DL AAA&quot;,sans-serif">ביטול\n     של 4 עד 3 ימי עסקים לפי הפעילות מזכה בהחזר בגובה 80% באופן אוטומטי.<o:p></o:p></span></li>\n <li class="MsoNormal" dir="RTL" style="margin-bottom:0cm;margin-bottom:.0001pt;\n     line-height:115%;mso-list:l1 level1 lfo1;tab-stops:list 36.0pt;vertical-align:\n     baseline"><span lang="HE" style="font-family:&quot;Almoni DL AAA&quot;,sans-serif">תשומת\n     לבכם- ביטול של פחות מ-3 ימי עסקים מהמועד המתוכנן של הפעילות , לא מזכה\n     בהחזר. במקרים בהם הביטול הוא מסיבות רפואיות, ניתן להגיש בקשה להחזר, אשר\n     תיבחן בהתאם לנסיבות . אם ברצונכם להגיש בקשה להחזר בנסיבות כאמור, עליכם לצרף\n     לבקשה אישור רופא.<o:p></o:p></span></li>\n</ul><p class="MsoListParagraphCxSpFirst" dir="RTL" style="margin-top:0cm;margin-right:\n18.0pt;margin-bottom:0cm;margin-left:0cm;margin-bottom:.0001pt;mso-add-space:\nauto;text-indent:-18.0pt;line-height:115%;mso-list:l0 level1 lfo2;vertical-align:\nbaseline"><!--[if !supportLists]--><span style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;">5.<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 7pt; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp;</span></span><span lang="HE" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;">במקרה שהפסיק החניך את המפעל במהלכו, בין אם משום שהורחק בין אם\nמרצונו החופשי, לא יפוצה בהחזר כספי כלשהו</span><span dir="LTR"></span><span dir="LTR"></span><span dir="LTR" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><span dir="LTR"></span><span dir="LTR"></span>.</span><span lang="HE" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p><p class="MsoListParagraphCxSpMiddle" dir="RTL" style="margin-top:0cm;margin-right:\n18.0pt;margin-bottom:0cm;margin-left:0cm;margin-bottom:.0001pt;mso-add-space:\nauto;text-indent:-18.0pt;line-height:115%;mso-list:l0 level1 lfo2;vertical-align:\nbaseline"><!--[if !supportLists]--><span style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;">6.<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 7pt; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp;</span></span><span lang="HE" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;">לא יהיה שינוי במחיר המפעל עקב שינויים במסלול הטיול, אורכו ו/או תכניתו\nבגין תנאי מזג אויר למעט מקרים קיצוניים ועל פי שיקול הדעת של התנועה</span><span dir="LTR"></span><span dir="LTR"></span><span dir="LTR" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><span dir="LTR"></span><span dir="LTR"></span>.<o:p></o:p></span></p><p class="MsoListParagraphCxSpMiddle" dir="RTL" style="margin-top:0cm;margin-right:\n18.0pt;margin-bottom:0cm;margin-left:0cm;margin-bottom:.0001pt;mso-add-space:\nauto;text-indent:-18.0pt;line-height:115%;mso-list:l0 level1 lfo2;vertical-align:\nbaseline"><!--[if !supportLists]--><span style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;">7.<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 7pt; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp;</span></span><!--[endif]--><span dir="RTL"></span><span lang="HE" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;">בכל מקרה, בקשות להחזר יש להגיש רק עד 7 ימים מתום המפעל, בצירוף כל המסמכים הרלוונטים.</span></p><p class="MsoListParagraphCxSpMiddle" dir="RTL" style="margin-top:0cm;margin-right:\n18.0pt;margin-bottom:0cm;margin-left:0cm;margin-bottom:.0001pt;mso-add-space:\nauto;text-indent:-18.0pt;line-height:115%;mso-list:l0 level1 lfo2;vertical-align:\nbaseline"><!--[if !supportLists]--><span style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;">8.<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 7pt; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp;</span></span><!--[endif]--><span dir="RTL"></span><span lang="HE" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;">בכל מקרה, החזר יינתן רק לאחר סיום הפעילות ולא לפני כן</span><span dir="LTR"></span><span dir="LTR"></span><span dir="LTR" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><span dir="LTR"></span><span dir="LTR"></span>.<o:p></o:p></span></p><p class="MsoListParagraphCxSpMiddle" dir="RTL" style="margin-top:0cm;margin-right:\n18.0pt;margin-bottom:0cm;margin-left:0cm;margin-bottom:.0001pt;mso-add-space:\nauto;text-indent:-18.0pt;line-height:115%;mso-list:l0 level1 lfo2;vertical-align:\nbaseline"><!--[if !supportLists]--><span style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;">9.<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 7pt; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp;</span></span><span lang="HE" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;">בקשות החזר עבור דמי חבר- במקרה של הפסקת פעילות במהלך שנת הפעילות ,\nניתן להגיש בקשה להחזר חלק יחסי מדמי החבר השנתיים. התנועה תשיב את החלק היחסי\nמהתשלום השנתי , כאשר ההחזר יחושב החל מהחודש המלא הראשון הקרוב למועד הגשת הבקשה.\nההחזר יהיה בגין החודשים המלאים שנותרו ממועד הגשת הבקשה ועד סוף שנת הפעילות (סוף\nחודש יוני), ובניכוי עמלת סליקת אשראי של עד 5 ₪, ככל שהתשלום בוצע בכרטיס אשראי. </span><span dir="LTR" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p></o:p></span></p><p class="MsoListParagraphCxSpLast" dir="RTL" style="margin-top:0cm;margin-right:\n18.0pt;margin-bottom:0cm;margin-left:0cm;margin-bottom:.0001pt;mso-add-space:\nauto;text-indent:-18.0pt;line-height:115%;mso-list:l0 level1 lfo2;vertical-align:\nbaseline"><!--[if !supportLists]--><span style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;">10.<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 7pt; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp;</span></span><!--[endif]--><span dir="RTL"></span><span lang="HE" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;">החזר על תשלומים שבוצעו\nבאמצעות כרטיס אשראי יבוצע באמצעות זיכוי חשבון הלקוח. תשלומים שבוצעו במזומן או\nבצ\'ק יבוצעו באמצעות העברה בנקאית לחשבון הורה החניך</span><span dir="LTR"></span><span dir="LTR"></span><span dir="LTR" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><span dir="LTR"></span><span dir="LTR"></span>.<o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="margin-bottom:0cm;margin-bottom:.0001pt;\nline-height:115%;vertical-align:baseline"><span lang="HE" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;"><o:p>&nbsp;</o:p></span></p><p class="MsoNormal" dir="RTL" style="margin-bottom:0cm;margin-bottom:.0001pt;\nline-height:115%;vertical-align:baseline"><span lang="HE" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;">לפניות בנושא תשלומים והחזרים בלבד ניתן לפנות ל: </span><span dir="LTR" style="font-family: &quot;Almoni DL AAA&quot;, sans-serif;">payments.noal@noal.org.il<o:p></o:p></span></p><p class="MsoNormal" dir="RTL" style="line-height:115%"><span dir="LTR" style="font-family:&quot;Almoni DL AAA&quot;,sans-serif"><o:p>&nbsp;</o:p></span></p><p class="MsoNormal" dir="RTL" style="margin-bottom:0cm;margin-bottom:.0001pt;\nline-height:115%;mso-outline-level:2;vertical-align:baseline">\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n</p><p class="MsoNormal" dir="RTL" style="line-height:115%"><span dir="LTR" style="font-family:&quot;Almoni DL AAA&quot;,sans-serif"><o:p>&nbsp;</o:p></span></p>',
    },
    {
      circle: 0,
      id: 10,
      definitionId: 2,
      name: "עמוד הנחות אחים",
      divId: "brothers",
      divText:
        'מדיניות הנחות אחים של התנועה<div><br></div><div>ככל, הנחות האחים ניתנות עבור אחים או אחיות שנרשמו לפעילויות המתקיימות באותה תקופת זמן, ועלות כל אחד מהאירועים בנפרד הינה מעל 100 ש"ח&nbsp;</div><div><br></div><div>על האחים/אחיות להיות מוגדרים במערכת כאחים - זאת ניתן לעשות במסך הנ"ל משמאל ולראות את מצב הבקשה.&nbsp; &nbsp;את הבקשות מאשרות רכזות הקנים</div><div><div><br></div><div>הנחת אחים:</div><div>עבור האח/ות השני/ה - 10% עבור התשלום הזול מבין שניהם</div><div><div>עבור האח/ות השלישי/ת - 20% עבור התשלום הזול מבין שניהם</div></div><div><div>עבור האח/ות הרביעי/ת - 30% עבור התשלום הזול מבין שניהם</div></div><div><br></div></div>',
    },
    {
      circle: 0,
      id: 21,
      definitionId: 4,
      name: "checkout",
      divId: "checkout",
      divText:
        'לתשומת לב!<div><br></div><div>האתר מאפשר תשלום בכל כרטיסי האשראי למעט דיינרס</div><div><br></div><div>ההרשמה באתר מהווה הסכמה&nbsp;<u><a href="http://54.247.127.207:4200/#/questions-answers" target="_blank">לתקנון האתר</a>,</u>&nbsp;<a href="http://noal.me/hechzer" target="_blank"><u>נוהל ההחזרים</u></a>&nbsp;ו<u><a href="https://noal.org.il/%D7%94%D7%A1%D7%9B%D7%9D-%D7%94%D7%91%D7%A0%D7%95%D7%AA-%D7%A2%D7%9D-%D7%94%D7%94%D7%95%D7%A8%D7%99%D7%9D/" target="_blank">הסכם ההבנות עם ההורים</a></u></div><div><br></div><div>ניתן לפנות למוקד התמיכה הטכנית שלנו בטלפון 03-5125888 בימים א\'-ה\' בשעות 16:00-22:00 או ביום ו\' בשעות 08:00-13:00</div>',
    },
    {
      circle: 0,
      id: 22,
      definitionId: 5,
      name: "הודעה עליונה תשלומים",
      divId: "upperPayment",
      divText:
        'אני מאשר/ת שקראתי את&nbsp;<a href="https://noal.org.il/%D7%A0%D7%94%D7%9C%D7%99-%D7%A4%D7%A8%D7%A1%D7%95%D7%9D-%D7%AA%D7%9E%D7%95%D7%A0%D7%95%D7%AA-%D7%91%D7%AA%D7%A7%D7%A9%D7%95%D7%A8%D7%AA-%D7%91%D7%A7%D7%9E%D7%A4%D7%99%D7%99%D7%9F-%D7%A4%D7%A8%D7%A1/" target="_blank"><u>נוהל פרסום תמונות ברשתות החברתיות ובתקשורת</u></a>.<br><a href="https://harshama.noal.org.il/www.noal.org.il" target="_blank"><span style="background-color: rgb(255, 255, 255);">ל</span></a><a href="https://noal.org.il" target="_blank"><u>אתר התנועה</u></a>&nbsp;ל<a href="https://www.facebook.com/noal4u" target="_blank" style="background-color: rgb(255, 255, 255);"><u>דף הפייסבוק שלנו</u></a><br>',
    },
    {
      circle: 0,
      id: 23,
      definitionId: 6,
      name: "הודעה תחתונה תשלומים",
      divId: "lowerPayment",
      divText:
        "אני מאשר/ת את כלל הפרטים, את ההשתתפות בפעילות ובמידת הצורך, לאפשר לחובשים לסייע במתן תרופות שאינן מצריכות מרשם רופא.<br>",
    },
    {
      circle: 0,
      id: 27,
      definitionId: 7,
      name: "כותרת תרומה",
      divId: "contributionTitle",
      divText: "קרן השיוויון",
    },
    {
      circle: 0,
      id: 28,
      definitionId: 8,
      name: "תוכן תרומה",
      divId: "contributionText",
      divText:
        "באמצעות תרומתך, קרן השיוויון תסייע לחניכים שידם אינם משגת להשתתף בפעילות התנועה כשווים.",
    },
    {
      circle: 0,
      id: 36,
      definitionId: 9,
      name: "הודעה למשתמש",
      divId: "popup",
      divText: "הי מה קורה",
    },
  ],
  user: {
    token: 7078,
    name: "רכז דמה מעגל דמה",
    role: "ADMIN",
    type: 900,
  },
};



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/parent-events-mocks/global.api.mock.ts